var zde = zde || {}; zde["modules"] = zde["modules"] || {}; zde["modules"]["shop_catalog"] =
webpackJsonpzde_modules__name_([9],{

/***/ "0iPh":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ "1QSW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1zW/":
/***/ (function(module, exports) {

module.exports = "<div class=\"subcategory-list-wrap\" data-bind=\"visible: list.groupedItems.length > 0 || list.category.popularShops.length > 0\">\n\t<div data-bind=\"foreach: list.groupedItems\">\n\t\t<div class=\"title\" data-bind=\"text: group.title\"></div>\n\t\t<ul class=\"subcategory-list subcategory-popular\" data-bind=\"foreach: items\">\n\t\t\t<li class=\"subcategory-item\" data-bind=\"click: $parents[1].list.handleClick\">\n\t\t\t\t<a data-bind=\"attr: {href: url}\">\n\t\t\t\t\t<span class=\"item-name\" data-bind=\"text: title\"></span>\n\t\t\t\t\t<span class=\"parametric-counter\" data-bind=\"numeral: {value: count, format: '0 a', titleFormat: '0,0'}\"></span>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\n\t<!-- ko with: list.category -->\n\t<div data-bind=\"visible: popularShops.length > 0\">\n\t\t<div class=\"title\" data-bind=\"lang: 'shop_filter_popular_shops'\"></div>\n\t\t<div class=\"popular-shops-list\" data-bind=\"foreach: popularShops\">\n\t\t\t<a class=\"popular-shops-item\" data-bind=\"attr: {href: url, title: title}, click: $parents[1].list.handleClick\">\n\t\t\t\t<img data-bind=\"attr: {src: logo}\"/>\n\t\t\t</a>\n\t\t</div>\n\t</div>\n\t<!-- /ko -->\n</div>\n\n<div class=\"subcategory-list-wrap\" data-bind=\"with: list\">\n\t<div class=\"title\" data-bind=\"visible: groupedItems.length > 0, lang: 'shop_filter_all_subcategories'\"></div>\n\t<ul class=\"subcategory-list\" data-bind=\"foreach: visibleItems\">\n\t\t<li class=\"subcategory-item\" data-bind=\"click: $parent.handleClick\">\n\t\t\t<a data-bind=\"attr: {href: url}\">\n\t\t\t\t<span class=\"item-name\" data-bind=\"text: title\"></span>\n\t\t\t\t<span class=\"parametric-counter\" data-bind=\"numeral: {value: count, format: '0 a', titleFormat: '0,0'}\"></span>\n\t\t\t</a>\n\t\t</li>\n\t</ul>\n</div>"

/***/ }),

/***/ "1zZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductItem; });
/* unused harmony export Offer */
/* unused harmony export Shop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lists__ = __webpack_require__("7DQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings__ = __webpack_require__("WISg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data__ = __webpack_require__("m9tG");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ProductList = function (_BaseList) {
	_inherits(ProductList, _BaseList);

	/**
  * @param {Settings} settings
  */
	function ProductList(settings) {
		_classCallCheck(this, ProductList);

		var _this = _possibleConstructorReturn(this, (ProductList.__proto__ || Object.getPrototypeOf(ProductList)).call(this, { name: 'products', settings: settings }));

		_this._favorites = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable([]);


		_this._favoritesHash = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.pureComputed(function () {
			var hash = {};
			_this._favorites().forEach(function (id) {
				return hash[id] = true;
			});
			return hash;
		});
		return _this;
	}

	_createClass(ProductList, [{
		key: "initData",
		value: function initData(data) {
			if (__WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.isArray(data['favorites'])) {
				this._favorites(data['favorites']);

				if (__WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.isArray(data['items']) && this._favorites().length > 0) {
					// inject "favorite" flag
					var favoritesHash = this._favoritesHash();
					var newItems = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(data['items'], function (item) {
						return _extends({}, item, {
							favorite: favoritesHash[item.id]
						});
					});
					data = _extends({}, data, {
						items: newItems
					});
				}
			}
			if (__WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].debug && __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.isObject(data['scores']) && __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.isArray(data['items'])) {
				var _newItems = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(data['items'], function (item) {
					return _extends({}, item, {
						score: data['scores'][item['id']]
					});
				});
				data = _extends({}, data, {
					items: _newItems
				});
			}
			_get(ProductList.prototype.__proto__ || Object.getPrototypeOf(ProductList.prototype), "initData", this).call(this, data);
		}
	}, {
		key: "newItem",
		value: function newItem(itemData) {
			return new ProductItem(itemData, this.settings);
		}
	}]);

	return ProductList;
}(__WEBPACK_IMPORTED_MODULE_2__lists__["a" /* BaseList */]);

var ProductItem = function () {
	/**
  * @param {object} data
  * @param {Settings} settings
  */
	function ProductItem(data, settings) {
		_classCallCheck(this, ProductItem);

		this.id = data.id;
		this.title = data.title;
		this.url = settings.getProductUrl(data.uri);
		this.images = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(data.images, function (img) {
			return settings.getImageUrl(img);
		});
		this.previews = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(data.previews, function (img) {
			return settings.getPreviewImgageUrl(img);
		});
		this.previewImage = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.first(this.previews);
		this.orderUrl = __WEBPACK_IMPORTED_MODULE_4__core_utils_url__["g" /* siteUrl */]('create_order?productId=' + this.id);
		this.updateDate = new Date(data['updateTime']);
		this.offersCount = data.offersCount;
		this.bestOffer = new Offer(data.bestOffer);
		this.price = settings.convertPrice(data.price);
		this.priceOld = settings.convertPrice(data.oldPrice);
		this.discount = data.discount;
		this.score = data.score;

		if (settings.useOfferUrl) {
			this.url = this.bestOffer.url;
		}

		this._favorite = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable(!!data.favorite);
	}

	_createClass(ProductItem, [{
		key: "showImages",
		value: function showImages() {
			if (this.hasImages) {
				$.fancybox.open(__WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(this.images, function (img) {
					return {
						type: 'image',
						src: img
					};
				}));
			}
		}
	}, {
		key: "showDebugInfo",
		value: function showDebugInfo() {
			if (__WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].debug && this.score) {
				__WEBPACK_IMPORTED_MODULE_5__data__["a" /* debugInfo */].show('product', this.id);
			}
		}
	}, {
		key: "isFavorite",
		get: function get() {
			return this._favorite();
		}
	}, {
		key: "hasImages",
		get: function get() {
			return this.images.length > 0;
		}
	}]);

	return ProductItem;
}();

var Offer = function Offer(data) {
	_classCallCheck(this, Offer);

	this.id = data.id;
	this.name = data.name;
	this.price = __WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].convertPrice(data.price);
	this.oldPrice = __WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].convertPrice(data.oldPrice);
	this.discount = data.discount;
	this.shop = new Shop(data.shop);
	this.url = __WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].getOfferUrl(data.id);
};

var Shop = function Shop(data) {
	_classCallCheck(this, Shop);

	this.id = data.id;
	this.title = data.title;
	this.url = __WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].getShopUrl(data.shopSlug);
};

/***/ }),

/***/ "2jcB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2uje":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_toastr__ = __webpack_require__("og09");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("YnTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_var__ = __webpack_require__("dTkA");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var t = Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* checkIsIframe */])() ? window.top.toastr : __WEBPACK_IMPORTED_MODULE_0_lib_toastr___default.a;

var MSG_ERROR = 'Ошибка';
var MSG_ERROR_XHR = 'Не удалось выполнить запрос';

var Notifier = function () {
	function Notifier() {
		_classCallCheck(this, Notifier);
	}

	_createClass(Notifier, null, [{
		key: "error",
		value: function error() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			// Extend timeout for errors to 10 seconds by default
			var timeOut = options ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_var__["g" /* orDefault */])(options.timeOut, 10000) : 10000;
			t.error(Object(__WEBPACK_IMPORTED_MODULE_2__utils_var__["g" /* orDefault */])(message, MSG_ERROR), title, _extends({ timeOut: timeOut }, options));
		}
	}, {
		key: "errorXHR",
		value: function errorXHR(jqXHR, textStatus, errorThrown) {
			if (textStatus != 'abort') {
				Notifier.error(MSG_ERROR_XHR);
			}
		}
	}, {
		key: "info",
		value: function info(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.info(message, title, _extends({}, options));
		}
	}, {
		key: "success",
		value: function success(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.success(message, title, _extends({}, options));
		}
	}, {
		key: "warning",
		value: function warning(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.warning(message, title, _extends({}, options));
		}
	}]);

	return Notifier;
}();

/***/ }),

/***/ "5wqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newLogger;
/* unused harmony export setDefaultLevel */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LEVEL_DEBUG = 0;
var LEVEL_INFO = 1;
var LEVEL_WARN = 2;
var LEVEL_ERROR = 3;

var LEVELS = ['debug', 'info', 'warn', 'error'];

var defaultLevel = window.IS_PRODUCTION ? LEVEL_WARN : LEVEL_DEBUG;

/**
 * Creates new logger instance with default level.
 * @param {string|null} name
 * @return {MyLogger}
 */
function newLogger() {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	return new MyLogger(name, defaultLevel);
}

/**
 * Sets level for new loggers.
 * @param {number} level
 */
function setDefaultLevel(level) {
	defaultLevel = level;
}

var MyLogger = function () {
	function MyLogger(name, level) {
		_classCallCheck(this, MyLogger);

		this._name = '';
		this._level = -1;

		this._dummy = function () {};

		this._name = name;
		this.setLevel(level);
	}

	_createClass(MyLogger, [{
		key: 'setLevel',
		value: function setLevel(level) {
			var _this = this;

			level = Number.isInteger(level) ? level : LEVELS.indexOf(level);
			this._level = level;

			var name = this._name ? '[' + this._name + ']' : null;
			var bind = function bind(condition, methodName) {
				if (!condition || !console[methodName]) return _this._dummy;
				return name ? console[methodName].bind(console, name) : console[methodName].bind(console);
			};
			var bindSimple = function bindSimple(condition, methodName) {
				return condition && console[methodName] ? console[methodName].bind(console) : _this._dummy;
			};

			[['log', LEVEL_DEBUG], ['info', LEVEL_INFO], ['warn', LEVEL_WARN], ['error', LEVEL_ERROR]].forEach(function (i) {
				var _i = _slicedToArray(i, 2),
				    method = _i[0],
				    lvl = _i[1];

				_this[method] = bind(level <= lvl, method);
			});

			['time', 'timeEnd', 'profile', 'profileEnd'].forEach(function (method) {
				_this[method] = bindSimple(level <= LEVEL_DEBUG, method);
			});
		}

		/** The same as {@link Console.log} */

	}, {
		key: 'log',
		value: function log(args) {}

		/** The same as {@link Console.info} */

	}, {
		key: 'info',
		value: function info(args) {}

		/** The same as {@link Console.warn} */

	}, {
		key: 'warn',
		value: function warn(args) {}

		/** The same as {@link Console.error} */

	}, {
		key: 'error',
		value: function error(args) {}

		/** The same as {@link Console.time} */

	}, {
		key: 'time',
		value: function time(label) {}

		/** The same as {@link Console.timeEnd} */

	}, {
		key: 'timeEnd',
		value: function timeEnd(label) {}

		/** The same as {@link Console.profile} */

	}, {
		key: 'profile',
		value: function profile(label) {}

		/** The same as {@link Console.profileEnd} */

	}, {
		key: 'profileEnd',
		value: function profileEnd(label) {}
	}, {
		key: 'measureTime',
		value: function measureTime(label, callable) {
			this.time(label);
			var result = callable();
			this.timeEnd(label);
			return result;
		}
	}, {
		key: 'doProfile',
		value: function doProfile(label, callable) {
			this.profile(label);
			var result = callable();
			this.profileEnd(label);
			return result;
		}
	}, {
		key: 'setLevelDebug',
		value: function setLevelDebug() {
			this.setLevel(LEVEL_DEBUG);
		}
	}, {
		key: 'setLevelInfo',
		value: function setLevelInfo() {
			this.setLevel(LEVEL_INFO);
		}
	}, {
		key: 'setLevelWarn',
		value: function setLevelWarn() {
			this.setLevel(LEVEL_WARN);
		}
	}, {
		key: 'setLevelError',
		value: function setLevelError() {
			this.setLevel(LEVEL_ERROR);
		}
	}]);

	return MyLogger;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (newLogger());

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("2jcB");
module.exports = __webpack_require__("KRdv");


/***/ }),

/***/ "7DQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return List; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_var__ = __webpack_require__("dTkA");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






/**
 * Base implementation of list that holds items of type {@link ListItem}
 */
var BaseList = function () {
	function BaseList() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		_classCallCheck(this, BaseList);

		this._id = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable('');
		this._name = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable('');
		this._title = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable('');
		this._total = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(0);
		this._items = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable([]);
		this._settings = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable();
		this._indexById = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable({});
		this._indexByName = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable({});
		this._onItemClick = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();

		this._id(data ? data.id : '');
		this._name(data ? data.name : '');
		this._title(data ? data.title : '');
		this._total(data ? data.total : 0);
		this._settings(data ? data.settings : null);

		// fix context for methods that are used in knockout bindings
		this.handleClick = this.handleClick.bind(this);
	}

	// computed

	// fields


	_createClass(BaseList, [{
		key: "init",


		/**
   * Initializes the list with new data
   * @param {Object|Object[]} data
   */
		value: function init(data) {
			if (__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isArray(data)) {
				this.initItems(data);
			} else if (__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isObject(data)) {
				this.initData(data);
			}
		}

		/**
   * Initializes list properties
   * @param {Object} data
   */

	}, {
		key: "initData",
		value: function initData(data) {
			if (!__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isUndefined(data['id'])) {
				this._id(data['id']);
			}
			if (!__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isUndefined(data['name'])) {
				this._name(data['name']);
			}
			if (!__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isUndefined(data['title'])) {
				this._title(data['title']);
			}
			if (!__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isUndefined(data['total'])) {
				this._total(data['total']);
			}
			if (!__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isUndefined(data['settings'])) {
				this._settings(data['settings']);
			}
			if (__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isArray(data['items'])) {
				this.initItems(data['items']);
			}
		}

		/**
   * Initializes list items
   * @param {Object[]} itemsData
   */

	}, {
		key: "initItems",
		value: function initItems(itemsData) {
			var items = itemsData ? __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.map(itemsData, this.newItem, this) : [];
			var indexById = itemsData ? __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.indexBy(items, 'id') : {};
			var indexByName = itemsData ? __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.indexBy(items, 'name') : {};
			this._items(items);
			this._indexById(indexById);
			this._indexByName(indexByName);
		}

		/**
   * Creates ListItem from given data
   * @param {Object} itemData
   * @return {ListItem}
   */

	}, {
		key: "newItem",
		value: function newItem(itemData) {
			return new ListItem(itemData);
		}

		/**
   * @param {number} id
   * @return {ListItem}
   */

	}, {
		key: "getItem",
		value: function getItem(id) {
			return this._indexById()[id];
		}

		/**
   * @param {string} name
   * @return {ListItem}
   */

	}, {
		key: "getItemByName",
		value: function getItemByName(name) {
			return this._indexByName()[name];
		}

		/**
   * Add event handler for item click
   * @param {Function} callback
   */

	}, {
		key: "onItemClick",
		value: function onItemClick(callback) {
			this._onItemClick.add(callback);
		}

		/**
   * @param {ListItem} item
   */

	}, {
		key: "handleClick",
		value: function handleClick(item) {
			this._onItemClick.fire(item);
		}
	}, {
		key: "id",
		get: function get() {
			return this._id();
		}
	}, {
		key: "name",
		get: function get() {
			return this._name();
		}
	}, {
		key: "title",
		get: function get() {
			return this._title();
		}

		/** @return {ListItem[]} */

	}, {
		key: "items",
		get: function get() {
			return this._items();
		}

		/** @return {number} */

	}, {
		key: "size",
		get: function get() {
			return this.items.length;
		}

		/** @return {boolean} */

	}, {
		key: "empty",
		get: function get() {
			return this.size == 0;
		}

		/** @return {number} */

	}, {
		key: "total",
		get: function get() {
			return this._total();
		}

		/** @type {Settings} */

	}, {
		key: "settings",
		get: function get() {
			return this._settings();
		}
	}]);

	return BaseList;
}();

/**
 * Implementation of BaseList that supports sorting and filtering
 */
var List = function (_BaseList) {
	_inherits(List, _BaseList);

	// options
	function List() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		_classCallCheck(this, List);

		var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, data));

		_this._sortItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(true);
		_this._filterItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(true);


		_this._selectedItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			var items = __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.filter(_this.items, function (item) {
				return item.selected;
			});
			return __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.sortBy(items, function (item) {
				return item.selected;
			});
		});
		_this._unselectedItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.filter(_this.items, function (item) {
				return !item.selected;
			});
		});
		_this._sortedItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return _this.sortItems ? [].concat(_toConsumableArray(_this.sortSource)).sort(_this.sortFunction.bind(_this)) : _this.sortSource;
		});
		_this._filteredItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return _this.filterItems ? __WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.filter(_this.filterSource, function (item) {
				return _this.filterPredicate(item);
			}) : _this.filterSource;
		});

		/*
  visibleItems <- _sortedItems <- _filteredItems <- items
   */
		return _this;
	}

	/** @type {boolean} */


	_createClass(List, [{
		key: "sortFunction",


		/**
   * @param {ListItem} item1
   * @param {ListItem} item2
   * @return {number}
   */
		value: function sortFunction(item1, item2) {
			// by count descending
			return item2.count - item1.count;
		}

		/**
   * @param {ListItem} item
   * @return {boolean}
   */

	}, {
		key: "filterPredicate",
		value: function filterPredicate(item) {
			// hide empty items
			return item.count > 0;
		}

		/**
   * These items should be shown to user
   * @return {ListItem[]}
   */

	}, {
		key: "updateCounts",
		value: function updateCounts(data) {
			__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.each(this.items, function (item) {
				var d = data ? data[item.id] : null;
				item.count = Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_var__["c" /* asNumber */])(__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.isObject(d) ? d.count : d);
			});
		}
	}, {
		key: "resetCounts",
		value: function resetCounts() {
			__WEBPACK_IMPORTED_MODULE_2_lib_underscore___default.a.each(this.items, function (item) {
				return item.count = 0;
			});
		}
	}, {
		key: "sortItems",
		get: function get() {
			return this._sortItems();
		}

		/** @param {boolean} value */
		,
		set: function set(value) {
			this._sortItems(value);
		}

		/** @type {boolean} */

	}, {
		key: "filterItems",
		get: function get() {
			return this._filterItems();
		}

		/** @param {boolean} value */
		,
		set: function set(value) {
			this._filterItems(value);
		}

		/**
   * @return {ListItem[]}
   */

	}, {
		key: "selectedItems",
		get: function get() {
			return this._selectedItems();
		}

		/**
   * @return {ListItem[]}
   */

	}, {
		key: "unselectedItems",
		get: function get() {
			return this._unselectedItems();
		}

		/**
   * @return {ListItem[]}
   */

	}, {
		key: "sortSource",
		get: function get() {
			return this._filteredItems();
		}

		/**
   * @return {ListItem[]}
   */

	}, {
		key: "filterSource",
		get: function get() {
			return this.items;
		}
	}, {
		key: "visibleItems",
		get: function get() {
			return this._sortedItems();
		}

		/**
   * @return {number}
   */

	}, {
		key: "visibleCount",
		get: function get() {
			return this.visibleItems.length;
		}

		/**
   * @return {number}
   */

	}, {
		key: "hiddenCount",
		get: function get() {
			return this.items.length - this.visibleItems.length;
		}

		/**
   * @return {boolean}
   */

	}, {
		key: "hasVisibleItems",
		get: function get() {
			return this.visibleItems.length > 0;
		}
	}, {
		key: "size",
		get: function get() {
			return this.visibleItems.length;
		}
	}]);

	return List;
}(BaseList);

/**
 * Base implementation of list item for {@link List} class.
 * All input data can be observables to track changes.
 */
var ListItem = function () {
	function ListItem(data) {
		_classCallCheck(this, ListItem);

		this._count = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(0);

		this._data = _extends({}, data);
		this._count(Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_var__["c" /* asNumber */])(data.count));
	}

	_createClass(ListItem, [{
		key: "id",
		get: function get() {
			return +this._data.id;
		}
	}, {
		key: "name",
		get: function get() {
			return '' + this._data.name;
		}
	}, {
		key: "title",
		get: function get() {
			return '' + this._data.title;
		}
	}, {
		key: "count",
		get: function get() {
			return this._count();
		},
		set: function set(value) {
			this._count(Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_var__["c" /* asNumber */])(value));
		}
	}, {
		key: "selected",
		get: function get() {
			return !!this._data.selected;
		}
	}, {
		key: "disabled",
		get: function get() {
			return !!this._data.disabled;
		}
	}, {
		key: "empty",
		get: function get() {
			return this.count == 0;
		}
	}]);

	return ListItem;
}();

/***/ }),

/***/ "7fPx":
/***/ (function(module, exports) {

module.exports = ko;

/***/ }),

/***/ "BY5J":
/***/ (function(module, exports) {

module.exports = "<select data-bind=\"value: filter.value,\n\t\t\t\t\toptions: filter.visibleOptions,\n\t\t\t\t\toptionsValue: 'key',\n\t\t\t\t\toptionsText: 'title',\n\t\t\t\t\toptionsCaption: filter.caption\">\n</select>"

/***/ }),

/***/ "EFDg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Query; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("T9V6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__var__ = __webpack_require__("dTkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger__ = __webpack_require__("5wqq");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var logger = __WEBPACK_IMPORTED_MODULE_4__logger__["a" /* newLogger */]('Query');

var Query = function () {

	/**
  * @param {Router} router
  */
	function Query(router) {
		var _this = this;

		_classCallCheck(this, Query);

		this._router = null;
		this._queryData = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable({});
		this._defaults = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable({});
		this._lastChange = {};
		this.delimiter = '-';

		this._router = router;
		router.onInitialize(function (navData) {
			_this._onRouterChange(navData);

			_this._queryData.subscribe(function (queryData) {
				var url = _this._constructUrl(queryData);
				var lastChange = _this._lastChange;
				_this._router.navigate(url, { lastChange: lastChange });
			});
		});
		router.onNavigate(this._onRouterChange.bind(this));
	}

	_createClass(Query, [{
		key: 'onChange',
		value: function onChange(callback) {
			this._queryData.subscribe(callback);
		}
	}, {
		key: 'setDefaults',
		value: function setDefaults(defaults) {
			var newValue = __WEBPACK_IMPORTED_MODULE_1_lib_underscore__["extend"]({}, this._defaults(), this._toString(defaults));
			this._defaults(newValue);
		}
	}, {
		key: 'getQuery',
		value: function getQuery() {
			return this._queryData();
		}
	}, {
		key: 'getQueryParam',
		value: function getQueryParam(key, defaultValue) {
			var value = this._queryData()[key];
			if (value) {
				return value;
			} else if (defaultValue !== undefined) {
				return defaultValue;
			} else if (this._defaults()[key] !== undefined) {
				return this._defaults()[key];
			} else {
				return '';
			}
		}
	}, {
		key: 'getQueryParamAsArray',
		value: function getQueryParamAsArray(key) {
			var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

			return Object(__WEBPACK_IMPORTED_MODULE_3__var__["a" /* asArray */])(this.getQueryParam(key, defaultValue), this.delimiter);
		}
	}, {
		key: 'setQuery',
		value: function setQuery(params, reset) {
			this._setQueryData(params, reset);
		}
	}, {
		key: 'setQueryParam',
		value: function setQueryParam(key, value, reset) {
			this.setQuery(_defineProperty({}, key, value), reset);
		}
	}, {
		key: 'getLastSetKeys',
		value: function getLastSetKeys() {
			return this._lastChange;
		}
	}, {
		key: '_toString',
		value: function _toString(val) {
			var _this2 = this;

			if (__WEBPACK_IMPORTED_MODULE_1_lib_underscore__["isArray"](val)) {
				val = __WEBPACK_IMPORTED_MODULE_1_lib_underscore__["map"](val, function (v) {
					return _this2._toString(v);
				});
				val = __WEBPACK_IMPORTED_MODULE_1_lib_underscore__["filter"](val, function (v) {
					return !!v;
				});
			} else if (__WEBPACK_IMPORTED_MODULE_1_lib_underscore__["isObject"](val)) {
				val = __WEBPACK_IMPORTED_MODULE_1_lib_underscore__["mapObject"](val, function (v) {
					return _this2._toString(v);
				});
				val = __WEBPACK_IMPORTED_MODULE_1_lib_underscore__["pick"](val, function (v) {
					return !!v;
				});
			} else if (val === true) {
				val = '1';
			} else if (val === false) {
				val = '0';
			} else if (val) {
				val = '' + val;
			} else {
				val = null;
			}
			return val;
		}
	}, {
		key: 'generateUrl',
		value: function generateUrl(params, reset) {
			var data = this._newQueryData(params, reset);
			return this._router.baseUrl + this._constructUrl(data);
		}
	}, {
		key: 'addValue',
		value: function addValue(key, value) {
			this.setQuery(_defineProperty({}, key, this.getQueryParamAsArray(key).concat(value)));
		}
	}, {
		key: 'toggleValue',
		value: function toggleValue(key, value) {
			value = "" + value;
			var selected = [].concat(_toConsumableArray(this.getQueryParamAsArray(key)));
			if (selected.indexOf(value) >= 0) {
				__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.utils.arrayRemoveItem(selected, value);
			} else {
				selected.push(value);
			}
			this.setQuery(_defineProperty({}, key, selected));
		}
	}, {
		key: 'removeValue',
		value: function removeValue(key, value) {
			var selected = [].concat(_toConsumableArray(this.getQueryParamAsArray(key)));
			__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.utils.arrayRemoveItem(selected, value);
			this.setQuery(_defineProperty({}, key, selected));
		}
	}, {
		key: 'resetQuery',
		value: function resetQuery() {
			this.setQuery({}, true);
		}
	}, {
		key: '_setQueryData',
		value: function _setQueryData(params) {
			var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			this._lastChange = reset ? {} : _extends({}, params);
			var data = this._newQueryData(params, reset);
			if (!__WEBPACK_IMPORTED_MODULE_1_lib_underscore__["isEqual"](this._queryData(), data)) {
				logger.log('set query:', data);
				this._queryData(data);
				return true;
			}
			return false;
		}
	}, {
		key: '_newQueryData',
		value: function _newQueryData(params) {
			var _this3 = this;

			var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var data = reset ? _extends({}, params) : _extends({}, this._queryData(), params);
			data = this._toString(data);
			data = __WEBPACK_IMPORTED_MODULE_1_lib_underscore__["pick"](data, function (v, k) {
				return v !== _this3._defaults()[k];
			});
			return data;
		}
	}, {
		key: '_onRouterChange',
		value: function _onRouterChange(navData) {
			var params = _extends({}, navData.params, navData.queryData);
			this._setQueryData(params, true);
		}

		/**
   *
   * @param {object} selection
   * @return {NavUrl}
   */

	}, {
		key: '_constructUrl',
		value: function _constructUrl(selection) {
			var _this4 = this;

			// convert array values into delimited strings
			var p = __WEBPACK_IMPORTED_MODULE_1_lib_underscore__["mapObject"](selection, function (val) {
				if (__WEBPACK_IMPORTED_MODULE_1_lib_underscore__["isArray"](val)) {
					return __WEBPACK_IMPORTED_MODULE_1_lib_underscore__["map"](val, function (v) {
						return v;
					}).join(_this4.delimiter);
				} else {
					return val;
				}
			});
			return new __WEBPACK_IMPORTED_MODULE_2__router__["a" /* NavUrl */]('', p);
		}
	}]);

	return Query;
}();

/***/ }),

/***/ "ER90":
/***/ (function(module, exports) {

module.exports = "<catalog-sidebar class=\"layout-sidebar\" params=\"sidebar: sidebar\"></catalog-sidebar>\n\n<section class=\"layout-content\">\n\t<h2 class=\"layout-title\" data-bind=\"component: {name: 'catalog-title', params: {model: $data}}\"></h2>\n\n\t<!-- ko if: settings.isAdmin -->\n\t<span class=\"btn-toggle-admin-panel\" title=\"Показать/скрыть админ панель\" data-bind=\"click: adminPanel.toggleVisibleState\"></span>\n\t<admin-panel params=\"model: adminPanel\" data-bind=\"visible: adminPanel.isVisible\" style=\"display: none\"></admin-panel>\n\t<!-- /ko -->\n\n\t<selection-items params=\"model: selection, showReset: true\" data-bind=\"visible: !selection.isEmpty\"></selection-items>\n\n\t<view-options class=\"view-options-top\" params=\"model: viewOptions\"></view-options>\n\n\t<product-list params=\"list: products\"></product-list>\n\n\t<view-options class=\"view-options-bottom\" params=\"model: viewOptions, showPageInfo: false, showPagination: true, showSorting: false\"\n\t\t\t\t  data-bind=\"visible: viewOptions.pagination.pagesCount() > 1\"></view-options>\n</section>\n"

/***/ }),

/***/ "EfVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DebugInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_modal__ = __webpack_require__("rItL");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var DebugInfo = function () {
	function DebugInfo() {
		_classCallCheck(this, DebugInfo);

		this._searchCriteria = '';
	}

	_createClass(DebugInfo, [{
		key: 'getSearchCriteria',
		value: function getSearchCriteria() {
			return this._searchCriteria;
		}
	}, {
		key: 'setSearchCriteria',
		value: function setSearchCriteria(criteria) {
			this._searchCriteria = criteria;
		}
	}, {
		key: 'show',
		value: function show(itemType, itemId) {
			if (!this._searchCriteria) {
				return;
			}
			Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_modal__["a" /* showModalIframe */])('shop_search_debug', {
				criteria: this._searchCriteria,
				item_type: itemType,
				item_id: itemId
			});
		}
	}]);

	return DebugInfo;
}();

/***/ }),

/***/ "FBgD":
/***/ (function(module, exports) {

module.exports = "<ul class=\"tags-list\" data-bind=\"\">\n\t<!-- ko foreach: items -->\n\t<li class=\"tag\" data-bind=\"click: $parent.selection.handleClick, attr: {title: zde.lang('shop_filter_btn_cancel')}\">\n\t\t<span data-bind=\"text: title\"></span>\n\t\t<i class=\"icon--delete\"></i>\n\t</li>\n\t<!-- /ko -->\n\n\t<!-- ko if: showReset -->\n\t<li class=\"tag tag-reset\" data-bind=\"click: selection.reset, attr: {title: zde.lang('shop_filter_btn_cancel_all')}\">\n\t\t<span data-bind=\"lang: 'btn_reset'\"></span>\n\t</li>\n\t<!-- /ko -->\n</ul>"

/***/ }),

/***/ "FYi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_URL; });
/* harmony export (immutable) */ __webpack_exports__["g"] = siteUrl;
/* harmony export (immutable) */ __webpack_exports__["f"] = joinPath;
/* harmony export (immutable) */ __webpack_exports__["e"] = isAbsolute;
/* unused harmony export buildQuery */
/* harmony export (immutable) */ __webpack_exports__["d"] = highlightUrls;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UrlParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UrlBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__("XRua");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__var__ = __webpack_require__("dTkA");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var BASE_URL = (window.base_url || '/').replace(/(.*)\/\/$|([^/])$/, '$1/');

var isAbsoluteUrlRegex = /^https?:\/\//i;

/**
 * @param {string|object} url Url path
 * @param {string|object} more Additional parts
 * @return {string}
 */
function siteUrl(url) {
	for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		more[_key - 1] = arguments[_key];
	}

	if (isAbsoluteUrlRegex.test(url)) {
		if (more.length === 0) {
			return url;
		} else {
			return joinPath.apply(null, [url].concat(more));
		}
	} else {
		return joinPath.apply(null, [BASE_URL, url].concat(more));
	}
}

/**
 * Joins given values with slash.
 * If last value is an object - it will be formatted as query data.
 * @param {string|object} values
 * @return {string}
 */
function joinPath() {
	for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		values[_key2] = arguments[_key2];
	}

	if (values.length == 0) return '';
	var query = {};
	var queryString = '';
	var fragment = '';
	var components = [];
	var processValue = function processValue(v) {
		if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isObject(v)) {
			query = _extends({}, query, v);
		} else {
			v = Object(__WEBPACK_IMPORTED_MODULE_2__var__["d" /* asString */])(v).trim();
			var i = void 0;
			if ((i = v.indexOf('#')) >= 0) {
				fragment = v.substr(i + 1);
				v = v.substr(0, i);
			} else if ((i = v.indexOf('?')) >= 0) {
				queryString = v.substr(i + 1);
				v = v.substr(0, i);
			}
			if (v) {
				if (components.length == 0) {
					v = v.replace(/\/$/g, '');
				} else {
					v = v.replace(/^\/|\/$/g, '');
				}
				components.push(v);
			}
		}
	};
	values.forEach(function (v) {
		if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(v)) {
			v.forEach(processValue);
		} else {
			processValue(v);
		}
	});
	var url = components.join('/');
	if (!__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(query)) {
		var q = buildQuery(query);
		if (queryString) {
			queryString += '&';
		}
		queryString += q;
	}
	if (queryString) {
		url += '?' + queryString;
	}
	if (fragment) {
		url += '#' + fragment;
	}
	return url;
}

/**
 *
 * @param {string} url
 * @return {boolean}
 */
function isAbsolute(url) {
	return isAbsoluteUrlRegex.test(url);
}

/**
 * Builds query string from given object
 * @param {object} queryData
 * @return {string}
 */
function buildQuery(queryData) {
	return __WEBPACK_IMPORTED_MODULE_1__location__["c" /* buildQuery */](queryData);
}

function highlightUrls(text) {
	var maxlength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

	return text.replace(/(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\?+=&%#\/\wА-Яа-яёЁ\.;-]*)*\/?/g, function (s) {
		var st = s;

		if (s.length > maxlength) {
			st = s.slice(0, maxlength) + "...";
		}

		if (!/^(https?:\/\/)/.test(s)) {
			s = "http://" + s;
		}

		return "<a href='" + s + "' target='_blank' rel='nofollow noopener'>" + st + "</a>";
	});
}

var UrlParser = function () {
	/**
  * @param {string} url
  */
	function UrlParser(url) {
		_classCallCheck(this, UrlParser);

		this._a = document.createElement('a');
		this._a.href = url;
	}

	/** @return {string} */


	_createClass(UrlParser, [{
		key: 'origin',
		get: function get() {
			return this._a.origin;
		}

		/** @return {string} */

	}, {
		key: 'protocol',
		get: function get() {
			return this._a.protocol;
		}

		/** @return {string} */

	}, {
		key: 'host',
		get: function get() {
			return this._a.host;
		}

		/** @return {string} */

	}, {
		key: 'hostname',
		get: function get() {
			return this._a.hostname;
		}

		/** @return {string} */

	}, {
		key: 'port',
		get: function get() {
			return this._a.port;
		}

		/** @return {string} */

	}, {
		key: 'pathname',
		get: function get() {
			return this._a.pathname;
		}

		/** @return {string} */

	}, {
		key: 'search',
		get: function get() {
			return this._a.search;
		}

		/** @return {string} */

	}, {
		key: 'hash',
		get: function get() {
			return this._a.hash;
		}
	}]);

	return UrlParser;
}();

var UrlBuilder = function () {
	function UrlBuilder() {
		var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var port = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
		var query = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
		var hash = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

		_classCallCheck(this, UrlBuilder);

		this._protocol = protocol;
		this._host = host;
		this._port = port;
		this._path = path;
		this._query = query;
		this._hash = hash;
	}

	/**
  * @param {string|null} value
  */


	_createClass(UrlBuilder, [{
		key: 'build',


		/**
   * @return {string}
   */
		value: function build() {
			var origin = (this._protocol ? this._protocol + '//' : '') + (this._host ? this._host + (this._port ? ':' + this._port : '') : '');
			var query = _typeof(this._query) === 'object' ? prefix(buildQuery(this._query), '?') : this._query;
			return joinPath(origin, this._path, query, this._hash);
		}
	}, {
		key: 'protocol',
		set: function set(value) {
			this._protocol = postfix(value, ':');
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._protocol;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'host',
		set: function set(value) {
			this._host = value;
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._host;
		}

		/**
   * @param {string|number|null} value
   */

	}, {
		key: 'port',
		set: function set(value) {
			this._port = value;
		}

		/** @return {string|number|null} */
		,
		get: function get() {
			return this._port;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'path',
		set: function set(value) {
			this._path = value;
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._path;
		}

		/**
   * @param {string|object|null} value
   */

	}, {
		key: 'query',
		set: function set(value) {
			this._query = prefix(value, '?');
		}

		/** @return {string|object|null} */
		,
		get: function get() {
			return this._query;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'hash',
		set: function set(value) {
			this._hash = prefix(value, '#');
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._hash;
		}
	}]);

	return UrlBuilder;
}();

function prefix(val, prefix) {
	if (val && typeof val === 'string' && !val.startsWith(prefix)) {
		return prefix + val;
	}
	return val;
}

function postfix(val, postfix) {
	if (val && typeof val === 'string' && !val.endsWith(postfix)) {
		return val + postfix;
	}
	return val;
}

/***/ }),

/***/ "FttF":
/***/ (function(module, exports) {

module.exports = "<div>\n\t<fieldset>\n\t\t<legend>Выделение</legend>\n\t\t<button type=\"button\" data-bind=\"click: selectAll\">\n\t\t\tОтметить все\n\t\t</button>\n\t\t<button type=\"button\" data-bind=\"click: unselectAll\">\n\t\t\tСнять выделение\n\t\t</button>\n\t</fieldset>\n</div>\n<div>\n\t<fieldset>\n\t\t<legend>С отмеченными</legend>\n\t\t<button type=\"button\" data-bind=\"click: deleteItems\">\n\t\t\tУдалить\n\t\t</button>\n\t\t<button type=\"button\" data-bind=\"click: restoreItems\">\n\t\t\tВосстановить\n\t\t</button>\n\t\t<button type=\"button\" data-bind=\"click: changeCategory\">\n\t\t\tПоменять категорию\n\t\t</button>\n\t</fieldset>\n</div>\n"

/***/ }),

/***/ "HQ4p":
/***/ (function(module, exports) {

module.exports = "<!-- ko if: !selectedCategory -->\n<span data-bind=\"lang: 'shop_title_all_products'\"></span>\n<!-- /ko -->\n\n<!-- ko if: selectedCategory && selectedCategory.id == 0 -->\n<span data-bind=\"lang: 'shop_title_products_no_category'\"></span>\n<!-- /ko -->\n\n<!-- ko if: selectedCategory && selectedCategory.id > 0 -->\n<span>\n\t<span data-bind=\"lang: 'shop_title_products_from_category'\"></span>\n\n\t<!-- ko with: selectedCategory -->\n\t<strong class=\"category\" data-bind=\"text: title\"></strong>\n\t<!-- /ko -->\n\n\t<!-- ko with: selectedSubcategory -->\n\t<strong class=\"subcategory\" data-bind=\"text: title\"></strong>\n\t<!-- /ko -->\n</span>\n<!-- /ko -->"

/***/ }),

/***/ "JMoE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__("XRua");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("T9V6");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var logger = __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* newLogger */]('Loader');

var Loader = function () {

	/**
  * @param {Router} router
  */

	/** @var XMLHttpRequest */

	/** @var {Router} */
	function Loader(router) {
		var _this = this;

		_classCallCheck(this, Loader);

		this._router = null;
		this._onStart = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();
		this._onStop = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();
		this._onResponse = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();
		this._xhr = null;
		this.apiUrl = null;

		this._router = router;
		router.onNavigate(function (navData) {
			_this._doRequest(navData);
		});
	}

	_createClass(Loader, [{
		key: "onStart",
		value: function onStart(callback) {
			this._onStart.add(callback);
		}
	}, {
		key: "onStop",
		value: function onStop(callback) {
			this._onStop.add(callback);
		}
	}, {
		key: "onResponse",
		value: function onResponse(callback) {
			this._onResponse.add(callback);
		}
	}, {
		key: "_doRequest",
		value: function _doRequest(navData) {
			var _this2 = this;

			var url = navData.url,
			    data = navData.data;

			var _ref = data || {},
			    lastChange = _ref.lastChange;

			var partialLoad = false;

			if (lastChange) {
				var val = lastChange.page || lastChange.limit || lastChange.sort;
				partialLoad = val !== undefined && val !== null;
			}

			if (this.apiUrl) {
				var query = navData.query;
				query = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* appendQuery */](query, _extends({}, navData.params, {
					partial: partialLoad
				}));
				url = this.apiUrl + '?' + query;
			} else if (partialLoad) {
				url = __WEBPACK_IMPORTED_MODULE_1__location__["a" /* addQuery */](url, { partial: true });
			}

			logger.log('do server request', url, navData);

			this._cancel();
			this._onStart.fire();
			this._xhr = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax(url, {
				dataType: 'json',
				success: function success(data, status) {
					logger.log('handle server response', status);
					_this2._onResponse.fire(data);
					_this2._onStop.fire(true, data);
				},
				error: function error(xhr, status, _error) {
					if (status !== 'abort') {
						logger.error('XHR error', status, _error);
					}
					_this2._onStop.fire(false);
				}
			});
		}
	}, {
		key: "_cancel",
		value: function _cancel() {
			if (this._xhr && this._xhr.readyState !== 4) {
				this._xhr.abort();
				this._xhr = null;
			}
		}
	}]);

	return Loader;
}();

/***/ }),

/***/ "KRdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets__ = __webpack_require__("Qnfz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewmodel__ = __webpack_require__("vSTT");





function init(options) {
	__WEBPACK_IMPORTED_MODULE_2__widgets__["a" /* init */]();
	var model = void 0;

	model = __WEBPACK_IMPORTED_MODULE_3__viewmodel__["a" /* init */](options);

	__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.applyBindings(model, __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shopCatalog')[0]);
}

/***/ }),

/***/ "LakT":
/***/ (function(module, exports) {

module.exports = "<div class=\"accordion\">\n\t<h5 class=\"accordion-header filter-header\">\n\t\t<span data-bind=\"text: title\"></span>\n\t\t<span class=\"accordion-header-icon\"></span>\n\t</h5>\n\t<div class=\"accordion-content filter-content\" data-bind=\"template: {nodes: $componentTemplateNodes, data: data}\"></div>\n</div>"

/***/ }),

/***/ "MBRW":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.Navigo=t()}(this,function(){"use strict";var e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};function t(){return!("undefined"==typeof window||!window.history||!window.history.pushState)}function n(e,n,o){this.root=null,this._routes=[],this._useHash=n,this._hash=void 0===o?"#":o,this._paused=!1,this._destroyed=!1,this._lastRouteResolved=null,this._notFoundHandler=null,this._defaultHandler=null,this._usePushState=!n&&t(),this._onLocationChange=this._onLocationChange.bind(this),this._genericHooks=null,this._historyAPIUpdateMethod="pushState",e?this.root=n?e.replace(/\/$/,"/"+this._hash):e.replace(/\/$/,""):n&&(this.root=this._cLoc().split(this._hash)[0].replace(/\/$/,"/"+this._hash)),this._listen(),this.updatePageLinks()}function o(e){return e instanceof RegExp?e:e.replace(/\/+$/,"").replace(/^\/+/,"^/")}function i(e){return e.replace(/\/$/,"").split("/").length}function s(e,t){return i(t)-i(e)}function r(e,t){return function(e){return(arguments.length>1&&void 0!==arguments[1]?arguments[1]:[]).map(function(t){var i=function(e){var t=[];return{regexp:e instanceof RegExp?e:new RegExp(e.replace(n.PARAMETER_REGEXP,function(e,o,i){return t.push(i),n.REPLACE_VARIABLE_REGEXP}).replace(n.WILDCARD_REGEXP,n.REPLACE_WILDCARD)+n.FOLLOWED_BY_SLASH_REGEXP,n.MATCH_REGEXP_FLAGS),paramNames:t}}(o(t.route)),s=i.regexp,r=i.paramNames,a=e.replace(/^\/+/,"/").match(s),h=function(e,t){return 0===t.length?null:e?e.slice(1,e.length).reduce(function(e,n,o){return null===e&&(e={}),e[t[o]]=decodeURIComponent(n),e},null):null}(a,r);return!!a&&{match:a,route:t,params:h}}).filter(function(e){return e})}(e,t)[0]||!1}function a(e,t){var n=t.map(function(t){return""===t.route||"*"===t.route?e:e.split(new RegExp(t.route+"($|/)"))[0]}),i=o(e);return n.length>1?n.reduce(function(e,t){return e.length>t.length&&(e=t),e},n[0]):1===n.length?n[0]:i}function h(e,n,o){var i,s=function(e){return e.split(/\?(.*)?$/)[0]};return void 0===o&&(o="#"),t()&&!n?s(e).split(o)[0]:(i=e.split(o)).length>1?s(i[1]):s(i[0])}function u(t,n,o){if(n&&"object"===(void 0===n?"undefined":e(n))){if(n.before)return void n.before(function(){(!(arguments.length>0&&void 0!==arguments[0])||arguments[0])&&(t(),n.after&&n.after(o))},o);if(n.after)return t(),void(n.after&&n.after(o))}t()}return n.prototype={helpers:{match:r,root:a,clean:o,getOnlyURL:h},navigate:function(e,t){var n;return e=e||"",this._usePushState?(n=(n=(t?"":this._getRoot()+"/")+e.replace(/^\/+/,"/")).replace(/([^:])(\/{2,})/g,"$1/"),history[this._historyAPIUpdateMethod]({},"",n),this.resolve()):"undefined"!=typeof window&&(e=e.replace(new RegExp("^"+this._hash),""),window.location.href=window.location.href.replace(/#$/,"").replace(new RegExp(this._hash+".*$"),"")+this._hash+e),this},on:function(){for(var t=this,n=arguments.length,o=Array(n),i=0;i<n;i++)o[i]=arguments[i];if("function"==typeof o[0])this._defaultHandler={handler:o[0],hooks:o[1]};else if(o.length>=2)if("/"===o[0]){var r=o[1];"object"===e(o[1])&&(r=o[1].uses),this._defaultHandler={handler:r,hooks:o[2]}}else this._add(o[0],o[1],o[2]);else"object"===e(o[0])&&Object.keys(o[0]).sort(s).forEach(function(e){t.on(e,o[0][e])});return this},off:function(e){return null!==this._defaultHandler&&e===this._defaultHandler.handler?this._defaultHandler=null:null!==this._notFoundHandler&&e===this._notFoundHandler.handler&&(this._notFoundHandler=null),this._routes=this._routes.reduce(function(t,n){return n.handler!==e&&t.push(n),t},[]),this},notFound:function(e,t){return this._notFoundHandler={handler:e,hooks:t},this},resolve:function(e){var n,o,i=this,s=(e||this._cLoc()).replace(this._getRoot(),"");this._useHash&&(s=s.replace(new RegExp("^/"+this._hash),"/"));var a=function(e){return e.split(/\?(.*)?$/).slice(1).join("")}(e||this._cLoc()),l=h(s,this._useHash,this._hash);return!this._paused&&(this._lastRouteResolved&&l===this._lastRouteResolved.url&&a===this._lastRouteResolved.query?(this._lastRouteResolved.hooks&&this._lastRouteResolved.hooks.already&&this._lastRouteResolved.hooks.already(this._lastRouteResolved.params),!1):(o=r(l,this._routes))?(this._callLeave(),this._lastRouteResolved={url:l,query:a,hooks:o.route.hooks,params:o.params,name:o.route.name},n=o.route.handler,u(function(){u(function(){o.route.route instanceof RegExp?n.apply(void 0,o.match.slice(1,o.match.length)):n(o.params,a)},o.route.hooks,o.params,i._genericHooks)},this._genericHooks,o.params),o):this._defaultHandler&&(""===l||"/"===l||l===this._hash||function(e,n,o){if(t()&&!n)return!1;if(!e.match(o))return!1;var i=e.split(o);return i.length<2||""===i[1]}(l,this._useHash,this._hash))?(u(function(){u(function(){i._callLeave(),i._lastRouteResolved={url:l,query:a,hooks:i._defaultHandler.hooks},i._defaultHandler.handler(a)},i._defaultHandler.hooks)},this._genericHooks),!0):(this._notFoundHandler&&u(function(){u(function(){i._callLeave(),i._lastRouteResolved={url:l,query:a,hooks:i._notFoundHandler.hooks},i._notFoundHandler.handler(a)},i._notFoundHandler.hooks)},this._genericHooks),!1))},destroy:function(){this._routes=[],this._destroyed=!0,this._lastRouteResolved=null,this._genericHooks=null,clearTimeout(this._listeningInterval),"undefined"!=typeof window&&(window.removeEventListener("popstate",this._onLocationChange),window.removeEventListener("hashchange",this._onLocationChange))},updatePageLinks:function(){var e=this;"undefined"!=typeof document&&this._findLinks().forEach(function(t){t.hasListenerAttached||(t.addEventListener("click",function(n){var o=e.getLinkPath(t);e._destroyed||(n.preventDefault(),e.navigate(o.replace(/\/+$/,"").replace(/^\/+/,"/")))}),t.hasListenerAttached=!0)})},generate:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=this._routes.reduce(function(n,o){var i;if(o.name===e)for(i in n=o.route,t)n=n.toString().replace(":"+i,t[i]);return n},"");return this._useHash?this._hash+n:n},link:function(e){return this._getRoot()+e},pause:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this._paused=e,this._historyAPIUpdateMethod=e?"replaceState":"pushState"},resume:function(){this.pause(!1)},historyAPIUpdateMethod:function(e){return void 0===e?this._historyAPIUpdateMethod:(this._historyAPIUpdateMethod=e,e)},disableIfAPINotAvailable:function(){t()||this.destroy()},lastRouteResolved:function(){return this._lastRouteResolved},getLinkPath:function(e){return e.getAttribute("href")},hooks:function(e){this._genericHooks=e},_add:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;return"string"==typeof t&&(t=encodeURI(t)),this._routes.push("object"===(void 0===n?"undefined":e(n))?{route:t,handler:n.uses,name:n.as,hooks:o||n.hooks}:{route:t,handler:n,hooks:o}),this._add},_getRoot:function(){return null!==this.root?this.root:(this.root=a(this._cLoc().split("?")[0],this._routes),this.root)},_listen:function(){var e=this;if(this._usePushState)window.addEventListener("popstate",this._onLocationChange);else if("undefined"!=typeof window&&"onhashchange"in window)window.addEventListener("hashchange",this._onLocationChange);else{var t=this._cLoc(),n=void 0,o=void 0;(o=function(){n=e._cLoc(),t!==n&&(t=n,e.resolve()),e._listeningInterval=setTimeout(o,200)})()}},_cLoc:function(){return"undefined"!=typeof window?void 0!==window.__NAVIGO_WINDOW_LOCATION_MOCK__?window.__NAVIGO_WINDOW_LOCATION_MOCK__:o(window.location.href):""},_findLinks:function(){return[].slice.call(document.querySelectorAll("[data-navigo]"))},_onLocationChange:function(){this.resolve()},_callLeave:function(){var e=this._lastRouteResolved;e&&e.hooks&&e.hooks.leave&&e.hooks.leave(e.params)}},n.PARAMETER_REGEXP=/([:*])(\w+)/g,n.WILDCARD_REGEXP=/\*/g,n.REPLACE_VARIABLE_REGEXP="([^/]+)",n.REPLACE_WILDCARD="(?:.*)",n.FOLLOWED_BY_SLASH_REGEXP="(?:/$|$)",n.MATCH_REGEXP_FLAGS="",n});
//# sourceMappingURL=navigo.min.js.map


/***/ }),

/***/ "Qnfz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
function init() {}

/***/ }),

/***/ "RD2g":
/***/ (function(module, exports) {

module.exports = "<!-- ko with: list -->\n<div class=\"filter-input-wrapper\" data-bind=\"visible: isFilterVisible, css: {filled: criteria().length > 0, loading: isFetching}\">\n\t<input class=\"filter-input\" type=\"text\" autocomplete=\"off\"\n\t\t   data-bind=\"textInput: criteria, attr: {placeholder: zde.lang('shop_filter_search_by_list')}\"/>\n\t<span class=\"filter-input-btn\" data-bind=\"click: resetFilter, attr: {title: zde.lang('btn_reset')}\">&nbsp;</span>\n</div>\n<div class=\"filter-content\">\n\t<ul class=\"parametric-list\" data-bind=\"foreach: visibleLimitedItems\">\n\t\t<li data-bind=\"css: {active: selected}\">\n\t\t\t<a class=\"parametric-line\" data-bind=\"click: $parent.handleClick\">\n\t\t\t\t<span class=\"parametric-icon\"></span>\n\t\t\t\t<span class=\"parametric-text\" data-bind=\"text: title\"></span>\n\t\t\t\t<span class=\"parametric-counter\" data-bind=\"numeral: {value: count, format: '0 a', titleFormat: '0,0'}\"></span>\n\t\t\t</a>\n\t\t</li>\n\t</ul>\n\t<div class=\"show-more-items\" data-bind=\"visible: moreCount > 0 && hiddenCount > 0\">\n\t\t<a data-bind=\"click: showMore\">\n\t\t\t<span data-bind=\"lang: {name: 'shop_filter_show_more', data: {n: moreCount}}\"></span>\n\t\t</a>\n\t</div>\n\t<div class=\"more-items-info\" data-bind=\"visible: moreCount > 0 && hiddenCount == 0\">\n\t\t<span data-bind=\"lang: {name: 'shop_filter_has_more_use_search', data: {n: moreCount}}\"></span>\n\t</div>\n\t<div data-bind=\"visible: isFiltered && visibleCount == 0\">\n\t\t<span data-bind=\"lang: 'shop_filter_no_results'\"></span>\n\t\t<a data-bind=\"click: resetFilter, lang: 'btn_reset'\"></a>\n\t</div>\n</div>\n<!-- /ko -->"

/***/ }),

/***/ "REJB":
/***/ (function(module, exports) {

module.exports = "<!-- ko with: categoryList -->\n<div class=\"filter-block category-filter-block\" data-bind=\"visible: hasVisibleItems, css: {'with-sub-layout': $data.activeItem}\">\n\t<div class=\"accordion\">\n\t\t<h5 class=\"accordion-header filter-header\">\n\t\t\t<span data-bind=\"lang: 'shop_filter_category'\"></span>\n\t\t\t<span class=\"accordion-header-icon\"></span>\n\t\t</h5>\n\t\t<div class=\"accordion-content filter-content\">\n\t\t\t<category-filter params=\"list: $data\"></category-filter>\n\t\t</div>\n\t</div>\n\t<!-- ko with: $data.activeItem -->\n\t<div class=\"subcategories-wrap\" data-bind=\"component: {name: 'subcategories', params: subcategories}\"></div>\n\t<!-- /ko -->\n</div>\n<div class=\"sub-layout-overlay\"></div>\n<!-- /ko -->\n\n<!-- ko foreach: attributes.items -->\n<filter-block params=\"title: title, data: {list: $data, selection: $root.selection}\">\n\t<selection-items params=\"model: selection, type: list.name\" data-bind=\"visible: selection.hasItemsOfType(list.name)\"></selection-items>\n\t<attribute-filter params=\"list: list\" data-bind=\"css2: list.name + '-filter'\"></attribute-filter>\n</filter-block>\n<!-- /ko -->\n\n<!-- ko foreach: [brands, shops] -->\n<filter-block params=\"title: title, data: {list: $data, selection: $root.selection}\" data-bind=\"visible: isVisible\">\n\t<selection-items params=\"model: selection, type: list.name\" data-bind=\"visible: selection.hasItemsOfType(list.name)\"></selection-items>\n\t<list-filter params=\"list: list\" data-bind=\"css: {loading11: list.isFetching}, css2: list.name + '-filter'\"></list-filter>\n</filter-block>\n<!-- /ko -->\n\n<filter-block class=\"price-range-filter\" params=\"title: zde.lang('shop_filter_price') + ', ' + $root.settings.currency, data: priceRangeFilter\"\n\t\t\t  data-bind=\"visible: priceRangeFilter.isVisible\">\n\t<range-filter params=\"filter: $data\"></range-filter>\n</filter-block>\n\n<filter-block class=\"discount-range-filter\" params=\"title: zde.lang('shop_filter_discount') + ', %', data: discountRangeFilter\"\n\t\t\t  data-bind=\"visible: discountRangeFilter.isVisible\">\n\t<range-filter params=\"filter: $data\"></range-filter>\n</filter-block>\n\n<filter-block class=\"last-update-filter\" params=\"title: zde.lang('shop_filter_last_update'), data: lastUpdateFilter\">\n\t<dropdown-filter params=\"filter: $data\"></dropdown-filter>\n</filter-block>\n\n<!-- ko ifnot: $root.settings.isGerman -->\n<filter-block class=\"availability-filter\" params=\"title: zde.lang('shop_filter_availability'), data: availabilityFilter\">\n\t<dropdown-filter params=\"filter: $data\"></dropdown-filter>\n</filter-block>\n\n<filter-block class=\"discount-filter\" params=\"title: zde.lang('shop_filter_discount'), data: discountFilter\">\n\t<dropdown-filter params=\"filter: $data\"></dropdown-filter>\n</filter-block>\n<!-- /ko -->"

/***/ }),

/***/ "RaK1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lang;
/* unused harmony export tmpl */
/* harmony export (immutable) */ __webpack_exports__["b"] = pluralize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_smart_plurals__ = __webpack_require__("tXil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_smart_plurals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_smart_plurals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__("TxBK");




/**
 * Renders phrase
 * @param {string} lang Phrase name
 * @param {object|null} [data]
 * @param {boolean} [asHtml] Whether to render variables decorated with span tag. Default is FALSE
 * @returns {string} Rendered phrase
 */
function lang(lang) {
	var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	var asHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	var phrase = Object(__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* phrases */])()[lang];
	if (!phrase) return lang;
	return tmpl(phrase, data, asHtml);
}

/**
 *
 * @param {string} template
 * @param {object|null} [data]
 * @param {boolean} [asHtml] Whether to render variables decorated with span tag. Default is TRUE
 * @returns {string}
 */
function tmpl(template) {
	var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	var asHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	if (!data) return template;
	template = '' + template;

	var result = template;
	for (var key in data) {
		if (!data.hasOwnProperty(key)) continue;
		var val = data[key];

		// unwrap value
		if (typeof val === 'function') {
			val = val();
		}

		var keyParam = escapeRegExp(key);
		var pluralRegex = new RegExp("\\[([^\\]]+{" + keyParam + "}[^\\]]+)\\]");
		var m = pluralRegex.exec(template);
		if (m) {
			result = result.replace(pluralRegex, pluralize(val, m[1], key));
		}

		var replacement = asHtml ? '<span class="tmpl-var-' + key + '">' + val + '</span>' : val;
		result = result.split('{' + key + '}').join(replacement);
	}
	return result;
}

/**
 *
 * @param {number} count
 * @param {string} text
 * @param {string} varName
 * @param {string|number|null} varValue
 */
function pluralize(count, text) {
	var varName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'n';
	var varValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	var parts = text.split('|');
	var pluralRule = __WEBPACK_IMPORTED_MODULE_1_smart_plurals___default.a.Plurals.getRule(LANG);
	var part = pluralRule(count, parts);
	if (part === undefined) {
		part = parts[0];
	}
	var replacement = varValue !== undefined && varValue !== null ? varValue : count;
	return part.split('{' + varName + '}').join(replacement);
}

function escapeRegExp(string) {
	return string.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
}

__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.bindingHandlers['lang'] = {
	init: function init() {
		return { 'controlsDescendantBindings': true };
	},
	update: function update(element, valueAccessor) {
		var params = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.unwrap(valueAccessor());
		var o = {
			name: '',
			data: undefined,
			html: undefined
		};
		if (!$.isPlainObject(params)) {
			o.name = params;
		} else {
			$.extend(o, params);
		}
		var args = [o.name, o.data, o.html];
		var val = lang.apply(this, args);
		__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.utils.setHtml(element, val);
	}
};

/***/ }),

/***/ "Rjrh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_categories__ = __webpack_require__("ZQ2V");



// component for SubcategoryList instance
// Input params: list instance or object with such properties
// - list {SubcategoryList}
__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.components.register('subcategories', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			if (params instanceof __WEBPACK_IMPORTED_MODULE_1__model_categories__["e" /* SubcategoryList */]) {
				params = { list: params };
			}
			return params;
		}
	},
	template: __webpack_require__("1zW/")
});

/***/ }),

/***/ "T9V6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_navigo__ = __webpack_require__("MBRW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_navigo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_navigo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__location__ = __webpack_require__("XRua");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__url__ = __webpack_require__("FYi7");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var logger = __WEBPACK_IMPORTED_MODULE_4__logger__["a" /* newLogger */]('Router');

var Router = function () {
	function Router() {
		_classCallCheck(this, Router);

		this.delay = 0;
		this._navigo = null;
		this._baseUrl = null;
		this._currentUrl = null;
		this._navData = null;
		this._onInitialize = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.Callbacks();
		this._onNavigate = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.Callbacks();
		this._initialized = false;
		this._handlerData = null;
		this._request = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable();
	}
	/** @type {NavUrl} */


	_createClass(Router, [{
		key: 'init',
		value: function init(baseUrl) {
			var _this = this;

			this._baseUrl = baseUrl || '';
			this._navigo = new __WEBPACK_IMPORTED_MODULE_0_navigo___default.a(this._baseUrl);
			this._routeHandler = this._routeHandler.bind(this);
			this._navigo.on({
				'/': function _(query) {
					return _this._routeHandler({}, query);
				},
				'/:category': this._routeHandler,
				'/:category/:subcategory': this._routeHandler
			});
			this._navigo.notFound(function () {
				logger.warn('Unknown route', location.pathname);
			});
			this._navigo.resolve();
			this._request.subscribe(function (req) {
				_this._navigateImmediate(req.url, req.data);
			});
			this._initialized = true;
		}
	}, {
		key: 'onInitialize',
		value: function onInitialize(callback) {
			this._onInitialize.add(callback);
		}
	}, {
		key: 'onNavigate',
		value: function onNavigate(callback) {
			this._onNavigate.add(callback);
		}
	}, {
		key: 'navigate',


		/**
   * @param {NavUrl|string} url
   * @param {object} data
   */
		value: function navigate(url) {
			var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			if (url instanceof NavUrl) {
				url = new NavUrl(this._prepUrl(url.path), url.queryData);
			} else {
				var parser = new __WEBPACK_IMPORTED_MODULE_5__core_utils_url__["c" /* UrlParser */](url);
				url = new NavUrl(this._prepUrl(parser.pathname), parser.search);
			}
			this._request({ url: url, data: data });
		}

		/**
   * @param {NavUrl} url
   * @param {object} handlerData
   */

	}, {
		key: '_navigateImmediate',
		value: function _navigateImmediate(url) {
			var handlerData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			if (this._initialized && !url.equals(this._currentUrl)) {
				logger.info('navigate to:', url);
				this._currentUrl = url;
				this._handlerData = handlerData;
				var urlString = url.build();
				var absolute = /^https?:\/\//i.test(urlString);
				if (this.enabled) {
					this._navigo.navigate(urlString, absolute);
				} else {
					location.href = absolute ? urlString : this._baseUrl + urlString;
				}
			}
		}
	}, {
		key: '_prepUrl',
		value: function _prepUrl(url) {
			var parser = new __WEBPACK_IMPORTED_MODULE_5__core_utils_url__["c" /* UrlParser */](this._baseUrl);
			return url.replace(parser.origin, '').replace(parser.pathname, '').replace(/^\/|\/$/g, '');
		}
	}, {
		key: '_routeHandler',
		value: function _routeHandler(params, query) {
			if (location.href.indexOf(this._baseUrl) !== 0) {
				location.reload();
				return;
			}
			var path = this._prepUrl(location.pathname);
			var queryData = __WEBPACK_IMPORTED_MODULE_3__location__["d" /* decodeQueryString */](query);
			this._currentUrl = new NavUrl(path, queryData);
			this._navData = {
				url: location.href,
				baseUrl: this._baseUrl,
				params: params,
				query: query,
				queryData: queryData,
				data: this._handlerData
			};
			this._handlerData = null;
			logger.log('new navData:', this._navData);
			if (this._initialized) {
				this._onNavigate.fire(this._navData);
			} else {
				this._onInitialize.fire(this._navData);
			}
		}
	}, {
		key: 'enabled',
		get: function get() {
			return window.history && window.history.pushState;
		}
	}, {
		key: 'initialized',
		get: function get() {
			return this._initialized;
		}
	}, {
		key: 'navData',
		get: function get() {
			return this._navData;
		}
	}, {
		key: 'baseUrl',
		get: function get() {
			return this._baseUrl;
		}
	}]);

	return Router;
}();

Router.defaults = {
	baseUrl: ''
};
var NavUrl = function () {
	function NavUrl(path, queryData) {
		_classCallCheck(this, NavUrl);

		this._path = path;
		this._queryData = queryData;
		this._url = new __WEBPACK_IMPORTED_MODULE_6__url__["b" /* UrlBuilder */](null, null, null, this._path, this._queryData, null).build();
	}

	_createClass(NavUrl, [{
		key: 'build',
		value: function build() {
			return this._url;
		}

		/**
   * @param {NavUrl} url
   * @return {boolean}
   */

	}, {
		key: 'equals',
		value: function equals(url) {
			return url instanceof NavUrl && this._path == url._path && _.isEqual(this._queryData, url._queryData);
		}
	}, {
		key: 'toString',
		value: function toString() {
			return this._url;
		}
	}, {
		key: 'path',
		get: function get() {
			return this._path;
		}
	}, {
		key: 'queryData',
		get: function get() {
			return this._queryData;
		}
	}]);

	return NavUrl;
}();

/***/ }),

/***/ "TxBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = globals;
/* harmony export (immutable) */ __webpack_exports__["b"] = phrases;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var__ = __webpack_require__("dTkA");


var _globals = {};
var _phrases = {};

/**
 * Returns Globals object
 * @param {string|null} key Optional key to return
 * @param {*} defaultValue Default value for key
 * @return {object|*} Globals object if no key is provided, otherwise associated value
 */
function globals() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var g = window.globals || _globals;
  return key !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__var__["e" /* element */])(g, key, defaultValue) : g;
}

/**
 * Returns global Phrases object
 * @param {string|null} key Optional key to return
 * @param {*} defaultValue Default value for key
 * @return {object} Phrases object if no key is provided, otherwise associated value
 */
function phrases() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var g = globals('phrases') || _phrases;
  return key !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__var__["e" /* element */])(g, key, defaultValue) : g;
}

/***/ }),

/***/ "WISg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Settings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_numeral__ = __webpack_require__("u2Mx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_var__ = __webpack_require__("dTkA");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var Settings = function () {
	function Settings(data) {
		_classCallCheck(this, Settings);

		this._data = _extends({}, data); // clone to avoid external modification

		if (typeof __WEBPACK_IMPORTED_MODULE_0_lib_numeral___default.a !== 'undefined') {
			__WEBPACK_IMPORTED_MODULE_0_lib_numeral___default.a.localeData().currency.symbol = this.currency;
		}
	}

	/** @return {string} */


	_createClass(Settings, [{
		key: "convertPrice",


		/**
   * @param {number} price
   * @return {number}
   */
		value: function convertPrice(price) {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["c" /* asNumber */])(price) * this.currencyRate;
		}
	}, {
		key: "getCategoryUrl",
		value: function getCategoryUrl(categorySlug) {
			var subcategorySlug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			return __WEBPACK_IMPORTED_MODULE_1__core_utils_url__["f" /* joinPath */](this.shopUrl, categorySlug, subcategorySlug);
		}
	}, {
		key: "getProductUrl",
		value: function getProductUrl(productUri) {
			return __WEBPACK_IMPORTED_MODULE_1__core_utils_url__["f" /* joinPath */](this.shopUrl, productUri);
		}
	}, {
		key: "getImageUrl",
		value: function getImageUrl(path) {
			var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full/';

			if (__WEBPACK_IMPORTED_MODULE_1__core_utils_url__["e" /* isAbsolute */](path)) {
				return path;
			}
			return __WEBPACK_IMPORTED_MODULE_1__core_utils_url__["f" /* joinPath */](this.imgUrl, dir, path);
		}
	}, {
		key: "getPreviewImgageUrl",
		value: function getPreviewImgageUrl(path) {
			return this.getImageUrl(path, 'preview/');
		}
	}, {
		key: "getShopUrl",
		value: function getShopUrl(shopSlug) {
			return __WEBPACK_IMPORTED_MODULE_1__core_utils_url__["g" /* siteUrl */]('shops', shopSlug);
		}
	}, {
		key: "getOfferUrl",
		value: function getOfferUrl(offerId) {
			return __WEBPACK_IMPORTED_MODULE_1__core_utils_url__["g" /* siteUrl */]('shop/relocate', offerId);
		}
	}, {
		key: "baseUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'base_url', ''));
		}

		/** @return {string} */

	}, {
		key: "shopUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'shop_url', ''));
		}

		/** @return {string} */

	}, {
		key: "catalogApiUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'api_url', this.shopUrl));
		}

		/** @return {string} */

	}, {
		key: "searchApiUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'search_api_url', this.shopUrl));
		}

		/** @return {string} */

	}, {
		key: "imgUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'img_url', ''));
		}

		/** @return {string} */

	}, {
		key: "currency",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["d" /* asString */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'currency', 'EUR'));
		}

		/** @return {number} */

	}, {
		key: "currencyRate",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["c" /* asNumber */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'currency_rate'), 1);
		}

		/** @return {boolean} */

	}, {
		key: "isAdmin",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["b" /* asBoolean */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'is_admin'));
		}

		/** @return {boolean} */

	}, {
		key: "isGerman",
		get: function get() {
			return !!window.IS_GERMAN;
		}

		/**
   * @return {boolean}
   */

	}, {
		key: "useFavorites",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["b" /* asBoolean */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'use_favorites'));
		}

		/**
   * Use offer url as product url
   * @return {boolean}
   */

	}, {
		key: "useOfferUrl",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["b" /* asBoolean */])(this._data['use_offer_url']);
		}

		/**
   * Format for numeral library
   * @return {string}
   */

	}, {
		key: "priceFormat",
		get: function get() {
			return this.currencyRate === 1 ? '0,0.00 $' : '0,0 $';
		}

		/** @return {boolean} */

	}, {
		key: "debug",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["b" /* asBoolean */])(Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_var__["e" /* element */])(this._data, 'debug'));
		}
	}]);

	return Settings;
}();

/***/ }),

/***/ "WO1x":
/***/ (function(module, exports) {

module.exports = "<!-- ko if: showCountInfo -->\n<div class=\"count-info-wrap\">\n\t<span data-bind=\"lang: 'shop_results_found'\"></span>\n\t<span data-bind=\"html: productsPluralText\"></span>\n</div>\n<!-- /ko -->\n\n<!-- ko if: showPageInfo -->\n<div class=\"page-info-wrap\" data-bind=\"with: model.pagination, visible: model.pagination.pagesCount() > 1\">\n\t<span data-bind=\"lang: {name: 'shop_page_number', data: {page: currentPage, total: pagesCount}}\"></span>\n</div>\n<!-- /ko -->\n\n<!-- ko if: showPagination -->\n<div class=\"pagination\" data-bind=\"with: model.pagination, visible: model.pagination.items().length > 1\">\n\t<!-- ko with: firstItem -->\n\t<a class=\"pg-item pg-first\" data-bind=\"attr: {href: url}, css: {active: active}, click: $parent.handleClickItem, lang: 'txt_paginator_first_page'\"></a>\n\t<!-- /ko -->\n\n\t<!-- ko foreach: items -->\n\t<a class=\"pg-item\" data-bind=\"attr: {href: url}, css: {active: active}, click: $parent.handleClickItem, text: number\"></a>\n\t<!-- /ko -->\n\n\t<!-- ko with: lastItem -->\n\t<a class=\"pg-item pg-last\" data-bind=\"attr: {href: url}, css: {active: active}, click: $parent.handleClickItem, lang: 'txt_paginator_last_page'\"></a>\n\t<!-- /ko -->\n</div>\n<!-- /ko -->\n\n<!-- ko if: showSorting -->\n<div class=\"sort-by-wrap\">\n\t<div>\n\t\t<span data-bind=\"lang: 'shop_sorting'\"></span>:\n\t\t<select name=\"sort-by\" class=\"select-sort-by\" data-bind=\"value: model.sortBy, options: sortTypes, optionsValue: 'key', optionsText: 'title'\">\n\t\t</select>\n\t</div>\n</div>\n<!-- /ko -->\n\n<!-- ko if: showLimit -->\n<div class=\"limit-wrap\">\n\t<div>\n\t\t<span data-bind=\"lang: 'shop_results_on_page'\"></span>:\n\t\t<select class=\"select-limit\" data-bind=\"value: model.limit, options: limitValues\">\n\t\t</select>\n\t</div>\n</div>\n<!-- /ko -->"

/***/ }),

/***/ "X0GP":
/***/ (function(module, exports) {

module.exports = _;

/***/ }),

/***/ "XRua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildUrl */
/* harmony export (immutable) */ __webpack_exports__["c"] = buildQuery;
/* harmony export (immutable) */ __webpack_exports__["a"] = addQuery;
/* harmony export (immutable) */ __webpack_exports__["b"] = appendQuery;
/* unused harmony export query */
/* unused harmony export hashQuery */
/* harmony export (immutable) */ __webpack_exports__["d"] = decodeQueryString;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This script adds some additional methods to window.location
 *  buildQuery      Helper method for constricting query strings
 *  query           location.query manipulator
 *  hashQuery       location.hash manipulator
 */

var location = window.location;

function buildUrl(pathname, queryString) {
	if (!queryString) {
		return pathname;
	}
	queryString = '' + queryString;
	if (!queryString.startsWith('?')) {
		queryString = '?' + queryString;
	}
	return pathname + queryString;
}

/**
 * Builds query string from given object
 * @param {object} queryData
 * @param {boolean} [numeric_prefix]
 * @return {string}
 */
function buildQuery(queryData, numeric_prefix) {
	var value = void 0,
	    key = void 0,
	    tmp = [];
	var arg_separator = "&";

	for (key in queryData) {
		if (!queryData.hasOwnProperty(key)) {
			continue;
		}
		value = queryData[key];
		if (numeric_prefix && !isNaN(key)) {
			key = String(numeric_prefix) + key;
		}
		var _query = http_build_query_helper(urlencode(key), value, arg_separator);
		if (_query !== '') {
			tmp.push(_query);
		}
	}

	return tmp.join(arg_separator);
}

/**
 * Appends given query data to given URL
 * @param {string} url
 * @param {object} queryData
 * @return {string} New url
 */
function addQuery(url, queryData) {
	var q = buildQuery(queryData);
	url = '' + url;
	var m = /^([^?#]*)(\?[^#]+)?(#.+)?$/.exec(url);
	if (!m) {
		return url + '?' + q;
	}
	return (m[1] || '') + (m[2] ? m[2] + '&' + q : '?' + q) + (m[3] || '');
}

/**
 * Appends given query data to given query string
 * @param {string} queryString
 * @param {object} queryData
 * @return {string} New query string
 */
function appendQuery(queryString, queryData) {
	var q = buildQuery(queryData);
	if (!q) {
		return queryString;
	}
	var str = '' + queryString;
	return str.length > 0 ? str + '&' + q : q;
}

/**
 * Manipulates <code>location.search</code> as an object.<br/>
 * With no arguments - returns the whole <code>location.search</code> object.<br/>
 * With only key argument - returns value for this key.<br/>
 * With key and value arguments (or only key as object) - updates <code>location.search</code> with new value
 * @param [key] The key to set. Can be an object, so the value is not needed
 * @param [value] The value to set
 * @param [extend] TRUE to extend current <code>location.search</code> object, or FALSE to replace it. Default is TRUE
 * @returns {Object|String}
 */
function query(key, value, extend) {
	return processQuery('search', key, value, extend);
}

/**
 * Manipulates <code>location.hash</code> as an object.<br/>
 * With no arguments - returns the whole <code>location.hash</code> object.<br/>
 * With only key argument - returns value for this key.<br/>
 * With key and value arguments (or only key as object) - updates <code>location.hash</code> with new value
 * @param [key] The key to set. Can be an object, so the value is not needed
 * @param [value] The value to set
 * @param [extend] TRUE to extend current <code>location.hash</code> object, or FALSE to replace it. Default is TRUE
 * @returns {Object|String}
 */
function hashQuery(key, value, extend) {
	return processQuery('hash', key, value, extend);
}

function processQuery(type, key, value, extend) {
	var queryData = decodeQueryString(location[type].substring(1));
	if (key !== undefined) {
		var isObj = (typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object';

		if (value === undefined && !isObj) {
			// return value
			return queryData[key] === undefined ? null : queryData[key];
		} else if (!isObj) {
			if (extend === undefined) extend = true;

			// set value to key
			var k = key.toString();
			key = {};
			key[k] = value;
		}

		if (extend) {
			$.extend(queryData, key);
		} else {
			queryData = key;
		}

		// clear data
		var newData = {};
		$.each(queryData, function (key, value) {
			if (value) newData[key] = value;
		});
		queryData = newData;

		location[type] = buildQuery(queryData);
	}
	return queryData;
}

/**
 * Decodes query string like 'a=one&b=two&c[]=three' and returns an object
 * @param string
 * @return {Object}
 */
function decodeQueryString(string) {
	var glue1 = '=',
	    glue2 = '&',
	    array = {},
	    // holds result
	array2 = String(string).replace(/^&?([\s\S]*?)&?$/, '$1').split(glue2),
	    i = void 0,
	    j = void 0,
	    chr = void 0,
	    tmp = void 0,
	    key = void 0,
	    value = void 0,
	    bracket = void 0,
	    keys = void 0,
	    evalStr = void 0,
	    fixStr = function fixStr(str) {
		return decodeURIComponent(str).replace(/([\\"'])/g, '\\$1').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\+/g, ' ');
	};

	for (i = 0; i < array2.length; i++) {
		tmp = array2[i].split(glue1);
		if (tmp.length < 2) {
			tmp = [tmp, ''];
		}
		key = fixStr(tmp[0]);
		value = fixStr(tmp[1]);
		while (key.charAt(0) === ' ') {
			key = key.substr(1);
		}
		if (key.indexOf('\0') !== -1) {
			key = key.substr(0, key.indexOf('\0'));
		}
		if (key && key.charAt(0) !== '[') {
			keys = [];
			bracket = 0;
			for (j = 0; j < key.length; j++) {
				if (key.charAt(j) === '[' && !bracket) {
					bracket = j + 1;
				} else if (key.charAt(j) === ']') {
					if (bracket) {
						if (!keys.length) {
							keys.push(key.substr(0, bracket - 1));
						}
						keys.push(key.substr(bracket, j - bracket));
						bracket = 0;
						if (key.charAt(j + 1) !== '[') {
							break;
						}
					}
				}
			}
			if (!keys.length) {
				keys = [key];
			}
			for (j = 0; j < keys[0].length; j++) {
				chr = keys[0].charAt(j);
				if (chr === ' ' || chr === '.' || chr === '[') {
					keys[0] = keys[0].substr(0, j) + '_' + keys[0].substr(j + 1);
				}
				if (chr === '[') {
					break;
				}
			}
			evalStr = 'array';
			for (j = 0; j < keys.length; j++) {
				key = keys[j];
				if (key !== '' && key !== ' ' || j === 0) {
					key = "'" + key + "'";
				} else {
					key = eval(evalStr + '.push([]);') - 1;
				}
				evalStr += '[' + key + ']';
				if (j !== keys.length - 1 && eval('typeof ' + evalStr) === 'undefined') {
					eval(evalStr + ' = [];');
				}
			}
			evalStr += " = '" + value + "';\n";
			eval(evalStr);
		}
	}

	return array;
}

function urlencode(str) {
	str = (str + '').toString();
	return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}

function http_build_query_helper(key, val, arg_separator) {
	var k = void 0,
	    tmp = [];
	if (val === true) {
		val = "1";
	} else if (val === false) {
		val = "0";
	}
	if (val !== null && val !== undefined && val !== '') {
		if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === "object") {
			var start = 0;
			for (k in val) {
				if (!val.hasOwnProperty(k)) {
					continue;
				}
				if (val[k] !== null) {
					var sk = void 0,
					    num = Number(k);
					if (!isNaN(num) && num - start === 0) {
						if (_typeof(val[k]) === "object") {
							sk = num;
						} else {
							sk = '';
						}
						start++;
					} else {
						sk = urlencode(k);
					}
					var part = http_build_query_helper(key + "[" + sk + "]", val[k], arg_separator);
					if (part) {
						tmp.push(part);
					}
				}
			}
			return tmp.join(arg_separator);
		} else if (typeof val !== "function") {
			return key + "=" + urlencode(val);
		} else {
			throw new Error('There was an error processing for http_build_query().');
		}
	} else {
		return '';
	}
}

/***/ }),

/***/ "YdFU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_LOGIN", function() { return MODAL_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ASK_REDIRECT", function() { return MODAL_ASK_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_CRITICAL_NEWS", function() { return MODAL_CRITICAL_NEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_REVIEW", function() { return MODAL_REVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_REVIEW_EDIT", function() { return MODAL_REVIEW_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_QUESTION_EDIT", function() { return MODAL_QUESTION_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_REVIEW_COMMENT_EDIT", function() { return MODAL_REVIEW_COMMENT_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_CREATE_COMPUTER_ORDER", function() { return MODAL_CREATE_COMPUTER_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_ORDER_PAGE", function() { return MODAL_FILIALIST_ORDER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_EXCLUDE_FROM_PARCEL", function() { return MODAL_FILIALIST_EXCLUDE_FROM_PARCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_FREE_ORDERS_EDIT", function() { return MODAL_FILIALIST_FREE_ORDERS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_CREATE_TODO", function() { return MODAL_FILIALIST_CREATE_TODO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIIST_REASSIGN_PACKAGES_TO_CUSTOMERS", function() { return MODAL_FILIALIIST_REASSIGN_PACKAGES_TO_CUSTOMERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_CHANGE_ASSIGNMENT_CUSTOMER", function() { return MODAL_FILIALIST_CHANGE_ASSIGNMENT_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_EDIT_ASSIGNMENT", function() { return MODAL_FILIALIST_EDIT_ASSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_GET_ASSIGNMENT_MEEST_DATA", function() { return MODAL_FILIALIST_GET_ASSIGNMENT_MEEST_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_BATCH_PAYMENT", function() { return MODAL_FILIALIST_BATCH_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_SET_PACKAGE_KINDS", function() { return MODAL_FILIALIST_SET_PACKAGE_KINDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_SET_MEEST_ADDRESS_ALIASES", function() { return MODAL_FILIALIST_SET_MEEST_ADDRESS_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_REPLENISH_BALANCE", function() { return MODAL_ADMIN_REPLENISH_BALANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_BATCH_PAYMENT", function() { return MODAL_ADMIN_BATCH_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_IMPORT_BANK_STATEMENT", function() { return MODAL_ADMIN_IMPORT_BANK_STATEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_VALIDATE_INVOICE_CSV", function() { return MODAL_ADMIN_VALIDATE_INVOICE_CSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_SHOP_BANK_STATEMENT_KEYWORDS", function() { return MODAL_ADMIN_SHOP_BANK_STATEMENT_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_PACKAGE_INFO", function() { return MODAL_PACKAGE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_SELECT_SHOP_CATEGORY", function() { return MODAL_SELECT_SHOP_CATEGORY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_modal__ = __webpack_require__("rItL");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
This file contains shortcuts for different kinds of modals
 */



var MODAL_LOGIN = {
	/**
  * @param {Function} onClose Callback accepts one parameter of type {object} - dialog's result
  * @return {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('login', null, { onClose: onClose });
	}
};

var MODAL_ASK_REDIRECT = {
	/**
  * @param {object} data
  * @return {ZDialog}
  */
	show: function show() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('ask_redirect', data, {
			modal: true
		});
	}
};

var MODAL_CRITICAL_NEWS = {
	/**
  * @param {number} id News ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('critical_news', { id: id }, {
			modal: true,
			onClose: onClose
		});
	}
};

var MODAL_REVIEW = {
	/**
  * @param {number} id
  * @param {number} index
  * @param {*} filter
  * @return {ZDialog}
  */
	show: function show(id) {
		var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('review', { id: id, index: index, filter: filter }, { fullscreen: true });
	}
};

var MODAL_REVIEW_EDIT = {
	/**
  * @param {number} id
  * @param {number} packageId
  * @param {Object} initialValues
 * @param {Function} onClose
 * @return {ZDialog}
  */
	show: function show(id) {
		var packageId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var initialValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var onClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		var data = _extends({
			id: id,
			package_id: packageId
		}, initialValues);

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('review_edit', data, { onClose: onClose });
	}
};

var MODAL_QUESTION_EDIT = {
	/**
  * @param {number} id
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('question_edit', { id: id }, { onClose: onClose });
	}
};

var MODAL_REVIEW_COMMENT_EDIT = {
	/**
  * @param {number} id
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('review_comment_edit', { id: id }, { width: 650, onClose: onClose });
	}
};

var MODAL_CREATE_COMPUTER_ORDER = {
	/**
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('create_computer_order', {}, { width: 780, onClose: onClose });
	}
};

var MODAL_FILIALIST_ORDER_PAGE = {
	/**
  * @param {number} id Package ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_order_page', { id: id }, { type: 'window', onClose: onClose });
	}
};

var MODAL_FILIALIST_EXCLUDE_FROM_PARCEL = {
	/**
  * @param {number} id Package ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_exclude_from_parcel', { id: id }, { width: 470, onClose: onClose });
	}
};

var MODAL_FILIALIST_FREE_ORDERS_EDIT = {
	/**
  * @param {number} customerId
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(customerId) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_free_orders_edit', { customer_id: customerId }, { width: 1300, onClose: onClose });
	}
};

var MODAL_FILIALIST_CREATE_TODO = {
	/**
  * @param {number} id
  * @param {string} type
  * @param {Function} onClose
 * @return {ZDialog}
  */
	show: function show(id, type) {
		var onClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_create_todo', { id: id, type: type }, { width: 600, onClose: onClose });
	}
};

var MODAL_FILIALIIST_REASSIGN_PACKAGES_TO_CUSTOMERS = {
	/**
  * @param {number[]} ids
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(ids) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_reassign_packages_to_customers', { ids: ids }, { width: 1800, onClose: onClose });
	}
};

var MODAL_FILIALIST_CHANGE_ASSIGNMENT_CUSTOMER = {
	/**
  * @param {Function} onClose
  * @returns {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_change_assignment_customer', null, { width: 900, onClose: onClose });
	}
};

var MODAL_FILIALIST_EDIT_ASSIGNMENT = {
	/**
  * @param {number} id
  * @param {Function} onClose
  * @returns {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_edit_assignment', { id: id }, { width: 500, onClose: onClose });
	}
};

var MODAL_FILIALIST_GET_ASSIGNMENT_MEEST_DATA = {
	/**
  * @param {string} id
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_get_assignment_meest_data', { id: id }, { width: 450, onClose: onClose });
	}
};

var MODAL_FILIALIST_BATCH_PAYMENT = {
	/**
  * @param {array} ids
 * $param {string} account
  * @param {number} rate
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(ids, account, rate) {
		var onClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_batch_payment', { ids: ids, account: account, rate: rate }, { width: 400, onClose: onClose });
	}
};

var MODAL_FILIALIST_SET_PACKAGE_KINDS = {
	/**
  * @param {number[]} ids
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(ids) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_set_package_kinds', { ids: ids }, { width: 900, onClose: onClose });
	}
};

var MODAL_FILIALIST_SET_MEEST_ADDRESS_ALIASES = {
	/**
  * @param {string[]} cities
  * @param {Object[]} streets
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(cities, streets) {
		var onClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		var data = encodeURIComponent(JSON.stringify({ cities: cities, streets: streets }));
		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_set_meest_address_aliases', { data: data }, { onClose: onClose });
	}
};

var MODAL_ADMIN_REPLENISH_BALANCE = {
	/**
  * @param {number} pendingReplenihmentId
  * @param {number} boundBankTransactionId
  * @param {number} suggestionBondId
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(pendingReplenihmentId) {
		var boundBankTransactionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var suggestionBondId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		var onClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_replenish_balance', {
			pending_replenihment_id: pendingReplenihmentId,
			bound_bank_transaction_id: boundBankTransactionId,
			suggestion_bond_id: suggestionBondId
		}, { onClose: onClose });
	}
};

var MODAL_ADMIN_BATCH_PAYMENT = {
	/**
  * @param {string} accountSource
  * @param {string} accountTarget
  * @param {number} amount
  * @param {number} rate
  * @param {number[]} groupIds
  * @param {number[]} boundBankTransactionIds
  * @param {number} suggestionBondId
  * @param {Function} onClose
  */
	show: function show(accountSource, accountTarget, amount, rate, groupIds, boundBankTransactionIds) {
		var suggestionBondId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
		var onClose = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

		Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_batch_payment', {
			account_source: accountSource,
			account_target: accountTarget,
			amount: amount,
			rate: rate,
			group_ids: groupIds,
			bound_bank_transaction_ids: boundBankTransactionIds,
			suggestion_bond_id: suggestionBondId
		}, { width: 500, onClose: onClose });
	}
};

var MODAL_ADMIN_IMPORT_BANK_STATEMENT = {
	/**
  * @param {Function} onClose
  * @returns {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_import_bank_statement', {}, { width: 800, onClose: onClose });
	}
};

var MODAL_ADMIN_VALIDATE_INVOICE_CSV = {
	/**
  * @param {string | null} name
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show() {
		var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_validate_invoice_csv', { name: name }, { width: 500, onClose: onClose });
	}
};

var MODAL_ADMIN_SHOP_BANK_STATEMENT_KEYWORDS = {
	/**
  * @returns {ZDialog}
  */
	show: function show() {
		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_shop_bank_statement_keywords', {}, { width: 1200 });
	}
};

var MODAL_PACKAGE_INFO = {
	/**
  * @param {number} id Package ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('package_info', { id: id }, { onClose: onClose });
	}
};

var MODAL_SELECT_SHOP_CATEGORY = {
	show: function show(onClose) {
		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('select_shop_category', {}, { width: 550, onClose: onClose });
	}
};

/***/ }),

/***/ "YnTO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = checkIsIframe;
/* harmony export (immutable) */ __webpack_exports__["c"] = isMobile;
/* harmony export (immutable) */ __webpack_exports__["d"] = isTouchScreen;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WEBP_FEATURES; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isWebpFeatureSupported;
/**
 * @return {boolean} TRUE if current window is an iframe window
 */
function checkIsIframe() {
	return window !== window.top;
}

var _isMobile = 'orientation' in window || navigator.userAgent.indexOf('IEMobile') !== -1;
var _isTouchScreen = 'ontouchstart' in window || navigator.msMaxTouchPoints;

function isMobile() {
	return _isMobile;
}

function isTouchScreen() {
	return _isTouchScreen;
}

var WEBP_FEATURES = {
	LOSSY: 'lossy',
	LOSSLESS: 'lossless',
	ALPHA: 'alpha',
	ANIMATION: 'animation'
};

function isWebpFeatureSupported(feature) {
	return new Promise(function (resolve, reject) {
		if (!Object.values(WEBP_FEATURES).includes(feature)) {
			reject('Invalid feature name');
			return;
		}

		var kTestImages = {
			lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
			lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
			alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
			animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
		};
		var img = new Image();
		img.onload = function () {
			var result = img.width > 0 && img.height > 0;
			resolve(result);
		};
		img.onerror = function () {
			resolve(false);
		};
		img.src = "data:image/webp;base64," + kTestImages[feature];
	});
}

/*export class MobileDetect {
	static Android = navigator.userAgent.match(/Android/i);
	static BlackBerry = navigator.userAgent.match(/BlackBerry/i);
	static iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
	static Opera = navigator.userAgent.match(/Opera Mini/i);
	static Windows = navigator.userAgent.match(/IEMobile/i);
	static Any = MobileDetect.Android || MobileDetect.BlackBerry || MobileDetect.iOS || MobileDetect.Opera || MobileDetect.Windows;
}*/

/***/ }),

/***/ "ZQ2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Factory */
/* unused harmony export BaseCategoryList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SubcategoryList; });
/* unused harmony export BaseCategoryItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SubcategoryItem; });
/* unused harmony export FakeCategoryItem */
/* unused harmony export CategoryGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PopularShopItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lists__ = __webpack_require__("7DQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_var__ = __webpack_require__("dTkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data__ = __webpack_require__("m9tG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_utils_lang__ = __webpack_require__("RaK1");
var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var Factory = function () {
	function Factory() {
		_classCallCheck(this, Factory);
	}

	_createClass(Factory, [{
		key: "newCategoryItem",
		value: function newCategoryItem(itemData) {
			if (itemData.id == 0) {
				return new FakeCategoryItem(itemData);
			}
			return new CategoryItem(itemData);
		}
	}]);

	return Factory;
}();

var BaseCategoryList = function (_List) {
	_inherits(BaseCategoryList, _List);

	function BaseCategoryList() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		_classCallCheck(this, BaseCategoryList);

		var _this = _possibleConstructorReturn(this, (BaseCategoryList.__proto__ || Object.getPrototypeOf(BaseCategoryList)).call(this, _extends({ name: 'categories', title: Object(__WEBPACK_IMPORTED_MODULE_6__core_utils_lang__["a" /* lang */])('shop_filter_category') }, data)));

		_this._selected = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.first(_this.selectedItems);
		});
		_this._sortType = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable();


		_this._groupedItems = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.pureComputed(function () {
			var groupedItems = {};
			var groupsIndex = {};
			_this.visibleItems.forEach(function (item) {
				/** @type {BaseCategoryItem} */
				var cat = item;
				if (cat.groups) {
					cat.groups.forEach(function (cg) {
						if (!groupedItems[cg.id]) {
							groupedItems[cg.id] = [];
							groupsIndex[cg.id] = cg;
						}
						groupedItems[cg.id].push(cat);
					});
				} else {
					/*if (!groupedItems[0]) {
     	groupedItems[0] = [];
     	groupsIndex[0] = new CategoryGroup({id:0, name: 'nogroup', title: 'Без группы', order: Number.MAX_VALUE});
     }
     groupedItems[0].push(cat);*/
				}
			});

			var arr = [];
			__WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(groupedItems, function (items, groupId) {
				var group = groupsIndex[groupId];
				arr.push({
					group: group,
					items: items
				});
			});
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.sortBy(arr, function (item) {
				return item.group.order;
			});
		});
		return _this;
	}

	/**
  * @return {T}
  */


	_createClass(BaseCategoryList, [{
		key: "sortFunction",


		/**
   * @param {BaseCategoryItem} item1
   * @param {BaseCategoryItem} item2
   * @return {number}
   */
		value: function sortFunction(item1, item2) {
			// default is "by order ascending"
			var order = item1.order - item2.order;
			if (this.sortType === 'count') {
				var orderByCount = item2.count - item1.count;
				return orderByCount !== 0 ? orderByCount : order;
			} else {
				return order;
			}
		}
	}, {
		key: "selected",
		get: function get() {
			return this._selected();
		}

		/**
   *
   * @return {array}
   */

	}, {
		key: "groupedItems",
		get: function get() {
			return this._groupedItems();
		}
	}, {
		key: "sortType",
		get: function get() {
			return this._sortType();
		},
		set: function set(value) {
			this._sortType(value);
		}
	}]);

	return BaseCategoryList;
}(__WEBPACK_IMPORTED_MODULE_2__lists__["b" /* List */]);

var CategoryList = function (_BaseCategoryList) {
	_inherits(CategoryList, _BaseCategoryList);

	function CategoryList() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		_classCallCheck(this, CategoryList);

		// fix context for methods that are used in knockout bindings
		var _this2 = _possibleConstructorReturn(this, (CategoryList.__proto__ || Object.getPrototypeOf(CategoryList)).call(this, _extends({ name: 'categories', title: 'Категория' }, data)));

		_this2._allItemsIndex = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable({});
		_this2._categoryGroupsIndex = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable();
		_this2._activeItem = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable();
		_this2.handleMouseOver = _this2.handleMouseOver.bind(_this2);

		_this2._activeItemComputed = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.pureComputed(function () {
			var item = _this2._activeItem();
			if (item && __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.contains(_this2.visibleItems, item)) {
				return item;
			} else {
				return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.first(_this2.visibleItems);
			}
		});
		return _this2;
	}

	/**
  *
  * @param data
  * @param categoryGroups
  * @return {*}
  */


	_createClass(CategoryList, [{
		key: "init",
		value: function init(data, categoryGroups) {
			if (categoryGroups) {
				var categoryGroupsIndex = {};
				categoryGroups.map(function (item) {
					var cg = new CategoryGroup(item);
					categoryGroupsIndex[cg.id] = cg;
					return cg;
				});
				this._categoryGroupsIndex(categoryGroupsIndex);
			} else {
				this._categoryGroupsIndex(null);
			}

			_get(CategoryList.prototype.__proto__ || Object.getPrototypeOf(CategoryList.prototype), "init", this).call(this, data);
		}
	}, {
		key: "initItems",
		value: function initItems(itemsData) {
			_get(CategoryList.prototype.__proto__ || Object.getPrototypeOf(CategoryList.prototype), "initItems", this).call(this, itemsData);

			var allItems = {};
			this.items.forEach(function (item) {
				/** @type {CategoryItem} */
				var cat = item;
				allItems[cat.id] = cat;
				cat.subcategories.items.forEach(function (i) {
					return allItems[i.id] = i;
				});
			});
			this._allItemsIndex(allItems);
		}
	}, {
		key: "newItem",
		value: function newItem(itemData) {
			var _this3 = this;

			var d = _extends({}, itemData, {
				url: __WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].getCategoryUrl(itemData.name),
				groups: itemData.group_ids && this._categoryGroupsIndex() ? __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(itemData.group_ids, function (id) {
					return _this3._categoryGroupsIndex()[id];
				}) : null
			});

			var cat = void 0;
			if (d.id == 0) {
				cat = new FakeCategoryItem(d);
			} else {
				cat = new CategoryItem(d);
			}
			var subcatData = void 0;
			if (d.subcategories) {
				subcatData = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(d.subcategories, function (d) {
					var groups = d.group_ids && _this3._categoryGroupsIndex() ? __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(d.group_ids, function (id) {
						return _this3._categoryGroupsIndex()[id];
					}) : null;
					return _extends({}, d, {
						groups: groups
					});
				});
			}
			cat.subcategories = this.newSubcategoryList(subcatData, cat);
			if (subcatData) {
				cat.subcategories.init(subcatData);
				cat.subcategories.onItemClick(function (item) {
					return _this3.handleClick(item);
				});
			}
			return cat;
		}
	}, {
		key: "newSubcategoryList",
		value: function newSubcategoryList(data, category) {
			return new SubcategoryList(data, category, this);
		}
	}, {
		key: "resetCounts",
		value: function resetCounts() {
			__WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.each(this.items, function (item) {
				item.count = 0;
				item.subcategories.resetCounts();
			});
		}
	}, {
		key: "updateCounts",
		value: function updateCounts(data) {
			__WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.each(this._allItemsIndex(), function (item) {
				item.count = data ? Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_var__["c" /* asNumber */])(data[item.id]) : 0;
			});
		}

		/**
   * Returns ether category or subcategory by ID
   * @param {number} id
   * @return {CategoryItem|SubcategoryItem}
   */

	}, {
		key: "getAnyItem",
		value: function getAnyItem(id) {
			return this._allItemsIndex()[id];
		}
	}, {
		key: "handleMouseOver",


		/**
   * @param {CategoryItem} item
   */
		value: function handleMouseOver(item) {
			this._activeItem(item);
		}

		/**
  * Force subcategories panel to repaint itself
  * (Fix for strange bug introduced in the last Chrome update)
   */

	}, {
		key: "refresh",
		value: function refresh() {
			var active = this._activeItem();
			this._activeItem(null);
			this._activeItem(active);
		}
	}, {
		key: "activeItem",
		get: function get() {
			return this._activeItemComputed();
		}
	}]);

	return CategoryList;
}(BaseCategoryList);

var SubcategoryList = function (_BaseCategoryList2) {
	_inherits(SubcategoryList, _BaseCategoryList2);

	/**
  * @param {object} data
  * @param {CategoryItem} category
  * @param {CategoryList} categoryList
  */
	function SubcategoryList(data, category, categoryList) {
		_classCallCheck(this, SubcategoryList);

		var _this4 = _possibleConstructorReturn(this, (SubcategoryList.__proto__ || Object.getPrototypeOf(SubcategoryList)).call(this, _extends({ name: 'subcategories', title: 'Категория' }, data)));

		_this4._category = category;
		_this4._categoryList = categoryList;
		return _this4;
	}

	_createClass(SubcategoryList, [{
		key: "newItem",
		value: function newItem(itemData) {
			var d = _extends({}, itemData, {
				url: __WEBPACK_IMPORTED_MODULE_5__data__["b" /* settings */].getCategoryUrl(this._category.name, itemData.name)
			});
			return new SubcategoryItem(d, this._category);
		}
	}, {
		key: "sortType",
		get: function get() {
			// use the same as category list
			return this._categoryList.sortType;
		}
	}, {
		key: "category",
		get: function get() {
			return this._category;
		}
	}]);

	return SubcategoryList;
}(BaseCategoryList);

var BaseCategoryItem = function (_ListItem) {
	_inherits(BaseCategoryItem, _ListItem);

	function BaseCategoryItem(data) {
		_classCallCheck(this, BaseCategoryItem);

		var _this5 = _possibleConstructorReturn(this, (BaseCategoryItem.__proto__ || Object.getPrototypeOf(BaseCategoryItem)).call(this, data));

		_this5._url = data.url;
		_this5._order = data.order || 0;
		_this5._groups = data.groups;
		return _this5;
	}

	/**
  * @return {string}
  */


	_createClass(BaseCategoryItem, [{
		key: "url",
		get: function get() {
			return this._url;
		}

		/**
   * @return {number}
   */

	}, {
		key: "order",
		get: function get() {
			return this._order;
		}

		/**
   * @return {CategoryGroup[]}
   */

	}, {
		key: "groups",
		get: function get() {
			return this._groups;
		}
	}, {
		key: "disabled",
		get: function get() {
			return this.count == 0;
		}
	}]);

	return BaseCategoryItem;
}(__WEBPACK_IMPORTED_MODULE_2__lists__["c" /* ListItem */]);

var CategoryItem = function (_BaseCategoryItem) {
	_inherits(CategoryItem, _BaseCategoryItem);

	function CategoryItem(data) {
		_classCallCheck(this, CategoryItem);

		var _this6 = _possibleConstructorReturn(this, (CategoryItem.__proto__ || Object.getPrototypeOf(CategoryItem)).call(this, data));

		_this6._subcategories = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.observable();
		_this6._popularShops = [];

		_this6._subcategoriesCountSum = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.pureComputed(function () {
			var sum = 0;
			_this6.subcategories.items.forEach(function (s) {
				return sum += s.count;
			});
			return sum;
		});
		if (!__WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.isUndefined(data.popular_shops)) {
			_this6._popularShops = __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.map(data.popular_shops, function (s) {
				return new PopularShopItem(s, _this6);
			});
		}
		return _this6;
	}

	_createClass(CategoryItem, [{
		key: "count",
		get: function get() {
			return this._subcategoriesCountSum();
		},
		set: function set(value) {}
		// do nothing


		/**
   * @return {SubcategoryList}
   */

	}, {
		key: "subcategories",
		get: function get() {
			return this._subcategories();
		}

		/**
   * @param {SubcategoryList} value
   */
		,
		set: function set(value) {
			this._subcategories(value);
		}

		/** @type {PopularShopItem[]} */

	}, {
		key: "popularShops",
		get: function get() {
			return this._popularShops;
		}
	}]);

	return CategoryItem;
}(BaseCategoryItem);

var SubcategoryItem = function (_BaseCategoryItem2) {
	_inherits(SubcategoryItem, _BaseCategoryItem2);

	/**
  * @param {object} data
  * @param {CategoryItem} category
  */
	function SubcategoryItem(data, category) {
		_classCallCheck(this, SubcategoryItem);

		var _this7 = _possibleConstructorReturn(this, (SubcategoryItem.__proto__ || Object.getPrototypeOf(SubcategoryItem)).call(this, data));

		_this7._category = category;
		return _this7;
	}

	/**
  * @return {CategoryItem}
  */


	_createClass(SubcategoryItem, [{
		key: "category",
		get: function get() {
			return this._category;
		}
	}]);

	return SubcategoryItem;
}(BaseCategoryItem);

var FakeCategoryItem = function (_CategoryItem) {
	_inherits(FakeCategoryItem, _CategoryItem);

	function FakeCategoryItem(data) {
		_classCallCheck(this, FakeCategoryItem);

		return _possibleConstructorReturn(this, (FakeCategoryItem.__proto__ || Object.getPrototypeOf(FakeCategoryItem)).call(this, data));
	}

	_createClass(FakeCategoryItem, [{
		key: "count",
		get: function get() {
			return this._count();
		},
		set: function set(value) {
			this._count(value);
		}
	}, {
		key: "order",
		get: function get() {
			return Number.MAX_VALUE;
		}
	}]);

	return FakeCategoryItem;
}(CategoryItem);

var CategoryGroup = function () {
	function CategoryGroup(data) {
		_classCallCheck(this, CategoryGroup);

		this._id = data.id;
		this._name = data.name;
		this._title = data.title;
		this._order = data.order;
	}

	_createClass(CategoryGroup, [{
		key: "id",
		get: function get() {
			return this._id;
		}
	}, {
		key: "name",
		get: function get() {
			return this._name;
		}
	}, {
		key: "title",
		get: function get() {
			return this._title;
		}
	}, {
		key: "order",
		get: function get() {
			return this._order;
		}
	}]);

	return CategoryGroup;
}();

var PopularShopItem = function () {
	/**
  * @param {object} data
  * @param {CategoryItem} category
  */
	function PopularShopItem(data, category) {
		_classCallCheck(this, PopularShopItem);

		this._id = +data.id;
		this._title = data.title;
		this._logo = data.logo;
		this._url = data.url || __WEBPACK_IMPORTED_MODULE_3__core_utils_url__["f" /* joinPath */](category.url, { shop: data.id });
		this._category = category;
	}

	/** @return {number} */


	_createClass(PopularShopItem, [{
		key: "id",
		get: function get() {
			return this._id;
		}

		/** @return {string} */

	}, {
		key: "title",
		get: function get() {
			return this._title;
		}

		/** @return {string} */

	}, {
		key: "logo",
		get: function get() {
			return this._logo;
		}

		/** @return {string} */

	}, {
		key: "url",
		get: function get() {
			return this._url;
		}

		/** @return {CategoryItem} */

	}, {
		key: "category",
		get: function get() {
			return this._category;
		}
	}]);

	return PopularShopItem;
}();

/***/ }),

/***/ "b/Fu":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Ion.RangeSlider
// version 2.2.0 Build: 380
// © Denis Ineshin, 2017
// https://github.com/IonDen
//
// Project page:    http://ionden.com/a/plugins/ion.rangeSlider/en.html
// GitHub page:     https://github.com/IonDen/ion.rangeSlider
//
// Released under MIT licence:
// http://ionden.com/a/plugins/licence-en.html
// =====================================================================================================================

;(function(factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("0iPh")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (jQuery) {
            return factory(jQuery, document, window, navigator);
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === "object") {
        factory(require("jquery"), document, window, navigator);
    } else {
        factory(jQuery, document, window, navigator);
    }
} (function ($, document, window, navigator, undefined) {
    "use strict";

    // =================================================================================================================
    // Service

    var plugin_count = 0;

    // IE8 fix
    var is_old_ie = (function () {
        var n = navigator.userAgent,
            r = /msie\s\d+/i,
            v;
        if (n.search(r) > 0) {
            v = r.exec(n).toString();
            v = v.split(" ")[1];
            if (v < 9) {
                $("html").addClass("lt-ie9");
                return true;
            }
        }
        return false;
    } ());
    if (!Function.prototype.bind) {
        Function.prototype.bind = function bind(that) {

            var target = this;
            var slice = [].slice;

            if (typeof target != "function") {
                throw new TypeError();
            }

            var args = slice.call(arguments, 1),
                bound = function () {

                    if (this instanceof bound) {

                        var F = function(){};
                        F.prototype = target.prototype;
                        var self = new F();

                        var result = target.apply(
                            self,
                            args.concat(slice.call(arguments))
                        );
                        if (Object(result) === result) {
                            return result;
                        }
                        return self;

                    } else {

                        return target.apply(
                            that,
                            args.concat(slice.call(arguments))
                        );

                    }

                };

            return bound;
        };
    }
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function(searchElement, fromIndex) {
            var k;
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var O = Object(this);
            var len = O.length >>> 0;
            if (len === 0) {
                return -1;
            }
            var n = +fromIndex || 0;
            if (Math.abs(n) === Infinity) {
                n = 0;
            }
            if (n >= len) {
                return -1;
            }
            k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
            while (k < len) {
                if (k in O && O[k] === searchElement) {
                    return k;
                }
                k++;
            }
            return -1;
        };
    }



    // =================================================================================================================
    // Template

    var base_html =
        '<span class="irs">' +
        '<span class="irs-line" tabindex="0"><span class="irs-line-left"></span><span class="irs-line-mid"></span><span class="irs-line-right"></span></span>' +
        '<span class="irs-min">0</span><span class="irs-max">1</span>' +
        '<span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span>' +
        '</span>' +
        '<span class="irs-grid"></span>' +
        '<span class="irs-bar"></span>';

    var single_html =
        '<span class="irs-bar-edge"></span>' +
        '<span class="irs-shadow shadow-single"></span>' +
        '<span class="irs-slider single"></span>';

    var double_html =
        '<span class="irs-shadow shadow-from"></span>' +
        '<span class="irs-shadow shadow-to"></span>' +
        '<span class="irs-slider from"></span>' +
        '<span class="irs-slider to"></span>';

    var disable_html =
        '<span class="irs-disable-mask"></span>';



    // =================================================================================================================
    // Core

    /**
     * Main plugin constructor
     *
     * @param input {Object} link to base input element
     * @param options {Object} slider config
     * @param plugin_count {Number}
     * @constructor
     */
    var IonRangeSlider = function (input, options, plugin_count) {
        this.VERSION = "2.2.0";
        this.input = input;
        this.plugin_count = plugin_count;
        this.current_plugin = 0;
        this.calc_count = 0;
        this.update_tm = 0;
        this.old_from = 0;
        this.old_to = 0;
        this.old_min_interval = null;
        this.raf_id = null;
        this.dragging = false;
        this.force_redraw = false;
        this.no_diapason = false;
        this.has_tab_index = true;
        this.is_key = false;
        this.is_update = false;
        this.is_start = true;
        this.is_finish = false;
        this.is_active = false;
        this.is_resize = false;
        this.is_click = false;

        options = options || {};

        // cache for links to all DOM elements
        this.$cache = {
            win: $(window),
            body: $(document.body),
            input: $(input),
            cont: null,
            rs: null,
            min: null,
            max: null,
            from: null,
            to: null,
            single: null,
            bar: null,
            line: null,
            s_single: null,
            s_from: null,
            s_to: null,
            shad_single: null,
            shad_from: null,
            shad_to: null,
            edge: null,
            grid: null,
            grid_labels: []
        };

        // storage for measure variables
        this.coords = {
            // left
            x_gap: 0,
            x_pointer: 0,

            // width
            w_rs: 0,
            w_rs_old: 0,
            w_handle: 0,

            // percents
            p_gap: 0,
            p_gap_left: 0,
            p_gap_right: 0,
            p_step: 0,
            p_pointer: 0,
            p_handle: 0,
            p_single_fake: 0,
            p_single_real: 0,
            p_from_fake: 0,
            p_from_real: 0,
            p_to_fake: 0,
            p_to_real: 0,
            p_bar_x: 0,
            p_bar_w: 0,

            // grid
            grid_gap: 0,
            big_num: 0,
            big: [],
            big_w: [],
            big_p: [],
            big_x: []
        };

        // storage for labels measure variables
        this.labels = {
            // width
            w_min: 0,
            w_max: 0,
            w_from: 0,
            w_to: 0,
            w_single: 0,

            // percents
            p_min: 0,
            p_max: 0,
            p_from_fake: 0,
            p_from_left: 0,
            p_to_fake: 0,
            p_to_left: 0,
            p_single_fake: 0,
            p_single_left: 0
        };



        /**
         * get and validate config
         */
        var $inp = this.$cache.input,
            val = $inp.prop("value"),
            config, config_from_data, prop;

        // default config
        config = {
            type: "single",

            min: 10,
            max: 100,
            from: null,
            to: null,
            step: 1,

            min_interval: 0,
            max_interval: 0,
            drag_interval: false,

            values: [],
            p_values: [],

            from_fixed: false,
            from_min: null,
            from_max: null,
            from_shadow: false,

            to_fixed: false,
            to_min: null,
            to_max: null,
            to_shadow: false,

            prettify_enabled: true,
            prettify_separator: " ",
            prettify: null,

            force_edges: false,

            keyboard: true,

            grid: false,
            grid_margin: true,
            grid_num: 4,
            grid_snap: false,

            hide_min_max: false,
            hide_from_to: false,

            prefix: "",
            postfix: "",
            max_postfix: "",
            decorate_both: true,
            values_separator: " — ",

            input_values_separator: ";",

            disable: false,
            block: false,

            extra_classes: "",

            scope: null,
            onStart: null,
            onChange: null,
            onFinish: null,
            onUpdate: null
        };


        // check if base element is input
        if ($inp[0].nodeName !== "INPUT") {
            console && console.warn && console.warn("Base element should be <input>!", $inp[0]);
        }


        // config from data-attributes extends js config
        config_from_data = {
            type: $inp.data("type"),

            min: $inp.data("min"),
            max: $inp.data("max"),
            from: $inp.data("from"),
            to: $inp.data("to"),
            step: $inp.data("step"),

            min_interval: $inp.data("minInterval"),
            max_interval: $inp.data("maxInterval"),
            drag_interval: $inp.data("dragInterval"),

            values: $inp.data("values"),

            from_fixed: $inp.data("fromFixed"),
            from_min: $inp.data("fromMin"),
            from_max: $inp.data("fromMax"),
            from_shadow: $inp.data("fromShadow"),

            to_fixed: $inp.data("toFixed"),
            to_min: $inp.data("toMin"),
            to_max: $inp.data("toMax"),
            to_shadow: $inp.data("toShadow"),

            prettify_enabled: $inp.data("prettifyEnabled"),
            prettify_separator: $inp.data("prettifySeparator"),

            force_edges: $inp.data("forceEdges"),

            keyboard: $inp.data("keyboard"),

            grid: $inp.data("grid"),
            grid_margin: $inp.data("gridMargin"),
            grid_num: $inp.data("gridNum"),
            grid_snap: $inp.data("gridSnap"),

            hide_min_max: $inp.data("hideMinMax"),
            hide_from_to: $inp.data("hideFromTo"),

            prefix: $inp.data("prefix"),
            postfix: $inp.data("postfix"),
            max_postfix: $inp.data("maxPostfix"),
            decorate_both: $inp.data("decorateBoth"),
            values_separator: $inp.data("valuesSeparator"),

            input_values_separator: $inp.data("inputValuesSeparator"),

            disable: $inp.data("disable"),
            block: $inp.data("block"),

            extra_classes: $inp.data("extraClasses"),
        };
        config_from_data.values = config_from_data.values && config_from_data.values.split(",");

        for (prop in config_from_data) {
            if (config_from_data.hasOwnProperty(prop)) {
                if (config_from_data[prop] === undefined || config_from_data[prop] === "") {
                    delete config_from_data[prop];
                }
            }
        }


        // input value extends default config
        if (val !== undefined && val !== "") {
            val = val.split(config_from_data.input_values_separator || options.input_values_separator || ";");

            if (val[0] && val[0] == +val[0]) {
                val[0] = +val[0];
            }
            if (val[1] && val[1] == +val[1]) {
                val[1] = +val[1];
            }

            if (options && options.values && options.values.length) {
                config.from = val[0] && options.values.indexOf(val[0]);
                config.to = val[1] && options.values.indexOf(val[1]);
            } else {
                config.from = val[0] && +val[0];
                config.to = val[1] && +val[1];
            }
        }



        // js config extends default config
        $.extend(config, options);


        // data config extends config
        $.extend(config, config_from_data);
        this.options = config;



        // validate config, to be sure that all data types are correct
        this.update_check = {};
        this.validate();



        // default result object, returned to callbacks
        this.result = {
            input: this.$cache.input,
            slider: null,

            min: this.options.min,
            max: this.options.max,

            from: this.options.from,
            from_percent: 0,
            from_value: null,

            to: this.options.to,
            to_percent: 0,
            to_value: null
        };



        this.init();
    };

    IonRangeSlider.prototype = {

        /**
         * Starts or updates the plugin instance
         *
         * @param [is_update] {boolean}
         */
        init: function (is_update) {
            this.no_diapason = false;
            this.coords.p_step = this.convertToPercent(this.options.step, true);

            this.target = "base";

            this.toggleInput();
            this.append();
            this.setMinMax();

            if (is_update) {
                this.force_redraw = true;
                this.calc(true);

                // callbacks called
                this.callOnUpdate();
            } else {
                this.force_redraw = true;
                this.calc(true);

                // callbacks called
                this.callOnStart();
            }

            this.updateScene();
        },

        /**
         * Appends slider template to a DOM
         */
        append: function () {
            var container_html = '<span class="irs js-irs-' + this.plugin_count + ' ' + this.options.extra_classes + '"></span>';
            this.$cache.input.before(container_html);
            this.$cache.input.prop("readonly", true);
            this.$cache.cont = this.$cache.input.prev();
            this.result.slider = this.$cache.cont;

            this.$cache.cont.html(base_html);
            this.$cache.rs = this.$cache.cont.find(".irs");
            this.$cache.min = this.$cache.cont.find(".irs-min");
            this.$cache.max = this.$cache.cont.find(".irs-max");
            this.$cache.from = this.$cache.cont.find(".irs-from");
            this.$cache.to = this.$cache.cont.find(".irs-to");
            this.$cache.single = this.$cache.cont.find(".irs-single");
            this.$cache.bar = this.$cache.cont.find(".irs-bar");
            this.$cache.line = this.$cache.cont.find(".irs-line");
            this.$cache.grid = this.$cache.cont.find(".irs-grid");

            if (this.options.type === "single") {
                this.$cache.cont.append(single_html);
                this.$cache.edge = this.$cache.cont.find(".irs-bar-edge");
                this.$cache.s_single = this.$cache.cont.find(".single");
                this.$cache.from[0].style.visibility = "hidden";
                this.$cache.to[0].style.visibility = "hidden";
                this.$cache.shad_single = this.$cache.cont.find(".shadow-single");
            } else {
                this.$cache.cont.append(double_html);
                this.$cache.s_from = this.$cache.cont.find(".from");
                this.$cache.s_to = this.$cache.cont.find(".to");
                this.$cache.shad_from = this.$cache.cont.find(".shadow-from");
                this.$cache.shad_to = this.$cache.cont.find(".shadow-to");

                this.setTopHandler();
            }

            if (this.options.hide_from_to) {
                this.$cache.from[0].style.display = "none";
                this.$cache.to[0].style.display = "none";
                this.$cache.single[0].style.display = "none";
            }

            this.appendGrid();

            if (this.options.disable) {
                this.appendDisableMask();
                this.$cache.input[0].disabled = true;
            } else {
                this.$cache.input[0].disabled = false;
                this.removeDisableMask();
                this.bindEvents();
            }

            // block only if not disabled
            if (!this.options.disable) {
                if (this.options.block) {
                    this.appendDisableMask();
                } else {
                    this.removeDisableMask();
                }
            }

            if (this.options.drag_interval) {
                this.$cache.bar[0].style.cursor = "ew-resize";
            }
        },

        /**
         * Determine which handler has a priority
         * works only for double slider type
         */
        setTopHandler: function () {
            var min = this.options.min,
                max = this.options.max,
                from = this.options.from,
                to = this.options.to;

            if (from > min && to === max) {
                this.$cache.s_from.addClass("type_last");
            } else if (to < max) {
                this.$cache.s_to.addClass("type_last");
            }
        },

        /**
         * Determine which handles was clicked last
         * and which handler should have hover effect
         *
         * @param target {String}
         */
        changeLevel: function (target) {
            switch (target) {
                case "single":
                    this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_single_fake);
                    this.$cache.s_single.addClass("state_hover");
                    break;
                case "from":
                    this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake);
                    this.$cache.s_from.addClass("state_hover");
                    this.$cache.s_from.addClass("type_last");
                    this.$cache.s_to.removeClass("type_last");
                    break;
                case "to":
                    this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_to_fake);
                    this.$cache.s_to.addClass("state_hover");
                    this.$cache.s_to.addClass("type_last");
                    this.$cache.s_from.removeClass("type_last");
                    break;
                case "both":
                    this.coords.p_gap_left = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake);
                    this.coords.p_gap_right = this.toFixed(this.coords.p_to_fake - this.coords.p_pointer);
                    this.$cache.s_to.removeClass("type_last");
                    this.$cache.s_from.removeClass("type_last");
                    break;
            }
        },

        /**
         * Then slider is disabled
         * appends extra layer with opacity
         */
        appendDisableMask: function () {
            this.$cache.cont.append(disable_html);
            this.$cache.cont.addClass("irs-disabled");
        },

        /**
         * Then slider is not disabled
         * remove disable mask
         */
        removeDisableMask: function () {
            this.$cache.cont.remove(".irs-disable-mask");
            this.$cache.cont.removeClass("irs-disabled");
        },

        /**
         * Remove slider instance
         * and unbind all events
         */
        remove: function () {
            this.$cache.cont.remove();
            this.$cache.cont = null;

            this.$cache.line.off("keydown.irs_" + this.plugin_count);

            this.$cache.body.off("touchmove.irs_" + this.plugin_count);
            this.$cache.body.off("mousemove.irs_" + this.plugin_count);

            this.$cache.win.off("touchend.irs_" + this.plugin_count);
            this.$cache.win.off("mouseup.irs_" + this.plugin_count);

            if (is_old_ie) {
                this.$cache.body.off("mouseup.irs_" + this.plugin_count);
                this.$cache.body.off("mouseleave.irs_" + this.plugin_count);
            }

            this.$cache.grid_labels = [];
            this.coords.big = [];
            this.coords.big_w = [];
            this.coords.big_p = [];
            this.coords.big_x = [];

            cancelAnimationFrame(this.raf_id);
        },

        /**
         * bind all slider events
         */
        bindEvents: function () {
            if (this.no_diapason) {
                return;
            }

            this.$cache.body.on("touchmove.irs_" + this.plugin_count, this.pointerMove.bind(this));
            this.$cache.body.on("mousemove.irs_" + this.plugin_count, this.pointerMove.bind(this));

            this.$cache.win.on("touchend.irs_" + this.plugin_count, this.pointerUp.bind(this));
            this.$cache.win.on("mouseup.irs_" + this.plugin_count, this.pointerUp.bind(this));

            this.$cache.line.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
            this.$cache.line.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));

            this.$cache.line.on("focus.irs_" + this.plugin_count, this.pointerFocus.bind(this));

            if (this.options.drag_interval && this.options.type === "double") {
                this.$cache.bar.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "both"));
                this.$cache.bar.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "both"));
            } else {
                this.$cache.bar.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
                this.$cache.bar.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
            }

            if (this.options.type === "single") {
                this.$cache.single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
                this.$cache.s_single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
                this.$cache.shad_single.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));

                this.$cache.single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
                this.$cache.s_single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
                this.$cache.edge.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
                this.$cache.shad_single.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
            } else {
                this.$cache.single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, null));
                this.$cache.single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, null));

                this.$cache.from.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
                this.$cache.s_from.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
                this.$cache.to.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
                this.$cache.s_to.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
                this.$cache.shad_from.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
                this.$cache.shad_to.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));

                this.$cache.from.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
                this.$cache.s_from.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
                this.$cache.to.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
                this.$cache.s_to.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
                this.$cache.shad_from.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
                this.$cache.shad_to.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
            }

            if (this.options.keyboard) {
                this.$cache.line.on("keydown.irs_" + this.plugin_count, this.key.bind(this, "keyboard"));
            }

            if (is_old_ie) {
                this.$cache.body.on("mouseup.irs_" + this.plugin_count, this.pointerUp.bind(this));
                this.$cache.body.on("mouseleave.irs_" + this.plugin_count, this.pointerUp.bind(this));
            }
        },

        /**
         * Focus with tabIndex
         *
         * @param e {Object} event object
         */
        pointerFocus: function (e) {
            if (!this.target) {
                var x;
                var $handle;

                if (this.options.type === "single") {
                    $handle = this.$cache.single;
                } else {
                    $handle = this.$cache.from;
                }

                x = $handle.offset().left;
                x += ($handle.width() / 2) - 1;

                this.pointerClick("single", {preventDefault: function () {}, pageX: x});
            }
        },

        /**
         * Mousemove or touchmove
         * only for handlers
         *
         * @param e {Object} event object
         */
        pointerMove: function (e) {
            if (!this.dragging) {
                return;
            }

            var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;
            this.coords.x_pointer = x - this.coords.x_gap;

            this.calc();
        },

        /**
         * Mouseup or touchend
         * only for handlers
         *
         * @param e {Object} event object
         */
        pointerUp: function (e) {
            if (this.current_plugin !== this.plugin_count) {
                return;
            }

            if (this.is_active) {
                this.is_active = false;
            } else {
                return;
            }

            this.$cache.cont.find(".state_hover").removeClass("state_hover");

            this.force_redraw = true;

            if (is_old_ie) {
                $("*").prop("unselectable", false);
            }

            this.updateScene();
            this.restoreOriginalMinInterval();

            // callbacks call
            if ($.contains(this.$cache.cont[0], e.target) || this.dragging) {
                this.callOnFinish();
            }
            
            this.dragging = false;
        },

        /**
         * Mousedown or touchstart
         * only for handlers
         *
         * @param target {String|null}
         * @param e {Object} event object
         */
        pointerDown: function (target, e) {
            e.preventDefault();
            var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;
            if (e.button === 2) {
                return;
            }

            if (target === "both") {
                this.setTempMinInterval();
            }

            if (!target) {
                target = this.target || "from";
            }

            this.current_plugin = this.plugin_count;
            this.target = target;

            this.is_active = true;
            this.dragging = true;

            this.coords.x_gap = this.$cache.rs.offset().left;
            this.coords.x_pointer = x - this.coords.x_gap;

            this.calcPointerPercent();
            this.changeLevel(target);

            if (is_old_ie) {
                $("*").prop("unselectable", true);
            }

            this.$cache.line.trigger("focus");

            this.updateScene();
        },

        /**
         * Mousedown or touchstart
         * for other slider elements, like diapason line
         *
         * @param target {String}
         * @param e {Object} event object
         */
        pointerClick: function (target, e) {
            e.preventDefault();
            var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;
            if (e.button === 2) {
                return;
            }

            this.current_plugin = this.plugin_count;
            this.target = target;

            this.is_click = true;
            this.coords.x_gap = this.$cache.rs.offset().left;
            this.coords.x_pointer = +(x - this.coords.x_gap).toFixed();

            this.force_redraw = true;
            this.calc();

            this.$cache.line.trigger("focus");
        },

        /**
         * Keyborard controls for focused slider
         *
         * @param target {String}
         * @param e {Object} event object
         * @returns {boolean|undefined}
         */
        key: function (target, e) {
            if (this.current_plugin !== this.plugin_count || e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
                return;
            }

            switch (e.which) {
                case 83: // W
                case 65: // A
                case 40: // DOWN
                case 37: // LEFT
                    e.preventDefault();
                    this.moveByKey(false);
                    break;

                case 87: // S
                case 68: // D
                case 38: // UP
                case 39: // RIGHT
                    e.preventDefault();
                    this.moveByKey(true);
                    break;
            }

            return true;
        },

        /**
         * Move by key
         *
         * @param right {boolean} direction to move
         */
        moveByKey: function (right) {
            var p = this.coords.p_pointer;
            var p_step = (this.options.max - this.options.min) / 100;
            p_step = this.options.step / p_step;

            if (right) {
                p += p_step;
            } else {
                p -= p_step;
            }

            this.coords.x_pointer = this.toFixed(this.coords.w_rs / 100 * p);
            this.is_key = true;
            this.calc();
        },

        /**
         * Set visibility and content
         * of Min and Max labels
         */
        setMinMax: function () {
            if (!this.options) {
                return;
            }

            if (this.options.hide_min_max) {
                this.$cache.min[0].style.display = "none";
                this.$cache.max[0].style.display = "none";
                return;
            }

            if (this.options.values.length) {
                this.$cache.min.html(this.decorate(this.options.p_values[this.options.min]));
                this.$cache.max.html(this.decorate(this.options.p_values[this.options.max]));
            } else {
                var min_pretty = this._prettify(this.options.min);
                var max_pretty = this._prettify(this.options.max);

                this.result.min_pretty = min_pretty;
                this.result.max_pretty = max_pretty;

                this.$cache.min.html(this.decorate(min_pretty, this.options.min));
                this.$cache.max.html(this.decorate(max_pretty, this.options.max));
            }

            this.labels.w_min = this.$cache.min.outerWidth(false);
            this.labels.w_max = this.$cache.max.outerWidth(false);
        },

        /**
         * Then dragging interval, prevent interval collapsing
         * using min_interval option
         */
        setTempMinInterval: function () {
            var interval = this.result.to - this.result.from;

            if (this.old_min_interval === null) {
                this.old_min_interval = this.options.min_interval;
            }

            this.options.min_interval = interval;
        },

        /**
         * Restore min_interval option to original
         */
        restoreOriginalMinInterval: function () {
            if (this.old_min_interval !== null) {
                this.options.min_interval = this.old_min_interval;
                this.old_min_interval = null;
            }
        },



        // =============================================================================================================
        // Calculations

        /**
         * All calculations and measures start here
         *
         * @param update {boolean=}
         */
        calc: function (update) {
            if (!this.options) {
                return;
            }

            this.calc_count++;

            if (this.calc_count === 10 || update) {
                this.calc_count = 0;
                this.coords.w_rs = this.$cache.rs.outerWidth(false);

                this.calcHandlePercent();
            }

            if (!this.coords.w_rs) {
                return;
            }

            this.calcPointerPercent();
            var handle_x = this.getHandleX();


            if (this.target === "both") {
                this.coords.p_gap = 0;
                handle_x = this.getHandleX();
            }

            if (this.target === "click") {
                this.coords.p_gap = this.coords.p_handle / 2;
                handle_x = this.getHandleX();

                if (this.options.drag_interval) {
                    this.target = "both_one";
                } else {
                    this.target = this.chooseHandle(handle_x);
                }
            }

            switch (this.target) {
                case "base":
                    var w = (this.options.max - this.options.min) / 100,
                        f = (this.result.from - this.options.min) / w,
                        t = (this.result.to - this.options.min) / w;

                    this.coords.p_single_real = this.toFixed(f);
                    this.coords.p_from_real = this.toFixed(f);
                    this.coords.p_to_real = this.toFixed(t);

                    this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max);
                    this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                    this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);

                    this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);
                    this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
                    this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);

                    this.target = null;

                    break;

                case "single":
                    if (this.options.from_fixed) {
                        break;
                    }

                    this.coords.p_single_real = this.convertToRealPercent(handle_x);
                    this.coords.p_single_real = this.calcWithStep(this.coords.p_single_real);
                    this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max);

                    this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);

                    break;

                case "from":
                    if (this.options.from_fixed) {
                        break;
                    }

                    this.coords.p_from_real = this.convertToRealPercent(handle_x);
                    this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);
                    if (this.coords.p_from_real > this.coords.p_to_real) {
                        this.coords.p_from_real = this.coords.p_to_real;
                    }
                    this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                    this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from");
                    this.coords.p_from_real = this.checkMaxInterval(this.coords.p_from_real, this.coords.p_to_real, "from");

                    this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);

                    break;

                case "to":
                    if (this.options.to_fixed) {
                        break;
                    }

                    this.coords.p_to_real = this.convertToRealPercent(handle_x);
                    this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);
                    if (this.coords.p_to_real < this.coords.p_from_real) {
                        this.coords.p_to_real = this.coords.p_from_real;
                    }
                    this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
                    this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to");
                    this.coords.p_to_real = this.checkMaxInterval(this.coords.p_to_real, this.coords.p_from_real, "to");

                    this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);

                    break;

                case "both":
                    if (this.options.from_fixed || this.options.to_fixed) {
                        break;
                    }

                    handle_x = this.toFixed(handle_x + (this.coords.p_handle * 0.001));

                    this.coords.p_from_real = this.convertToRealPercent(handle_x) - this.coords.p_gap_left;
                    this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);
                    this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                    this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from");
                    this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);

                    this.coords.p_to_real = this.convertToRealPercent(handle_x) + this.coords.p_gap_right;
                    this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);
                    this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
                    this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to");
                    this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);

                    break;

                case "both_one":
                    if (this.options.from_fixed || this.options.to_fixed) {
                        break;
                    }

                    var real_x = this.convertToRealPercent(handle_x),
                        from = this.result.from_percent,
                        to = this.result.to_percent,
                        full = to - from,
                        half = full / 2,
                        new_from = real_x - half,
                        new_to = real_x + half;

                    if (new_from < 0) {
                        new_from = 0;
                        new_to = new_from + full;
                    }

                    if (new_to > 100) {
                        new_to = 100;
                        new_from = new_to - full;
                    }

                    this.coords.p_from_real = this.calcWithStep(new_from);
                    this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
                    this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);

                    this.coords.p_to_real = this.calcWithStep(new_to);
                    this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
                    this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);

                    break;
            }

            if (this.options.type === "single") {
                this.coords.p_bar_x = (this.coords.p_handle / 2);
                this.coords.p_bar_w = this.coords.p_single_fake;

                this.result.from_percent = this.coords.p_single_real;
                this.result.from = this.convertToValue(this.coords.p_single_real);
                this.result.from_pretty = this._prettify(this.result.from);

                if (this.options.values.length) {
                    this.result.from_value = this.options.values[this.result.from];
                }
            } else {
                this.coords.p_bar_x = this.toFixed(this.coords.p_from_fake + (this.coords.p_handle / 2));
                this.coords.p_bar_w = this.toFixed(this.coords.p_to_fake - this.coords.p_from_fake);

                this.result.from_percent = this.coords.p_from_real;
                this.result.from = this.convertToValue(this.coords.p_from_real);
                this.result.from_pretty = this._prettify(this.result.from);
                this.result.to_percent = this.coords.p_to_real;
                this.result.to = this.convertToValue(this.coords.p_to_real);
                this.result.to_pretty = this._prettify(this.result.to);

                if (this.options.values.length) {
                    this.result.from_value = this.options.values[this.result.from];
                    this.result.to_value = this.options.values[this.result.to];
                }
            }

            this.calcMinMax();
            this.calcLabels();
        },


        /**
         * calculates pointer X in percent
         */
        calcPointerPercent: function () {
            if (!this.coords.w_rs) {
                this.coords.p_pointer = 0;
                return;
            }

            if (this.coords.x_pointer < 0 || isNaN(this.coords.x_pointer)  ) {
                this.coords.x_pointer = 0;
            } else if (this.coords.x_pointer > this.coords.w_rs) {
                this.coords.x_pointer = this.coords.w_rs;
            }

            this.coords.p_pointer = this.toFixed(this.coords.x_pointer / this.coords.w_rs * 100);
        },

        convertToRealPercent: function (fake) {
            var full = 100 - this.coords.p_handle;
            return fake / full * 100;
        },

        convertToFakePercent: function (real) {
            var full = 100 - this.coords.p_handle;
            return real / 100 * full;
        },

        getHandleX: function () {
            var max = 100 - this.coords.p_handle,
                x = this.toFixed(this.coords.p_pointer - this.coords.p_gap);

            if (x < 0) {
                x = 0;
            } else if (x > max) {
                x = max;
            }

            return x;
        },

        calcHandlePercent: function () {
            if (this.options.type === "single") {
                this.coords.w_handle = this.$cache.s_single.outerWidth(false);
            } else {
                this.coords.w_handle = this.$cache.s_from.outerWidth(false);
            }

            this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100);
        },

        /**
         * Find closest handle to pointer click
         *
         * @param real_x {Number}
         * @returns {String}
         */
        chooseHandle: function (real_x) {
            if (this.options.type === "single") {
                return "single";
            } else {
                var m_point = this.coords.p_from_real + ((this.coords.p_to_real - this.coords.p_from_real) / 2);
                if (real_x >= m_point) {
                    return this.options.to_fixed ? "from" : "to";
                } else {
                    return this.options.from_fixed ? "to" : "from";
                }
            }
        },

        /**
         * Measure Min and Max labels width in percent
         */
        calcMinMax: function () {
            if (!this.coords.w_rs) {
                return;
            }

            this.labels.p_min = this.labels.w_min / this.coords.w_rs * 100;
            this.labels.p_max = this.labels.w_max / this.coords.w_rs * 100;
        },

        /**
         * Measure labels width and X in percent
         */
        calcLabels: function () {
            if (!this.coords.w_rs || this.options.hide_from_to) {
                return;
            }

            if (this.options.type === "single") {

                this.labels.w_single = this.$cache.single.outerWidth(false);
                this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100;
                this.labels.p_single_left = this.coords.p_single_fake + (this.coords.p_handle / 2) - (this.labels.p_single_fake / 2);
                this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake);

            } else {

                this.labels.w_from = this.$cache.from.outerWidth(false);
                this.labels.p_from_fake = this.labels.w_from / this.coords.w_rs * 100;
                this.labels.p_from_left = this.coords.p_from_fake + (this.coords.p_handle / 2) - (this.labels.p_from_fake / 2);
                this.labels.p_from_left = this.toFixed(this.labels.p_from_left);
                this.labels.p_from_left = this.checkEdges(this.labels.p_from_left, this.labels.p_from_fake);

                this.labels.w_to = this.$cache.to.outerWidth(false);
                this.labels.p_to_fake = this.labels.w_to / this.coords.w_rs * 100;
                this.labels.p_to_left = this.coords.p_to_fake + (this.coords.p_handle / 2) - (this.labels.p_to_fake / 2);
                this.labels.p_to_left = this.toFixed(this.labels.p_to_left);
                this.labels.p_to_left = this.checkEdges(this.labels.p_to_left, this.labels.p_to_fake);

                this.labels.w_single = this.$cache.single.outerWidth(false);
                this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100;
                this.labels.p_single_left = ((this.labels.p_from_left + this.labels.p_to_left + this.labels.p_to_fake) / 2) - (this.labels.p_single_fake / 2);
                this.labels.p_single_left = this.toFixed(this.labels.p_single_left);
                this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake);

            }
        },



        // =============================================================================================================
        // Drawings

        /**
         * Main function called in request animation frame
         * to update everything
         */
        updateScene: function () {
            if (this.raf_id) {
                cancelAnimationFrame(this.raf_id);
                this.raf_id = null;
            }

            clearTimeout(this.update_tm);
            this.update_tm = null;

            if (!this.options) {
                return;
            }

            this.drawHandles();

            if (this.is_active) {
                this.raf_id = requestAnimationFrame(this.updateScene.bind(this));
            } else {
                this.update_tm = setTimeout(this.updateScene.bind(this), 300);
            }
        },

        /**
         * Draw handles
         */
        drawHandles: function () {
            this.coords.w_rs = this.$cache.rs.outerWidth(false);

            if (!this.coords.w_rs) {
                return;
            }

            if (this.coords.w_rs !== this.coords.w_rs_old) {
                this.target = "base";
                this.is_resize = true;
            }

            if (this.coords.w_rs !== this.coords.w_rs_old || this.force_redraw) {
                this.setMinMax();
                this.calc(true);
                this.drawLabels();
                if (this.options.grid) {
                    this.calcGridMargin();
                    this.calcGridLabels();
                }
                this.force_redraw = true;
                this.coords.w_rs_old = this.coords.w_rs;
                this.drawShadow();
            }

            if (!this.coords.w_rs) {
                return;
            }

            if (!this.dragging && !this.force_redraw && !this.is_key) {
                return;
            }

            if (this.old_from !== this.result.from || this.old_to !== this.result.to || this.force_redraw || this.is_key) {

                this.drawLabels();

                this.$cache.bar[0].style.left = this.coords.p_bar_x + "%";
                this.$cache.bar[0].style.width = this.coords.p_bar_w + "%";

                if (this.options.type === "single") {
                    this.$cache.s_single[0].style.left = this.coords.p_single_fake + "%";

                    this.$cache.single[0].style.left = this.labels.p_single_left + "%";
                } else {
                    this.$cache.s_from[0].style.left = this.coords.p_from_fake + "%";
                    this.$cache.s_to[0].style.left = this.coords.p_to_fake + "%";

                    if (this.old_from !== this.result.from || this.force_redraw) {
                        this.$cache.from[0].style.left = this.labels.p_from_left + "%";
                    }
                    if (this.old_to !== this.result.to || this.force_redraw) {
                        this.$cache.to[0].style.left = this.labels.p_to_left + "%";
                    }

                    this.$cache.single[0].style.left = this.labels.p_single_left + "%";
                }

                this.writeToInput();

                if ((this.old_from !== this.result.from || this.old_to !== this.result.to) && !this.is_start) {
                    this.$cache.input.trigger("change");
                    this.$cache.input.trigger("input");
                }

                this.old_from = this.result.from;
                this.old_to = this.result.to;

                // callbacks call
                if (!this.is_resize && !this.is_update && !this.is_start && !this.is_finish) {
                    this.callOnChange();
                }
                if (this.is_key || this.is_click) {
                    this.is_key = false;
                    this.is_click = false;
                    this.callOnFinish();
                }

                this.is_update = false;
                this.is_resize = false;
                this.is_finish = false;
            }

            this.is_start = false;
            this.is_key = false;
            this.is_click = false;
            this.force_redraw = false;
        },

        /**
         * Draw labels
         * measure labels collisions
         * collapse close labels
         */
        drawLabels: function () {
            if (!this.options) {
                return;
            }

            var values_num = this.options.values.length;
            var p_values = this.options.p_values;
            var text_single;
            var text_from;
            var text_to;
            var from_pretty;
            var to_pretty;

            if (this.options.hide_from_to) {
                return;
            }

            if (this.options.type === "single") {

                if (values_num) {
                    text_single = this.decorate(p_values[this.result.from]);
                    this.$cache.single.html(text_single);
                } else {
                    from_pretty = this._prettify(this.result.from);

                    text_single = this.decorate(from_pretty, this.result.from);
                    this.$cache.single.html(text_single);
                }

                this.calcLabels();

                if (this.labels.p_single_left < this.labels.p_min + 1) {
                    this.$cache.min[0].style.visibility = "hidden";
                } else {
                    this.$cache.min[0].style.visibility = "visible";
                }

                if (this.labels.p_single_left + this.labels.p_single_fake > 100 - this.labels.p_max - 1) {
                    this.$cache.max[0].style.visibility = "hidden";
                } else {
                    this.$cache.max[0].style.visibility = "visible";
                }

            } else {

                if (values_num) {

                    if (this.options.decorate_both) {
                        text_single = this.decorate(p_values[this.result.from]);
                        text_single += this.options.values_separator;
                        text_single += this.decorate(p_values[this.result.to]);
                    } else {
                        text_single = this.decorate(p_values[this.result.from] + this.options.values_separator + p_values[this.result.to]);
                    }
                    text_from = this.decorate(p_values[this.result.from]);
                    text_to = this.decorate(p_values[this.result.to]);

                    this.$cache.single.html(text_single);
                    this.$cache.from.html(text_from);
                    this.$cache.to.html(text_to);

                } else {
                    from_pretty = this._prettify(this.result.from);
                    to_pretty = this._prettify(this.result.to);

                    if (this.options.decorate_both) {
                        text_single = this.decorate(from_pretty, this.result.from);
                        text_single += this.options.values_separator;
                        text_single += this.decorate(to_pretty, this.result.to);
                    } else {
                        text_single = this.decorate(from_pretty + this.options.values_separator + to_pretty, this.result.to);
                    }
                    text_from = this.decorate(from_pretty, this.result.from);
                    text_to = this.decorate(to_pretty, this.result.to);

                    this.$cache.single.html(text_single);
                    this.$cache.from.html(text_from);
                    this.$cache.to.html(text_to);

                }

                this.calcLabels();

                var min = Math.min(this.labels.p_single_left, this.labels.p_from_left),
                    single_left = this.labels.p_single_left + this.labels.p_single_fake,
                    to_left = this.labels.p_to_left + this.labels.p_to_fake,
                    max = Math.max(single_left, to_left);

                if (this.labels.p_from_left + this.labels.p_from_fake >= this.labels.p_to_left) {
                    this.$cache.from[0].style.visibility = "hidden";
                    this.$cache.to[0].style.visibility = "hidden";
                    this.$cache.single[0].style.visibility = "visible";

                    if (this.result.from === this.result.to) {
                        if (this.target === "from") {
                            this.$cache.from[0].style.visibility = "visible";
                        } else if (this.target === "to") {
                            this.$cache.to[0].style.visibility = "visible";
                        } else if (!this.target) {
                            this.$cache.from[0].style.visibility = "visible";
                        }
                        this.$cache.single[0].style.visibility = "hidden";
                        max = to_left;
                    } else {
                        this.$cache.from[0].style.visibility = "hidden";
                        this.$cache.to[0].style.visibility = "hidden";
                        this.$cache.single[0].style.visibility = "visible";
                        max = Math.max(single_left, to_left);
                    }
                } else {
                    this.$cache.from[0].style.visibility = "visible";
                    this.$cache.to[0].style.visibility = "visible";
                    this.$cache.single[0].style.visibility = "hidden";
                }

                if (min < this.labels.p_min + 1) {
                    this.$cache.min[0].style.visibility = "hidden";
                } else {
                    this.$cache.min[0].style.visibility = "visible";
                }

                if (max > 100 - this.labels.p_max - 1) {
                    this.$cache.max[0].style.visibility = "hidden";
                } else {
                    this.$cache.max[0].style.visibility = "visible";
                }

            }
        },

        /**
         * Draw shadow intervals
         */
        drawShadow: function () {
            var o = this.options,
                c = this.$cache,

                is_from_min = typeof o.from_min === "number" && !isNaN(o.from_min),
                is_from_max = typeof o.from_max === "number" && !isNaN(o.from_max),
                is_to_min = typeof o.to_min === "number" && !isNaN(o.to_min),
                is_to_max = typeof o.to_max === "number" && !isNaN(o.to_max),

                from_min,
                from_max,
                to_min,
                to_max;

            if (o.type === "single") {
                if (o.from_shadow && (is_from_min || is_from_max)) {
                    from_min = this.convertToPercent(is_from_min ? o.from_min : o.min);
                    from_max = this.convertToPercent(is_from_max ? o.from_max : o.max) - from_min;
                    from_min = this.toFixed(from_min - (this.coords.p_handle / 100 * from_min));
                    from_max = this.toFixed(from_max - (this.coords.p_handle / 100 * from_max));
                    from_min = from_min + (this.coords.p_handle / 2);

                    c.shad_single[0].style.display = "block";
                    c.shad_single[0].style.left = from_min + "%";
                    c.shad_single[0].style.width = from_max + "%";
                } else {
                    c.shad_single[0].style.display = "none";
                }
            } else {
                if (o.from_shadow && (is_from_min || is_from_max)) {
                    from_min = this.convertToPercent(is_from_min ? o.from_min : o.min);
                    from_max = this.convertToPercent(is_from_max ? o.from_max : o.max) - from_min;
                    from_min = this.toFixed(from_min - (this.coords.p_handle / 100 * from_min));
                    from_max = this.toFixed(from_max - (this.coords.p_handle / 100 * from_max));
                    from_min = from_min + (this.coords.p_handle / 2);

                    c.shad_from[0].style.display = "block";
                    c.shad_from[0].style.left = from_min + "%";
                    c.shad_from[0].style.width = from_max + "%";
                } else {
                    c.shad_from[0].style.display = "none";
                }

                if (o.to_shadow && (is_to_min || is_to_max)) {
                    to_min = this.convertToPercent(is_to_min ? o.to_min : o.min);
                    to_max = this.convertToPercent(is_to_max ? o.to_max : o.max) - to_min;
                    to_min = this.toFixed(to_min - (this.coords.p_handle / 100 * to_min));
                    to_max = this.toFixed(to_max - (this.coords.p_handle / 100 * to_max));
                    to_min = to_min + (this.coords.p_handle / 2);

                    c.shad_to[0].style.display = "block";
                    c.shad_to[0].style.left = to_min + "%";
                    c.shad_to[0].style.width = to_max + "%";
                } else {
                    c.shad_to[0].style.display = "none";
                }
            }
        },



        /**
         * Write values to input element
         */
        writeToInput: function () {
            if (this.options.type === "single") {
                if (this.options.values.length) {
                    this.$cache.input.prop("value", this.result.from_value);
                } else {
                    this.$cache.input.prop("value", this.result.from);
                }
                this.$cache.input.data("from", this.result.from);
            } else {
                if (this.options.values.length) {
                    this.$cache.input.prop("value", this.result.from_value + this.options.input_values_separator + this.result.to_value);
                } else {
                    this.$cache.input.prop("value", this.result.from + this.options.input_values_separator + this.result.to);
                }
                this.$cache.input.data("from", this.result.from);
                this.$cache.input.data("to", this.result.to);
            }
        },



        // =============================================================================================================
        // Callbacks

        callOnStart: function () {
            this.writeToInput();

            if (this.options.onStart && typeof this.options.onStart === "function") {
                if (this.options.scope) {
                    this.options.onStart.call(this.options.scope, this.result);
                } else {
                    this.options.onStart(this.result);
                }
            }
        },
        callOnChange: function () {
            this.writeToInput();

            if (this.options.onChange && typeof this.options.onChange === "function") {
                if (this.options.scope) {
                    this.options.onChange.call(this.options.scope, this.result);
                } else {
                    this.options.onChange(this.result);
                }
            }
        },
        callOnFinish: function () {
            this.writeToInput();

            if (this.options.onFinish && typeof this.options.onFinish === "function") {
                if (this.options.scope) {
                    this.options.onFinish.call(this.options.scope, this.result);
                } else {
                    this.options.onFinish(this.result);
                }
            }
        },
        callOnUpdate: function () {
            this.writeToInput();

            if (this.options.onUpdate && typeof this.options.onUpdate === "function") {
                if (this.options.scope) {
                    this.options.onUpdate.call(this.options.scope, this.result);
                } else {
                    this.options.onUpdate(this.result);
                }
            }
        },




        // =============================================================================================================
        // Service methods

        toggleInput: function () {
            this.$cache.input.toggleClass("irs-hidden-input");

            if (this.has_tab_index) {
                this.$cache.input.prop("tabindex", -1);
            } else {
                this.$cache.input.removeProp("tabindex");
            }

            this.has_tab_index = !this.has_tab_index;
        },

        /**
         * Convert real value to percent
         *
         * @param value {Number} X in real
         * @param no_min {boolean=} don't use min value
         * @returns {Number} X in percent
         */
        convertToPercent: function (value, no_min) {
            var diapason = this.options.max - this.options.min,
                one_percent = diapason / 100,
                val, percent;

            if (!diapason) {
                this.no_diapason = true;
                return 0;
            }

            if (no_min) {
                val = value;
            } else {
                val = value - this.options.min;
            }

            percent = val / one_percent;

            return this.toFixed(percent);
        },

        /**
         * Convert percent to real values
         *
         * @param percent {Number} X in percent
         * @returns {Number} X in real
         */
        convertToValue: function (percent) {
            var min = this.options.min,
                max = this.options.max,
                min_decimals = min.toString().split(".")[1],
                max_decimals = max.toString().split(".")[1],
                min_length, max_length,
                avg_decimals = 0,
                abs = 0;

            if (percent === 0) {
                return this.options.min;
            }
            if (percent === 100) {
                return this.options.max;
            }


            if (min_decimals) {
                min_length = min_decimals.length;
                avg_decimals = min_length;
            }
            if (max_decimals) {
                max_length = max_decimals.length;
                avg_decimals = max_length;
            }
            if (min_length && max_length) {
                avg_decimals = (min_length >= max_length) ? min_length : max_length;
            }

            if (min < 0) {
                abs = Math.abs(min);
                min = +(min + abs).toFixed(avg_decimals);
                max = +(max + abs).toFixed(avg_decimals);
            }

            var number = ((max - min) / 100 * percent) + min,
                string = this.options.step.toString().split(".")[1],
                result;

            if (string) {
                number = +number.toFixed(string.length);
            } else {
                number = number / this.options.step;
                number = number * this.options.step;

                number = +number.toFixed(0);
            }

            if (abs) {
                number -= abs;
            }

            if (string) {
                result = +number.toFixed(string.length);
            } else {
                result = this.toFixed(number);
            }

            if (result < this.options.min) {
                result = this.options.min;
            } else if (result > this.options.max) {
                result = this.options.max;
            }

            return result;
        },

        /**
         * Round percent value with step
         *
         * @param percent {Number}
         * @returns percent {Number} rounded
         */
        calcWithStep: function (percent) {
            var rounded = Math.round(percent / this.coords.p_step) * this.coords.p_step;

            if (rounded > 100) {
                rounded = 100;
            }
            if (percent === 100) {
                rounded = 100;
            }

            return this.toFixed(rounded);
        },

        checkMinInterval: function (p_current, p_next, type) {
            var o = this.options,
                current,
                next;

            if (!o.min_interval) {
                return p_current;
            }

            current = this.convertToValue(p_current);
            next = this.convertToValue(p_next);

            if (type === "from") {

                if (next - current < o.min_interval) {
                    current = next - o.min_interval;
                }

            } else {

                if (current - next < o.min_interval) {
                    current = next + o.min_interval;
                }

            }

            return this.convertToPercent(current);
        },

        checkMaxInterval: function (p_current, p_next, type) {
            var o = this.options,
                current,
                next;

            if (!o.max_interval) {
                return p_current;
            }

            current = this.convertToValue(p_current);
            next = this.convertToValue(p_next);

            if (type === "from") {

                if (next - current > o.max_interval) {
                    current = next - o.max_interval;
                }

            } else {

                if (current - next > o.max_interval) {
                    current = next + o.max_interval;
                }

            }

            return this.convertToPercent(current);
        },

        checkDiapason: function (p_num, min, max) {
            var num = this.convertToValue(p_num),
                o = this.options;

            if (typeof min !== "number") {
                min = o.min;
            }

            if (typeof max !== "number") {
                max = o.max;
            }

            if (num < min) {
                num = min;
            }

            if (num > max) {
                num = max;
            }

            return this.convertToPercent(num);
        },

        toFixed: function (num) {
            num = num.toFixed(20);
            return +num;
        },

        _prettify: function (num) {
            if (!this.options.prettify_enabled) {
                return num;
            }

            if (this.options.prettify && typeof this.options.prettify === "function") {
                return this.options.prettify(num);
            } else {
                return this.prettify(num);
            }
        },

        prettify: function (num) {
            var n = num.toString();
            return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + this.options.prettify_separator);
        },

        checkEdges: function (left, width) {
            if (!this.options.force_edges) {
                return this.toFixed(left);
            }

            if (left < 0) {
                left = 0;
            } else if (left > 100 - width) {
                left = 100 - width;
            }

            return this.toFixed(left);
        },

        validate: function () {
            var o = this.options,
                r = this.result,
                v = o.values,
                vl = v.length,
                value,
                i;

            if (typeof o.min === "string") o.min = +o.min;
            if (typeof o.max === "string") o.max = +o.max;
            if (typeof o.from === "string") o.from = +o.from;
            if (typeof o.to === "string") o.to = +o.to;
            if (typeof o.step === "string") o.step = +o.step;

            if (typeof o.from_min === "string") o.from_min = +o.from_min;
            if (typeof o.from_max === "string") o.from_max = +o.from_max;
            if (typeof o.to_min === "string") o.to_min = +o.to_min;
            if (typeof o.to_max === "string") o.to_max = +o.to_max;

            if (typeof o.grid_num === "string") o.grid_num = +o.grid_num;

            if (o.max < o.min) {
                o.max = o.min;
            }

            if (vl) {
                o.p_values = [];
                o.min = 0;
                o.max = vl - 1;
                o.step = 1;
                o.grid_num = o.max;
                o.grid_snap = true;

                for (i = 0; i < vl; i++) {
                    value = +v[i];

                    if (!isNaN(value)) {
                        v[i] = value;
                        value = this._prettify(value);
                    } else {
                        value = v[i];
                    }

                    o.p_values.push(value);
                }
            }

            if (typeof o.from !== "number" || isNaN(o.from)) {
                o.from = o.min;
            }

            if (typeof o.to !== "number" || isNaN(o.to)) {
                o.to = o.max;
            }

            if (o.type === "single") {

                if (o.from < o.min) o.from = o.min;
                if (o.from > o.max) o.from = o.max;

            } else {

                if (o.from < o.min) o.from = o.min;
                if (o.from > o.max) o.from = o.max;

                if (o.to < o.min) o.to = o.min;
                if (o.to > o.max) o.to = o.max;

                if (this.update_check.from) {

                    if (this.update_check.from !== o.from) {
                        if (o.from > o.to) o.from = o.to;
                    }
                    if (this.update_check.to !== o.to) {
                        if (o.to < o.from) o.to = o.from;
                    }

                }

                if (o.from > o.to) o.from = o.to;
                if (o.to < o.from) o.to = o.from;

            }

            if (typeof o.step !== "number" || isNaN(o.step) || !o.step || o.step < 0) {
                o.step = 1;
            }

            if (typeof o.from_min === "number" && o.from < o.from_min) {
                o.from = o.from_min;
            }

            if (typeof o.from_max === "number" && o.from > o.from_max) {
                o.from = o.from_max;
            }

            if (typeof o.to_min === "number" && o.to < o.to_min) {
                o.to = o.to_min;
            }

            if (typeof o.to_max === "number" && o.from > o.to_max) {
                o.to = o.to_max;
            }

            if (r) {
                if (r.min !== o.min) {
                    r.min = o.min;
                }

                if (r.max !== o.max) {
                    r.max = o.max;
                }

                if (r.from < r.min || r.from > r.max) {
                    r.from = o.from;
                }

                if (r.to < r.min || r.to > r.max) {
                    r.to = o.to;
                }
            }

            if (typeof o.min_interval !== "number" || isNaN(o.min_interval) || !o.min_interval || o.min_interval < 0) {
                o.min_interval = 0;
            }

            if (typeof o.max_interval !== "number" || isNaN(o.max_interval) || !o.max_interval || o.max_interval < 0) {
                o.max_interval = 0;
            }

            if (o.min_interval && o.min_interval > o.max - o.min) {
                o.min_interval = o.max - o.min;
            }

            if (o.max_interval && o.max_interval > o.max - o.min) {
                o.max_interval = o.max - o.min;
            }
        },

        decorate: function (num, original) {
            var decorated = "",
                o = this.options;

            if (o.prefix) {
                decorated += o.prefix;
            }

            decorated += num;

            if (o.max_postfix) {
                if (o.values.length && num === o.p_values[o.max]) {
                    decorated += o.max_postfix;
                    if (o.postfix) {
                        decorated += " ";
                    }
                } else if (original === o.max) {
                    decorated += o.max_postfix;
                    if (o.postfix) {
                        decorated += " ";
                    }
                }
            }

            if (o.postfix) {
                decorated += o.postfix;
            }

            return decorated;
        },

        updateFrom: function () {
            this.result.from = this.options.from;
            this.result.from_percent = this.convertToPercent(this.result.from);
            this.result.from_pretty = this._prettify(this.result.from);
            if (this.options.values) {
                this.result.from_value = this.options.values[this.result.from];
            }
        },

        updateTo: function () {
            this.result.to = this.options.to;
            this.result.to_percent = this.convertToPercent(this.result.to);
            this.result.to_pretty = this._prettify(this.result.to);
            if (this.options.values) {
                this.result.to_value = this.options.values[this.result.to];
            }
        },

        updateResult: function () {
            this.result.min = this.options.min;
            this.result.max = this.options.max;
            this.updateFrom();
            this.updateTo();
        },


        // =============================================================================================================
        // Grid

        appendGrid: function () {
            if (!this.options.grid) {
                return;
            }

            var o = this.options,
                i, z,

                total = o.max - o.min,
                big_num = o.grid_num,
                big_p = 0,
                big_w = 0,

                small_max = 4,
                local_small_max,
                small_p,
                small_w = 0,

                result,
                html = '';



            this.calcGridMargin();

            if (o.grid_snap) {

                if (total > 50) {
                    big_num = 50 / o.step;
                    big_p = this.toFixed(o.step / 0.5);
                } else {
                    big_num = total / o.step;
                    big_p = this.toFixed(o.step / (total / 100));
                }

            } else {
                big_p = this.toFixed(100 / big_num);
            }

            if (big_num > 4) {
                small_max = 3;
            }
            if (big_num > 7) {
                small_max = 2;
            }
            if (big_num > 14) {
                small_max = 1;
            }
            if (big_num > 28) {
                small_max = 0;
            }

            for (i = 0; i < big_num + 1; i++) {
                local_small_max = small_max;

                big_w = this.toFixed(big_p * i);

                if (big_w > 100) {
                    big_w = 100;
                }
                this.coords.big[i] = big_w;

                small_p = (big_w - (big_p * (i - 1))) / (local_small_max + 1);

                for (z = 1; z <= local_small_max; z++) {
                    if (big_w === 0) {
                        break;
                    }

                    small_w = this.toFixed(big_w - (small_p * z));

                    html += '<span class="irs-grid-pol small" style="left: ' + small_w + '%"></span>';
                }

                html += '<span class="irs-grid-pol" style="left: ' + big_w + '%"></span>';

                result = this.convertToValue(big_w);
                if (o.values.length) {
                    result = o.p_values[result];
                } else {
                    result = this._prettify(result);
                }

                html += '<span class="irs-grid-text js-grid-text-' + i + '" style="left: ' + big_w + '%">' + result + '</span>';
            }
            this.coords.big_num = Math.ceil(big_num + 1);



            this.$cache.cont.addClass("irs-with-grid");
            this.$cache.grid.html(html);
            this.cacheGridLabels();
        },

        cacheGridLabels: function () {
            var $label, i,
                num = this.coords.big_num;

            for (i = 0; i < num; i++) {
                $label = this.$cache.grid.find(".js-grid-text-" + i);
                this.$cache.grid_labels.push($label);
            }

            this.calcGridLabels();
        },

        calcGridLabels: function () {
            var i, label, start = [], finish = [],
                num = this.coords.big_num;

            for (i = 0; i < num; i++) {
                this.coords.big_w[i] = this.$cache.grid_labels[i].outerWidth(false);
                this.coords.big_p[i] = this.toFixed(this.coords.big_w[i] / this.coords.w_rs * 100);
                this.coords.big_x[i] = this.toFixed(this.coords.big_p[i] / 2);

                start[i] = this.toFixed(this.coords.big[i] - this.coords.big_x[i]);
                finish[i] = this.toFixed(start[i] + this.coords.big_p[i]);
            }

            if (this.options.force_edges) {
                if (start[0] < -this.coords.grid_gap) {
                    start[0] = -this.coords.grid_gap;
                    finish[0] = this.toFixed(start[0] + this.coords.big_p[0]);

                    this.coords.big_x[0] = this.coords.grid_gap;
                }

                if (finish[num - 1] > 100 + this.coords.grid_gap) {
                    finish[num - 1] = 100 + this.coords.grid_gap;
                    start[num - 1] = this.toFixed(finish[num - 1] - this.coords.big_p[num - 1]);

                    this.coords.big_x[num - 1] = this.toFixed(this.coords.big_p[num - 1] - this.coords.grid_gap);
                }
            }

            this.calcGridCollision(2, start, finish);
            this.calcGridCollision(4, start, finish);

            for (i = 0; i < num; i++) {
                label = this.$cache.grid_labels[i][0];

                if (this.coords.big_x[i] !== Number.POSITIVE_INFINITY) {
                    label.style.marginLeft = -this.coords.big_x[i] + "%";
                }
            }
        },

        // Collisions Calc Beta
        // TODO: Refactor then have plenty of time
        calcGridCollision: function (step, start, finish) {
            var i, next_i, label,
                num = this.coords.big_num;

            for (i = 0; i < num; i += step) {
                next_i = i + (step / 2);
                if (next_i >= num) {
                    break;
                }

                label = this.$cache.grid_labels[next_i][0];

                if (finish[i] <= start[next_i]) {
                    label.style.visibility = "visible";
                } else {
                    label.style.visibility = "hidden";
                }
            }
        },

        calcGridMargin: function () {
            if (!this.options.grid_margin) {
                return;
            }

            this.coords.w_rs = this.$cache.rs.outerWidth(false);
            if (!this.coords.w_rs) {
                return;
            }

            if (this.options.type === "single") {
                this.coords.w_handle = this.$cache.s_single.outerWidth(false);
            } else {
                this.coords.w_handle = this.$cache.s_from.outerWidth(false);
            }
            this.coords.p_handle = this.toFixed(this.coords.w_handle  / this.coords.w_rs * 100);
            this.coords.grid_gap = this.toFixed((this.coords.p_handle / 2) - 0.1);

            this.$cache.grid[0].style.width = this.toFixed(100 - this.coords.p_handle) + "%";
            this.$cache.grid[0].style.left = this.coords.grid_gap + "%";
        },



        // =============================================================================================================
        // Public methods

        update: function (options) {
            if (!this.input) {
                return;
            }

            this.is_update = true;

            this.options.from = this.result.from;
            this.options.to = this.result.to;
            this.update_check.from = this.result.from;
            this.update_check.to = this.result.to;

            this.options = $.extend(this.options, options);
            this.validate();
            this.updateResult(options);

            this.toggleInput();
            this.remove();
            this.init(true);
        },

        reset: function () {
            if (!this.input) {
                return;
            }

            this.updateResult();
            this.update();
        },

        destroy: function () {
            if (!this.input) {
                return;
            }

            this.toggleInput();
            this.$cache.input.prop("readonly", false);
            $.data(this.input, "ionRangeSlider", null);

            this.remove();
            this.input = null;
            this.options = null;
        }
    };

    $.fn.ionRangeSlider = function (options) {
        return this.each(function() {
            if (!$.data(this, "ionRangeSlider")) {
                $.data(this, "ionRangeSlider", new IonRangeSlider(this, options, plugin_count++));
            }
        });
    };



    // =================================================================================================================
    // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
    // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

    // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

    // MIT license

    (function() {
        var lastTime = 0;
        var vendors = ['ms', 'moz', 'webkit', 'o'];
        for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
            window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
            window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                || window[vendors[x]+'CancelRequestAnimationFrame'];
        }

        if (!window.requestAnimationFrame)
            window.requestAnimationFrame = function(callback, element) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                var id = window.setTimeout(function() { callback(currTime + timeToCall); },
                    timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };

        if (!window.cancelAnimationFrame)
            window.cancelAnimationFrame = function(id) {
                clearTimeout(id);
            };
    }());

}));


/***/ }),

/***/ "dTkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isset */
/* harmony export (immutable) */ __webpack_exports__["e"] = element;
/* unused harmony export elementOrDefault */
/* harmony export (immutable) */ __webpack_exports__["f"] = elementOrDash;
/* harmony export (immutable) */ __webpack_exports__["g"] = orDefault;
/* harmony export (immutable) */ __webpack_exports__["c"] = asNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = asBoolean;
/* harmony export (immutable) */ __webpack_exports__["d"] = asString;
/* harmony export (immutable) */ __webpack_exports__["h"] = trim;
/* harmony export (immutable) */ __webpack_exports__["a"] = asArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);


/**
 * Is a given variable defined and has value?
 * @param {*} val
 * @return {boolean} <code>false</code> if given value is <code>undefined</code> or <code>null</code>, otherwise <code>true</code>
 */
function isset(val) {
  return !__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isUndefined(val) && !__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isNull(val);
}

/**
 * Returns object's property or array's index if exists and default value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function element(object, key) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.has(object, key) ? object[key] : defaultValue;
}

/**
 * Returns object's property or array's index if exists and is not <code>null</code> or default value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function elementOrDefault(object, key) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.has(object, key) && object[key] !== null ? object[key] : defaultValue;
}

/**
 * Returns object's property or array's index if exists and is not <code>null</code> or "&mdash;" value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function elementOrDash(object, key) {
  return elementOrDefault(object, key, '&mdash;');
}

/**
 * Returns value if it's not <code>undefined</code> or <code>null</code>, otherwise defaultValue
 * @param {*} value
 * @param {*} defaultValue
 * @return {*}
 */
function orDefault(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return isset(value) ? value : defaultValue;
}

/**
 * Converts given value to number using standard javascript converter: <code>+value</code>
 * @param {*} value Input value
 * @param {number} defaultValue
 * @return {number} Either converted value if it's not <code>NaN</code> and default value otherwise
 */
function asNumber(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  value = +value;
  return !isNaN(value) ? value : 0;
}

/**
 * Converts given value to boolean using such algo:
 * - string <code>"0"</code> results in <code>false</code>;
 * - string <code>"false"</code> results in <code>false</code>;
 * - string <code>"null"</code> results in <code>false</code>;
 * - empty object results in <code>false</code>;
 * - empty array results in <code>false</code>;
 * - other values go through standard javascript converter: <code>!!value</code>
 * @param {*} value Input value
 * @return {boolean} Converted value
 */
function asBoolean(value) {
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isBoolean(value)) return value;
  if (value === '0') return false;
  if (value === 'false') return false;
  if (value === 'null') return false;
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isObject(value) && __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(value)) return false;
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(value) && __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(value)) return false;
  return !!value;
}

/**
 * Converts given value to string using standard javascript converter: <code>''+value</code>
 * except that <code>null</code> and <code>undefined</code> values will be converted to empty string.
 * @param {*} value Input value
 * @return {string} Converted value
 */
function asString(value) {
  if (value === null || __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isUndefined(value)) return '';
  return '' + value;
}

/**
 * Converts given value to string using {@link asString()} and trims whitespace characters.
 * @param {string|*} value
 * @return {string} Converted and trimmed value
 */
function trim(value) {
  return asString(value).trim();
}

/**
 * If input value is an array - it will be returned as is.
 * In other cases input value will be converted to string and either split with given delimiter
 * or just returned as a single array element.
 * @param {array|string} value
 * @param {string} delimiter
 * @return {array}
 */
function asArray(value) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!value) return [];
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(value)) return value;
  value = asString(value);
  return delimiter ? value.split(delimiter) : [value];
}

/***/ }),

/***/ "e7VL":
/***/ (function(module, exports) {

module.exports = "<div class=\"main\">\n\t<a class=\"link\" data-bind=\"attr: {href: url}\">\n\t\t<!-- ko if: previewImage -->\n\t\t<span class=\"img loading\" style=\"background-image: url('/public/images/loader_bg.gif')\"></span>\n\t\t<span class=\"img\" data-bind=\"attr: {style: 'background-image: url(\\'' + previewImage + '\\')'}\"></span>\n\t\t<!-- /ko -->\n\n\t\t<!-- ko ifnot: previewImage -->\n\t\t<span class=\"img noimg\" style=\"background-image: url('/public/images/noimage.png')\"></span>\n\t\t<!-- /ko -->\n\n\t\t<span class=\"extra-links\">\n\t\t\t<!-- ko if: isCheckboxVisible -->\n\t\t\t<span class=\"extra-link select-it\" data-bind=\"click: toggleSelectState\" title=\"Отметить\"></span>\n\t\t\t<span class=\"extra-link unselect-it\" data-bind=\"click: toggleSelectState\" title=\"Снять отметку\"></span>\n\t\t\t<!-- /ko -->\n\n\t\t\t<!-- ko if: isFavoritesVisible -->\n\t\t\t<span class=\"extra-link like-it\" data-bind=\"click: toggleFavorite\" title=\"Добавить в избранное\"></span>\n\t\t\t<span class=\"extra-link unlike-it\" data-bind=\"click: toggleFavorite\" title=\"Удалить из избранного\"></span>\n\t\t\t<!-- /ko -->\n\n\t\t\t<span class=\"extra-link zoom-it\" data-bind=\"click: showImages, attr: {title: zde.lang('shop_btn_view_all_images')}\"></span>\n\t\t</span>\n\n\t\t<span class=\"favorite\" data-bind=\"visible: isFavorite\"></span>\n\n\t\t<span class=\"title\"><span data-bind=\"text: title, attr: {title: title}\"></span></span>\n\n\t\t<span class=\"price\">\n\t\t\t<span class=\"\" data-bind=\"css: {'new': priceOld}\">\n\t\t\t\t<span data-bind=\"numeral: {value: price, format: $root.settings.priceFormat}\"></span>\n\t\t\t</span>\n\t\t\t<span class=\"old\" data-bind=\"visible: priceOld\">\n\t\t\t\t<span data-bind=\"numeral: {value: priceOld, format: $root.settings.priceFormat}\"></span>\n\t\t\t</span>\n\t\t</span>\n\n\t\t<span class=\"discount\" data-bind=\"visible: discount > 0\">\n\t\t\t-<span data-bind=\"text: discount\"></span> %\n\t\t</span>\n\n\t\t<!-- ko if: $data.score -->\n\t\t<span class=\"score\" title=\"lucene score\" data-bind=\"text: score, click: showDebugInfo\"></span>\n\t\t<!-- /ko -->\n\t</a>\n\n\t<!-- ko with: bestOffer -->\n\t<a class=\"link shop-name\" target=\"_blank\" data-bind=\"text: shop.title, attr: {href: url}\" rel=\"nofollow noopener\"></a>\n\t<!-- /ko -->\n</div>\n\n<!-- ko if: $root.settings.isAdmin -->\n<div class=\"details\">\n\t<table width=\"100%\" style=\"text-align: left\" valign=\"top\">\n\t\t<tr>\n\t\t\t<th style=\"padding-right: 10px\">ID</th>\n\t\t\t<td data-bind=\"text: id\"></td>\n\t\t</tr>\n\t\t<!-- ko if: subcategory -->\n\t\t<tr>\n\t\t\t<th style=\"padding-right: 10px\">Категория</th>\n\t\t\t<td data-bind=\"text: subcategory.category.title + '&nbsp;/&nbsp;' + subcategory.title\"></td>\n\t\t</tr>\n\t\t<!-- /ko -->\n\t\t<!-- ko if: brand -->\n\t\t<tr>\n\t\t\t<th style=\"padding-right: 10px\">Бренд</th>\n\t\t\t<td data-bind=\"text: brand.title\"></td>\n\t\t</tr>\n\t\t<!-- /ko -->\n\t\t<tr>\n\t\t\t<th style=\"padding-right: 10px\">Обновлен</th>\n\t\t\t<td data-bind=\"text: updateDate\"></td>\n\t\t</tr>\n\t</table>\n\n\t<!--<div class=\"color-filter\">\n\t\t<ul class=\"tags-list\">\n\t\t\t<li class=\"tag\"><span style=\"background-color: black;\"></span></li>\n\t\t</ul>\n\t</div>\n\n\t<div class=\"size-filter\">\n\t\t<ul class=\"tags-list\">\n\t\t\t<li class=\"tag\"><span>XXS</span></li>\n\t\t</ul>\n\t</div>\n\n\t<a class=\"actions\" target=\"_blank\" data-bind=\"attr: {href: orderUrl}\">\n\t\tЗаказать\n\t</a>-->\n</div>\n<!-- /ko -->"

/***/ }),

/***/ "f5a1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "router", function() { return router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "query", function() { return query; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loader", function() { return loader; });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_utils_nav_router__ = __webpack_require__("T9V6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_utils_nav_query__ = __webpack_require__("EFDg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_utils_nav_loader__ = __webpack_require__("JMoE");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// const logger = loggerUtils.newLogger('Navigator');

var ShopQuery = function (_Query) {
	_inherits(ShopQuery, _Query);

	function ShopQuery() {
		_classCallCheck(this, ShopQuery);

		return _possibleConstructorReturn(this, (ShopQuery.__proto__ || Object.getPrototypeOf(ShopQuery)).apply(this, arguments));
	}

	_createClass(ShopQuery, [{
		key: 'setCategory',
		value: function setCategory(category) {
			var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			this.setSubcategory(category, null, reset);
		}
	}, {
		key: 'getCategory',
		value: function getCategory() {
			return this.getQueryParam('category');
		}
	}, {
		key: 'setSubcategory',
		value: function setSubcategory(category, subcategory) {
			var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			this.setQuery({ category: category, subcategory: subcategory }, reset);
		}
	}, {
		key: 'getSubcategory',
		value: function getSubcategory() {
			return this.getQueryParam('subcategory');
		}
	}, {
		key: 'addBrand',
		value: function addBrand(brand) {
			this.addValue('brand', brand);
		}
	}, {
		key: 'toggleBrand',
		value: function toggleBrand(brand) {
			this.toggleValue('brand', brand);
		}
	}, {
		key: 'getBrands',
		value: function getBrands() {
			return this.getQueryParamAsArray('brand');
		}
	}, {
		key: 'addShop',
		value: function addShop(shop) {
			this.addValue('shop', shop);
		}
	}, {
		key: 'toggleShop',
		value: function toggleShop(shop) {
			this.toggleValue('shop', shop);
		}
	}, {
		key: 'setShop',
		value: function setShop(shop) {
			this.setQuery({ shop: shop });
		}
	}, {
		key: 'getShops',
		value: function getShops() {
			return this.getQueryParamAsArray('shop');
		}
	}, {
		key: 'setMinPrice',
		value: function setMinPrice(min_price) {
			this.setQuery({ min_price: min_price });
		}
	}, {
		key: 'getMinPrice',
		value: function getMinPrice() {
			return this.getQueryParam('min_price');
		}
	}, {
		key: 'setMaxPrice',
		value: function setMaxPrice(max_price) {
			this.setQuery({ max_price: max_price });
		}
	}, {
		key: 'getMaxPrice',
		value: function getMaxPrice() {
			return this.getQueryParam('max_price');
		}
	}, {
		key: 'getAttributeValues',
		value: function getAttributeValues(attr) {
			return this.getQueryParamAsArray(attr);
		}
	}, {
		key: 'toggleAttribute',
		value: function toggleAttribute(attr, value) {
			this.toggleValue(attr, value);
		}
	}, {
		key: 'setSortBy',
		value: function setSortBy(sort) {
			this.setQuery({ sort: sort });
		}
	}, {
		key: 'getSortBy',
		value: function getSortBy() {
			return this.getQueryParam('sort');
		}
	}, {
		key: 'setLimit',
		value: function setLimit(limit) {
			var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			this.setQuery({ limit: limit, page: page });
		}
	}, {
		key: 'getLimit',
		value: function getLimit() {
			return this.getQueryParam('limit');
		}
	}, {
		key: 'setPage',
		value: function setPage(page) {
			this.setQuery({ page: page });
		}
	}, {
		key: 'getPage',
		value: function getPage() {
			return this.getQueryParam('page');
		}
	}, {
		key: 'getPageUrl',
		value: function getPageUrl(page) {
			return this.generateUrl({ page: page });
		}
	}, {
		key: 'setLayout',
		value: function setLayout(layout) {
			this.setQuery({ layout: layout });
		}
	}, {
		key: 'getLayout',
		value: function getLayout() {
			return this.getQueryParam('layout');
		}
	}, {
		key: 'getSearch',
		value: function getSearch() {
			return this.getQueryParam('search');
		}
	}, {
		key: 'setSearch',
		value: function setSearch(search) {
			// don't reset the query if search is empty
			return this.setQuery({ search: search }, !!search);
		}
	}, {
		key: 'getSearchResults',
		value: function getSearchResults() {
			return this.getQueryParam('search_results');
		}
	}, {
		key: 'setSearchResults',
		value: function setSearchResults(search_results) {
			return this.setQuery({ search_results: search_results });
		}
	}, {
		key: 'setParam',
		value: function setParam(param, value) {
			var query = {};
			query[param] = value;
			return this.setQuery(query);
		}
	}, {
		key: 'setQuery',
		value: function setQuery(params, reset) {
			if (!reset) {
				// reset page
				if (params.page === undefined) {
					params.page = null;
				}
			}
			return _get(ShopQuery.prototype.__proto__ || Object.getPrototypeOf(ShopQuery.prototype), 'setQuery', this).call(this, params, reset);
		}
	}, {
		key: '_constructUrl',
		value: function _constructUrl(selection) {
			var path = '';
			if (selection.category) {
				path += '/' + selection.category;
				if (selection.subcategory) {
					path += '/' + selection.subcategory;
				}
				selection = __WEBPACK_IMPORTED_MODULE_0_lib_underscore__["omit"](selection, 'category', 'subcategory');
			}
			var url = _get(ShopQuery.prototype.__proto__ || Object.getPrototypeOf(ShopQuery.prototype), '_constructUrl', this).call(this, selection);
			return new __WEBPACK_IMPORTED_MODULE_1_core_utils_nav_router__["a" /* NavUrl */](path, url.queryData);
		}
	}]);

	return ShopQuery;
}(__WEBPACK_IMPORTED_MODULE_2_core_utils_nav_query__["a" /* Query */]);

/** @var {Router} */


var router = new __WEBPACK_IMPORTED_MODULE_1_core_utils_nav_router__["b" /* Router */]();
/** @var {ShopQuery} */
var query = new ShopQuery(router);
/** @var {Loader} */
var loader = new __WEBPACK_IMPORTED_MODULE_3_core_utils_nav_loader__["a" /* Loader */](router);

function init(baseUrl, apiUrl) {
	router.init(baseUrl);
	loader.apiUrl = apiUrl;
}

/***/ }),

/***/ "fokk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createIframeDialog"] = createIframeDialog;
/* harmony export (immutable) */ __webpack_exports__["createHtmlDialog"] = createHtmlDialog;
/* harmony export (immutable) */ __webpack_exports__["openHtmlDialog"] = openHtmlDialog;
/* harmony export (immutable) */ __webpack_exports__["createWindowDialog"] = createWindowDialog;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dialogManager", function() { return dialogManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_less__ = __webpack_require__("vBks");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dialog_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__("YnTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_var__ = __webpack_require__("dTkA");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var logger = Object(__WEBPACK_IMPORTED_MODULE_3__utils_logger__["a" /* newLogger */])('ZDialog');

/**
 * Creates new dialog with IFrame with given url
 * @param {string} url IFrame url
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog}
 */
function createIframeDialog(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: url, type: 'iframe', __width: 800 }, options));
}

/**
 * Creates new dialog instance.
 * autoOpen option is false by default, so you should either call open() method
 * or override autoOpen option
 * @param {*} content HTML content. Can be either valid HTML string, or DOM node, or jQuery object
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog} Dialog instance
 */
function createHtmlDialog(content) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: content, type: 'html', showCloseButton: true }, options));
}

/**
 * The same as {@link createHtmlDialog()} but with autoOpen enabled
 * @param {*} content HTML content
 * @param {object} options ZDialog options
 * @return {ZDialog} Dialog instance
 */
function openHtmlDialog(content) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return createHtmlDialog(content, _extends({ autoOpen: true }, options));
}

/**
 * Creates new dialog as new window with given url
 * @param {string} url IFrame url
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog}
 */
function createWindowDialog(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: url, type: 'window' }, options));
}

// add some helper functions to jQuery
$.extend($.fn, {
	/**
  * Calls {@link openHtmlDialog()} with source element as content
  * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
  */
	zdialog: function zdialog() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		var $el = $(this);
		var $placeholder = $('<div style="display: none !important;"></div>').insertAfter($el);
		var isInDom = $el.closest(document.documentElement);
		var isVisible = $el.css('display') != 'none';
		if (isInDom) {
			$el.detach();
		}
		if (!isVisible) {
			$el.show();
		}
		var dialog = createHtmlDialog($el, options);
		dialog.onBeforeClose(function () {
			$el.detach();
		});
		dialog.onClose(function () {
			if (isInDom) {
				$el.insertAfter($placeholder);
			}
			if (!isVisible) {
				$el.hide();
			}
			$placeholder.remove();
		});
		dialog.open();
		$el.data('zdialogInstance', dialog);
		return this;
	},

	/**
  * Returns ZDialog instance for given element (if the dialog was created with {@link jQuery.fn.zdialog} function)
  * @return {ZDialog}
  */
	zdialogInstance: function zdialogInstance() {
		return this.data('zdialogInstance');
	}
});

// FOR TESTING
/*import {MODAL_ASK_REDIRECT, MODAL_CRITICAL_NEWS, MODAL_LOGIN, MODAL_PACKAGE_INFO, MODAL_REVIEW} from "../modals";
$('.logo').click(function(e) {
	e.preventDefault();
	const queue = [];
	const showNext = () => {
		if (queue.length > 0) {
			queue.shift()();
		}
	};
	const onOpen = () => {};
	// queue.push(() => MODAL_REVIEW.show(104625).onOpen(showNext));
	// queue.push(() => MODAL_LOGIN.show().onOpen(showNext));
	// queue.push(() => MODAL_PACKAGE_INFO.show(1803110691).onOpen(showNext));
	// queue.push(() => MODAL_ASK_REDIRECT.show().onOpen(showNext));
	// queue.push(() => MODAL_CRITICAL_NEWS.show(312).onOpen(showNext));
	queue.push(() => openHtmlDialog('<div rel="show-next" style="width: 400px; height: 400px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 400px; height: 1000px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 1500px; height: 400px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 400px; height: 400px; background: red;"></div>', {fullscreen: true}).onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 2500px; height: 2500px; background: red;"></div>', {fullscreen: true}).onOpen(onOpen));
	showNext();

	$(document).on('click', '.zdialog-html > div', showNext);
});*/

/**
 * @param {object} options
 * @return {ZDialog}
 */
var newDialog = function newDialog(options) {
	return new ZDialog(options);
};

// force use newDialog function from top window
var key = '__zdialog_newDialog';
if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["b" /* checkIsIframe */])()) {
	newDialog = window.top[key];
} else {
	window.top[key] = newDialog;
}

/**
 * Dialog class
 */

var ZDialog = function () {
	/** @type {JQuery.Callbacks} */

	/** @type {JQuery.Callbacks} */

	/** @type {HeightWatcher} */
	function ZDialog(options) {
		_classCallCheck(this, ZDialog);

		this._width = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable();
		this._height = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable();
		this._isModal = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isCloseBtnVisible = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isLoading = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isOpened = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isClosed = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isHidden = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._contentHeight = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(0);
		this._iframeHeight = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(0);
		this._opened = false;
		this._onOpen = $.Callbacks();
		this._onClose = $.Callbacks();
		this._onBeforeClose = $.Callbacks();
		this._result = null;

		var o = _extends({}, ZDialog.defaults, options);

		this._name = o.name;
		this._o = o;
		this._isModal(!!o.modal);
		this._isCloseBtnVisible(!!o.showCloseButton);
		this._width(o.width);
		this._height(o.height);

		if (o.onOpen) {
			this._onOpen.add(o.onOpen);
		}
		if (o.onClose) {
			this._onClose.add(o.onClose);
		}

		if (o.autoOpen) {
			this.open();
		}
	}
	/** @type {JQuery.Callbacks} */


	// options


	_createClass(ZDialog, [{
		key: "open",
		value: function open() {
			var _this = this;

			if (this.isOpened) {
				return;
			}
			this._isClosed(false);
			this._isHidden(false);
			this._result = null;
			if (this.type === 'window') {
				this._wnd = window.open(this.content);
				this._wnd.addEventListener('DOMContentLoaded', function () {
					return _this._handleWindowReady();
				});
				this._wnd.onbeforeunload = function () {
					if (!_this.isClosed) {
						_this.close();
					}
				};
				this._isLoading(true);
			} else if (!dialogManager.isRegistered(this)) {
				if (this.isFullScreen) {
					this._width('');
					this._height('');
					this._contentHeight('');
					this._iframeHeight('');
				}
				if (this.type === 'iframe') {
					this._isLoading(true);
					if (!this.isAutoHeight) {
						this._contentHeight(this.height);
						this._iframeHeight(this.height);
					} else {
						this._contentHeight('');
					}
				} else {
					this._contentHeight(this.height);
					this._isOpened(true);
					setTimeout(function () {
						return _this._onOpen.fireWith(_this);
					}, 0);
				}
				dialogManager.register(this);
			} else if (this._isHidden()) {
				dialogManager.show(this);
			}
		}
	}, {
		key: "close",
		value: function close() {
			var _this2 = this;

			if (this.isClosed) {
				return;
			}
			this._onBeforeClose.fireWith(this, [this._result]);
			this._isOpened(false);
			this._isHidden(false);
			this._isClosed(true);
			if (this.type === 'window') {
				if (this._wnd) {
					this._wnd.close();
					window.top.focus();
					this._wnd = null;
					setTimeout(function () {
						return _this2._onClose.fireWith(_this2, [_this2._result]);
					}, 0);
				}
			} else if (dialogManager.isRegistered(this)) {
				if (this._heightWatcher) {
					this._heightWatcher.off();
				}
				dialogManager.unregister(this);
				setTimeout(function () {
					return _this2._onClose.fireWith(_this2, [_this2._result]);
				}, 0);
			}
		}
	}, {
		key: "hide",
		value: function hide() {
			if (this.type === 'window') {
				logger.error('Method is not supported for current dialog type');
			} else if (dialogManager.isRegistered(this)) {
				this._isOpened(false);
				this._isHidden(true);
				dialogManager.hide(this);
			}
		}
	}, {
		key: "closeWithResult",
		value: function closeWithResult(result) {
			this.result = result;
			this.close();
		}
	}, {
		key: "updatePosition",
		value: function updatePosition() {
			if (this.type === 'iframe') {
				this._contentHeight(this.iframeHeight);
			}
		}

		/** @return {string} */

	}, {
		key: "handleIframeLoad",
		value: function handleIframeLoad(item, e) {
			var _this3 = this;

			logger.log('loaded', e);
			this._isLoading(false);

			if (!this.isFullScreen && this.isAutoHeight) {
				this._heightWatcher = new HeightWatcher(e.target, function (newHeight) {
					logger.log("new height = " + newHeight);
					_this3._iframeHeight(newHeight);
					if (!_this3.contentHeight) {
						_this3._contentHeight(newHeight);
					}
					_this3._isOpened(true);
					setTimeout(function () {
						return _this3._onOpen.fireWith(_this3);
					}, 0);
				});
			} else {
				this._isOpened(true);
				setTimeout(function () {
					return _this3._onOpen.fireWith(_this3);
				}, 0);
			}

			// inject this instance to iframe
			e.target.contentWindow.dialogInstance = this;

			// apply special classes
			$(e.target.contentWindow.document.body).toggleClass('zdialog-layout-modal', this.isModal).toggleClass('zdialog-layout-autoheight', this.isAutoHeight).toggleClass('zdialog-layout-fullscreen', this.isFullScreen);

			// triger event inside iframe
			e.target.contentWindow.$(e.target.contentWindow.document).trigger('zdialog-shown');
		}
	}, {
		key: "_handleWindowReady",
		value: function _handleWindowReady(e) {
			var _this4 = this;

			logger.log('loaded', e);
			this._isLoading(false);
			this._isOpened(true);

			// inject this instance to iframe
			this._wnd.dialogInstance = this;
			$(this._wnd.document.body).addClass('zdialog-layout-window');

			setTimeout(function () {
				return _this4._onOpen.fireWith(_this4);
			}, 0);
		}
	}, {
		key: "handleCloseClick",
		value: function handleCloseClick(item, e) {
			var $target = $(e.target);
			if ($target.is('[data-dialog-result]')) {
				this.result = $target.data('dialogResult');
			}
			this.close();
		}
	}, {
		key: "handleBackdropClick",
		value: function handleBackdropClick() {
			if (dialogManager.isTopmost(this) && !this.isModal) {
				this.close();
			}
		}
	}, {
		key: "onOpen",
		value: function onOpen(callback) {
			this._onOpen.add(callback);
		}
	}, {
		key: "offOpen",
		value: function offOpen(callback) {
			this._onOpen.remove(callback);
		}
	}, {
		key: "onClose",
		value: function onClose(callback) {
			this._onClose.add(callback);
		}
	}, {
		key: "offClose",
		value: function offClose(callback) {
			this._onClose.remove(callback);
		}
	}, {
		key: "onBeforeClose",
		value: function onBeforeClose(callback) {
			this._onBeforeClose.add(callback);
		}
	}, {
		key: "offBeforeClose",
		value: function offBeforeClose(callback) {
			this._onBeforeClose.remove(callback);
		}
	}, {
		key: "name",
		get: function get() {
			return this._name;
		}

		/** @return {string} */

	}, {
		key: "type",
		get: function get() {
			return this._o.type;
		}

		/** @return {string} */

	}, {
		key: "content",
		get: function get() {
			return this._o.content;
		}

		/** @return {string} */

	}, {
		key: "title",
		get: function get() {
			return this._o.title;
		}

		/** @return {number} */

	}, {
		key: "width",
		get: function get() {
			return this._width();
		}

		/** @return {number|string} */

	}, {
		key: "height",
		get: function get() {
			return this._height();
		}

		/** @return {number|string} */

	}, {
		key: "minWidth",
		get: function get() {
			return this._o.minWidth;
		}

		/** @return {number|string} */

	}, {
		key: "maxWidth",
		get: function get() {
			return this._o.maxWidth;
		}

		/** @return {number|string} */

	}, {
		key: "contentWidth",
		get: function get() {
			return this._width();
		}

		/** @return {number|string} */

	}, {
		key: "contentHeight",
		get: function get() {
			return this._contentHeight();
		}

		/** @return {number} */

	}, {
		key: "iframeHeight",
		get: function get() {
			return this._iframeHeight();
		}

		/** @return {boolean} */

	}, {
		key: "isLoading",
		get: function get() {
			return this._isLoading();
		}

		/** @return {boolean} */

	}, {
		key: "isOpened",
		get: function get() {
			return this._isOpened();
		}

		/** @return {boolean} */

	}, {
		key: "isClosed",
		get: function get() {
			return this._isClosed();
		}

		/** @return {boolean} */

	}, {
		key: "isHidden",
		get: function get() {
			return this._isHidden();
		}

		/** @return {boolean} */

	}, {
		key: "isModal",
		get: function get() {
			return this._isModal();
		}

		/** @return {boolean} */

	}, {
		key: "isCloseBtnVisible",
		get: function get() {
			return this._isCloseBtnVisible();
		}

		/** @type {boolean} */

	}, {
		key: "isFullScreen",
		get: function get() {
			return this._o.fullscreen;
		}

		/** @type {boolean} */

	}, {
		key: "isAutoHeight",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_5__utils_var__["d" /* asString */])(this.height) === '' || this.height === 'auto';
		}

		/** @return {*} */

	}, {
		key: "result",
		get: function get() {
			return this._result;
		}

		/**
   * @param {*} value
   */
		,
		set: function set(value) {
			this._result = value;
		}

		/**
   * @return {*}
   */

	}, {
		key: "customData",
		get: function get() {
			return this._o.custom;
		}

		/**
   * @return {string}
   */

	}, {
		key: "cssClass",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_5__utils_var__["d" /* asString */])(this._o.cssClass);
		}
	}]);

	return ZDialog;
}();

ZDialog.defaults = {
	name: '',
	type: 'iframe', // iframe, html
	content: '',
	title: '',
	buttons: [],
	modal: false,
	autoOpen: false,
	showCloseButton: false,

	width: '',
	height: '',
	fullscreen: false,
	cssClass: '',

	custom: null,

	//events
	onOpen: null,
	onClose: null
};

var DialogManager = function () {
	/** @type {KnockoutObservableArray<ZDialog>} */
	function DialogManager() {
		var _this5 = this;

		_classCallCheck(this, DialogManager);

		this._counter = 0;
		this._dialogs = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observableArray([]);
		this._isClosing = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._initialized = false;
		this._wrapper = new WindowWrapper();

		this._$html = $('html');
		this._$body = $('body');

		this._isLoading = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.any(_this5.dialogs, function (d) {
				return d.isLoading;
			});
		});

		this._visibleDialogs = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.pureComputed(function () {
			return _this5.dialogs.filter(function (d) {
				return !d.isHidden;
			});
		});
	}

	/**
  * @param {ZDialog} dialog
  */


	_createClass(DialogManager, [{
		key: "register",
		value: function register(dialog) {
			if (this.isRegistered(dialog)) {
				return;
			}

			this._dialogs.push(dialog);
			this._checkMarkupAfterOpen();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "unregister",
		value: function unregister(dialog) {
			if (this._dialogs.remove(dialog).length === 0) {
				// nothing has been removed
				return;
			}
			this._checkMarkupAfterClose();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "hide",
		value: function hide(dialog) {
			if (this.isRegistered(dialog)) {
				this._checkMarkupAfterClose();
			}
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "show",
		value: function show(dialog) {
			if (this.isRegistered(dialog)) {
				this._checkMarkupAfterOpen();
			}
		}
	}, {
		key: "_checkMarkupAfterOpen",
		value: function _checkMarkupAfterOpen() {
			if (this._isClosing()) {
				clearTimeout(this._timeout);
				this._timeout = null;
				this._isClosing(false);
			} else if (this.visibleDialogs.length === 1 && !this._initialized) {
				this._wrapper.on();

				if (!this._$el) {
					this._$el = $("<div class=\"zdialog-wrapper\" data-bind=\"component: {name: 'zdialog-wrapper', params: $data}, \n\t\t\t\t\t\t\t\t\t\tcss: {'zdialog-loading': isLoading, 'zdialog-closing': isClosing}\"></div>");
					__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.applyBindings(this, this._$el[0]);
					this._$el.appendTo('body');
				} else {
					this._$el.show();
				}
				this._initialized = true;
			}
		}
	}, {
		key: "_checkMarkupAfterClose",
		value: function _checkMarkupAfterClose() {
			var _this6 = this;

			if (!this._isClosing() && this.visibleDialogs.length === 0 && this._initialized) {
				// no dialogs left
				this._isClosing(true);
				this._timeout = setTimeout(function () {
					_this6._wrapper.off();
					// logger.log('remove container');
					_this6._$el.remove();
					__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.cleanNode(_this6._$el[0]);
					_this6._$el = null;
					_this6._initialized = false;
					_this6._isClosing(false);
				}, 300);
			}
		}

		/**
   * @param {ZDialog} dialog
   * @return {boolean}
   */

	}, {
		key: "isRegistered",
		value: function isRegistered(dialog) {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.contains(this.dialogs, dialog);
		}
	}, {
		key: "handleBeforeRemove",
		value: function handleBeforeRemove(node) {
			var $node = $(node);
			$node.remove();
			/*if (node.nodeType === 3) {
   	$node.remove();
   	return;
   }
   $node.addClass('zdialog-closing');
   setTimeout(() => $node.remove(), 300);*/
		}

		/** @return {ZDialog[]} */

	}, {
		key: "getTopmostDialog",
		value: function getTopmostDialog() {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.last(this.visibleDialogs.filter(function (d) {
				return !d.isLoading;
			}));
		}
	}, {
		key: "isTopmost",
		value: function isTopmost(dialog) {
			return dialog === this.getTopmostDialog();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "getDialogClass",
		value: function getDialogClass(dialog) {
			var css = [];
			if (dialog.isModal) {
				css.push('zdialog-modal');
			}
			if (dialog.isFullScreen) {
				css.push('zdialog-fullscreen');
			}
			if (this.isTopmost(dialog)) {
				css.push('zdialog-topmost');
			} else if (this.visibleDialogs.length > 1) {
				css.push('zdialog-overlapped');
			}
			if (dialog.isLoading) {
				css.push('zdialog-loading');
			}
			if (dialog.isOpened) {
				css.push('zdialog-opened');
			}
			if (dialog.isHidden) {
				css.push('zdialog-hidden');
			}
			if (dialog.name) {
				css.push('zdialog-instance-' + dialog.name);
			}
			if (dialog.cssClass) {
				css.push(dialog.cssClass);
			}
			return css.join(' ');
		}
	}, {
		key: "dialogs",
		get: function get() {
			return this._dialogs();
		}

		/** @return {ZDialog[]} */

	}, {
		key: "visibleDialogs",
		get: function get() {
			return this._visibleDialogs();
		}

		/** @return {boolean} */

	}, {
		key: "isLoading",
		get: function get() {
			return this._isLoading();
		}

		/** @return {boolean} */

	}, {
		key: "isClosing",
		get: function get() {
			return this._isClosing();
		}
	}]);

	return DialogManager;
}();

var HeightWatcher = function () {
	function HeightWatcher($iframe, callback) {
		var _this7 = this;

		_classCallCheck(this, HeightWatcher);

		this._currHeight = 0;
		this._event = $.Callbacks();

		this._event.add(callback);
		this._ibody = $($iframe)[0].contentWindow.document.body;
		// this.updateHeight();
		setTimeout(function () {
			_this7.updateHeight();
			_this7._interval = setInterval(function () {
				return _this7.updateHeight();
			}, 50);
		}, 0);
	}

	_createClass(HeightWatcher, [{
		key: "updateHeight",
		value: function updateHeight() {
			// const newHeight = this._ibody.offsetHeight;
			var newHeight = this.getHeight();
			if (newHeight !== this._currHeight) {
				this._currHeight = newHeight;
				this._event.fire(newHeight);
			}
		}
	}, {
		key: "getHeight",
		value: function getHeight() {
			var height = this._ibody.scrollHeight;
			$(this._ibody).find('iframe:visible').filter(function () {
				return $(this).css('visibility') !== 'hidden';
			}).each(function () {
				var iHeight = $(this).height();
				if (iHeight > height) {
					height = iHeight;
				}
			});
			return height;
		}
	}, {
		key: "off",
		value: function off() {
			clearInterval(this._interval);
			this._event.empty();
		}
	}]);

	return HeightWatcher;
}();

var WindowWrapper = function () {
	function WindowWrapper() {
		_classCallCheck(this, WindowWrapper);

		this._$wnd = $(window);
		this._$html = $('html');
		this._$head = $('head');
		this._scrollTop = 0;
		this._scrollLeft = 0;

		this._$scrollBarStyle = $("<style type=\"text/css\"></style>").appendTo(this._$head);
		this._$positionStyle = $("<style type=\"text/css\"></style>").appendTo(this._$head);
		// this._useFixedLayout = /(iPod|iPhone|iPad)/.test(navigator.userAgent);
		this._useFixedLayout = Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["c" /* isMobile */])(); ///(iPod|iPhone|iPad)/.test(navigator.userAgent);
	}

	_createClass(WindowWrapper, [{
		key: "on",
		value: function on() {
			if (this._useFixedLayout) {
				this._scrollTop = this._$wnd.scrollTop();
				this._scrollLeft = this._$wnd.scrollLeft();
				this._applyPositionStyle();
				this._$wnd.scrollTop(0).scrollLeft(0);
			}
			this._applyScrollbarStyle();

			this._$html.toggleClass('zdialog-scrollbar-fix', this._hasScrollBar()).toggleClass('zdialog-position-fix', this._useFixedLayout).addClass('zdialog-open');
		}
	}, {
		key: "off",
		value: function off() {
			this._$html.removeClass('zdialog-scrollbar-fix').removeClass('zdialog-position-fix').removeClass('zdialog-open');
			if (this._useFixedLayout) {
				this._$wnd.scrollTop(this._scrollTop).scrollLeft(this._scrollLeft);
			}
		}
	}, {
		key: "_applyScrollbarStyle",
		value: function _applyScrollbarStyle() {
			var scrollBarWidth = getScrollBarWidth();
			// language=CSS
			this._$scrollBarStyle.html("\n.zdialog-scrollbar-fix {\n\tpadding-right: " + scrollBarWidth + "px;\n}\n");
		}
	}, {
		key: "_applyPositionStyle",
		value: function _applyPositionStyle() {
			// language=CSS
			this._$positionStyle.html("\n.zdialog-position-fix {\n\tposition: fixed;\n\twidth: 100%;\n\theight: 100%;\n\ttop: -" + this._scrollTop + "px;\n\tleft: -" + this._scrollLeft + "px;\n}\n");
		}
	}, {
		key: "_hasScrollBar",
		value: function _hasScrollBar() {
			return hasScrollBar(this._$html);
		}
	}]);

	return WindowWrapper;
}();

function getScrollBarWidth() {
	var $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body'),
	    widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
	$outer.remove();
	return 100 - widthWithScroll;
}

function hasScrollBar(el) {
	var $el = $(el);
	return $el.length > 0 ? $el[0].scrollHeight > $(window).height() : false;
}

var dialogManager = new DialogManager();

__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-wrapper', {
	template: "\n<div class=\"zdialog-overlay\"></div>\n<div class=\"zdialog-loader\"></div>\n<div data-bind=\"foreach: {data: dialogs, beforeRemove: handleBeforeRemove}\">\n\t<div class=\"zdialog-container\">\n\t\t<div class=\"zdialog\" data-bind=\"component: {name: 'zdialog', params: $data}, height: contentHeight, \n\t\t\t\t\t\t\t\t\t\tcss: $parent.getDialogClass($data)\"></div>\n\t</div>\n</div>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog', {
	template: "\n<div class=\"zdialog-backdrop\" data-bind=\"click: handleBackdropClick\"></div>\n<div class=\"zdialog-content\" data-bind=\"css: 'zdialog-content-' + type, \n\t\t\t\t\t\t\t\t\t\tcomponent: {name: 'zdialog-content-' + type, params: $data},\n\t\t\t\t\t\t\t\t\t\twidth: contentWidth\"></div>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-content-iframe', {
	template: "\n<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n<iframe class=\"zdialog-iframe\" frameborder=\"0\" vspace=\"0\" hspace=\"0\" scrolling=\"auto\"\n\t\tdata-bind=\"attr: {src: content}, event: {load: handleIframeLoad}, height: iframeHeight\"></iframe>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-content-html', {
	template: "\n<!-- ko if: title -->\n<h2 class=\"zdialog-title\">\n\t<span data-bind=\"html: title\"></span>\n\t<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n</h2>\n<!-- /ko -->\n<!-- ko ifnot: title -->\n<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n<!-- /ko -->\n<div class=\"zdialog-html\" data-bind=\"html: content, on: {events: 'click', selector: '[rel=close-dialog]', handler: handleCloseClick}\"></div>\n".trim()
});

/***/ }),

/***/ "iOFR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j16w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ion_rangeslider__ = __webpack_require__("b/Fu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ion_rangeslider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ion_rangeslider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ion_rangeslider_css_ion_rangeSlider_css__ = __webpack_require__("wEGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ion_rangeslider_css_ion_rangeSlider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ion_rangeslider_css_ion_rangeSlider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ion_rangeslider_css_ion_rangeSlider_skinHTML5_css__ = __webpack_require__("1QSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ion_rangeslider_css_ion_rangeSlider_skinHTML5_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ion_rangeslider_css_ion_rangeSlider_skinHTML5_css__);




/***/ }),

/***/ "l4Yc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loading_less__ = __webpack_require__("iOFR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loading_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loading_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("YnTO");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var $el = void 0;
var counter = 0;
var iframeOverride = Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* checkIsIframe */])() ? window.top.zde.loading : {};

/* harmony default export */ __webpack_exports__["a"] = (_extends({
	/**
  * Shows loading spinner
  */
	show: function show() {
		if (!$el) {
			$el = $('<div class="zloader"></div>').appendTo('body');
			/*$el = $(`<div class="zloader2">
   <div></div>
   <div></div>
   <div></div>
   </div>`).appendTo('body');*/
		}
		counter++;
	},

	/**
  * Shows loading spinner
  */
	hide: function hide() {
		if ($el && --counter <= 0) {
			$el.addClass('zloader-closing');
			// let animation finish and remove the element
			var $element = $el;
			setTimeout(function () {
				$element.remove();
			}, 1000);
			$el = null;
			counter = 0;
		}
	}

}, iframeOverride));

/***/ }),

/***/ "m9tG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shopData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return settings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return debugInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_globals__ = __webpack_require__("TxBK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_settings__ = __webpack_require__("WISg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_debuginfo__ = __webpack_require__("EfVR");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var logger = Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_logger__["a" /* newLogger */])('Shop');

var shopData = _extends({
	categories: [],
	categoryGroups: []

}, Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_globals__["a" /* globals */])('shopData'));
logger.log('data', shopData);

/** @type {Settings} */
var settings = new __WEBPACK_IMPORTED_MODULE_2__model_settings__["a" /* Settings */](Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_globals__["a" /* globals */])('shopSettings'));
logger.log('settings', settings);

/** @type {DebugInfo} */
var debugInfo = new __WEBPACK_IMPORTED_MODULE_3__model_debuginfo__["a" /* DebugInfo */]();

// todo: move this code out of here
// force offer links open in new window
(function () {
	var url = settings.getOfferUrl('');
	$(document).on('click', "a[href^=\"" + url + "\"]:not([target])", function (e) {
		if (!e.isDefaultPrevented()) {
			e.preventDefault();
			window.open($(this).attr('href'));
		}
	});
})();

/***/ }),

/***/ "og09":
/***/ (function(module, exports) {

module.exports = toastr;

/***/ }),

/***/ "plkG":
/***/ (function(module, exports) {

module.exports = "<!-- ko with: list -->\n<ul class=\"category-list\" data-bind=\"foreach: visibleItems\">\n\t<li class=\"category-item\"\n\t\tdata-bind=\"css: {fake: id == 0, active: $parent.activeItem == $data}, click: $parent.handleClick, event: {mouseover: $parent.handleMouseOver}\">\n\t\t<a data-bind=\"attr: {href: url}\">\n\t\t\t<span class=\"item-name\" data-bind=\"text: title\"></span>\n\t\t\t<span class=\"parametric-counter\" data-bind=\"numeral: {value: count, format: '0 a', titleFormat: '0,0'}\"></span>\n\t\t</a>\n\t</li>\n</ul>\n<!-- /ko -->"

/***/ }),

/***/ "rItL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = showModalIframe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_dialog__ = __webpack_require__("fokk");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * Shows iframe-based modal window
 * @param {string} name Modal name
 * @param {object} data Custom data to passed as GET parameters
 * @param {object} dialogOptions Options for {@link ZDialog} instance
 * @return {ZDialog}
 */
function showModalIframe(name) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var dialogOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  data = _extends({}, data);
  for (var key in data) {
    if (data[key] === null) delete data[key];
  }var query = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(_extends({}, data));
  var url = Object(__WEBPACK_IMPORTED_MODULE_1__url__["g" /* siteUrl */])('modals/' + name + (query ? '?' + query : ''));
  return Object(__WEBPACK_IMPORTED_MODULE_2__widgets_dialog__["createIframeDialog"])(url, _extends({ name: name }, dialogOptions, { autoOpen: true }));
}

/***/ }),

/***/ "szBx":
/***/ (function(module, exports) {

module.exports = "<!-- ko with: list -->\n<ul class=\"tags-list\" data-bind=\"foreach: visibleItems\">\n\t<li class=\"tag\" data-bind=\"css: {active: selected, disabled: disabled}, css2: $parent.name + '-' + name,\n\t\t\t\t\t\t\t\t\t\t   click: $parent.handleClick, attr: {title: hint}\">\n\t\t<span data-bind=\"text: title\"></span>\n\t</li>\n</ul>\n<!-- /ko -->"

/***/ }),

/***/ "tXil":
/***/ (function(module, exports) {

var Smart = {};

// Embed the Smart.Plurals source: 


// Create namespace:
if (typeof Smart !== 'object')
	Smart = {};

(function() {

	var rules = {} // Map of language codes to rules
		, defaultCode = null
		, defaultRule = null;

	Smart.Plurals = {
		/**
		 * Retrieves a plural rule, based on the supplied language code.
		 * If no languageCode is specified, the default rule will be returned.
		 *
		 * A plural rule is a function that takes in a value
		 * and determines whether it should be singular form, plural form,
		 * or even other forms, depending on the number of choices.
		 *
		 * @param {String} [languageCode] - Optional - a 2-letter or 4-letter language code, or the full ruleName.
		 * @returns {function({Number} value, {Number|Array} choices)}
		 */
		getRule: function(languageCode) {
			// Calling this with no parameters will return the default:
			if (!languageCode) {
				return defaultRule || (defaultRule = this.getRule(defaultCode));
			}

			// Normalize:
			languageCode = ',' + languageCode.toLowerCase() + ',';

			// Search for an "exact match":
			for (var languageCodes in rules) {
				if (!rules.hasOwnProperty(languageCodes)) continue;

				var isExactMatch = (languageCodes.indexOf(languageCode) !== -1);
				if (isExactMatch) {
					return rules[languageCodes];
				}
			}

			// If we've got a 4-letter code, search for a "generic match" (2-letter code):
			var dash = languageCode.indexOf('-');
			if (dash !== -1) {
				var twoLetterCode = languageCode.substring(1, dash);
				return this.getRule(twoLetterCode);
			}

			return null;
		}
		,
		/**
		 * Sets the default language rule.
		 *
		 * @param {String} languageCode - 2-letter or 4-letter language code
		 */
		setDefaultRule: function(languageCode) {
			defaultCode = languageCode.toLowerCase();
			defaultRule = null; // it's lazy loaded
		}
		,
		/**
		 * Defines a language rule.
		 *
		 * @param {String} languageCodes - A comma-separated list of 2-letter or 4-letter language codes
		 * @param {function({Number} value, {Number} choices)|String} pluralRule - The rule; see getRule for a description.
		 */
		defineRule: function(languageCodes, pluralRule) {
			// Normalize:
			languageCodes = ',' + languageCodes.toLowerCase() + ',';

			var normalizedRule;
			if (typeof pluralRule === 'string') {
				// Allows for aliases
				normalizedRule = this.getRule(pluralRule);
			} else {
				normalizedRule = function (value, choices) {
					if (typeof choices === 'number') {
						return pluralRule(value, choices);
					} else if (typeof choices.length === 'number') {
						return choices[pluralRule(value, choices.length)];
					}
				};
			}

			rules[languageCodes] = normalizedRule;

			if (!defaultCode) {
				this.setDefaultRule(languageCodes.split(',')[1]);
			}

			return normalizedRule;
		}
	};

})();

/**
 * Germanic family
 *  English, German, Dutch, Swedish, Danish, Norwegian, Faroese
 * Romanic family
 *  Spanish, Portuguese, Italian, Bulgarian
 * Latin/Greek family
 *  Greek
 * Finno-Ugric family
 *  Finnish, Estonian
 * Semitic family
 *  Hebrew
 * Artificial
 *  Esperanto
 * Finno-Ugric family
 *  Hungarian
 * Turkic/Altaic family
 *  Turkish
 */
Smart.Plurals.defineRule('english,en,de,nl,sv,da,no,nn,nb,fo,es,pt,it,bg,el,fi,et,he,eo,hu,tr',
	function pluralRule_english(value, choices) {
		// singular used for 1
		// special cases for 0 and negative
		var singular = (value === 1);
		if (choices === 2) return (singular ? 0 : 1);

		var zero = (value === 0);
		if (choices === 3) return (zero ? 0 : singular ? 1 : 2);

		var negative = (value < 0);
		return (negative ? 0 : zero ? 1 : singular ? 2 : 3);
	}
);

/**
 * Slavic family
 *  Czech, Slovak
 */
Smart.Plurals.defineRule('czech,cs,sk', function pluralRule_czech(value, choices) {
	// singular used for 1
	// special case for 2-4
	var singular = (value === 1);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value >= 2 && value <= 4);
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Romanic family
 *  French, Brazilian Portuguese
 */
Smart.Plurals.defineRule('french,fr,pt-br', function pluralRule_french(value, choices) {
	// singular used for 0 and 1
	var singular = (value === 0 || value === 1);
	return (singular ? 0 : 1);
});

/**
 * Celtic
 *  Gaeilge (Irish)
 */
Smart.Plurals.defineRule('irish,ga', function pluralRule_irish(value, choices) {
	// singular used for 1
	// special case for 2
	var singular = (value === 1);
	if (choices === 2) return (singular ? 0 : 1);

	var two = (value === 2);
	return (singular ? 0 : two ? 1 : 2);
});

/**
 * Baltic family
 *  Latvian
 */
Smart.Plurals.defineRule('latvian,lv', function pluralRule_latvian(value, choices) {
	// singular used for 1, 21, 31, 41... -- but not 11, 111, 211, 311, 411...
	// special case for 0
	var singular = (value % 10 === 1 && value % 100 != 11);
	if (choices === 2) return (singular ? 0 : 1);

	var zero = (value === 0);
	return (zero ? 0 : singular ? 1 : 2);
});

/**
 * Baltic family
 *  Lithuanian
 */
Smart.Plurals.defineRule('lithuanian,lt', function pluralRule_lithuanian(value, choices) {
	// singular used for numbers ending in 1 (1, 21, 31, 41...)
	// special case for numbers ending in 12-19 (12-19, 112-119, 212-219...)
	var singular = (value % 10 === 1 && value % 100 != 11);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value % 100 >= 12 && value % 100 <= 19);
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Slavic family
 *  Polish
 */
Smart.Plurals.defineRule('polish,pl', function pluralRule_polish(value, choices) {
	// singular used for 1
	// special case for numbers ending in 2-4, except for 12-14 (2-4, 22-24, 32-34...)
	var singular = (value === 1);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20));
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Romanic family
 *  Romanian
 */
Smart.Plurals.defineRule('romanian,ro', function pluralRule_romanian(value, choices) {
	// singular used for 1
	// special case for 0 and numbers ending in 01-19 (0, 2-19, 101-119, 201-219...)
	var singular = (value === 1);
	if (choices === 2) return (singular ? 0 : 1);

	var few = (value === 0 || (value % 100 >= 1 && value % 100 <= 19));
	return (singular ? 0 : few ? 1 : 2);
});

/**
 * Slavic family
 *  Russian, Ukrainian, Serbian, Croatian
 */
Smart.Plurals.defineRule('russian,ru,uk,sr,hr', function pluralRule_russian(value, choices) {
	// singular used for numbers ending in 1, except 11 (1, 21, 31...)
	// special case for numbers ending in 2-4, except 12-14 (2-4, 22-24, 32-34...)
	// numbers ending in 11-14 use plural (11-14, 111-114, 211-214...)
	var singular = (value % 10 === 1 && value % 100 != 11);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20));
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Slavic family
 *  Slovenian
 */
Smart.Plurals.defineRule('slovenian,sl', function pluralRule_slovenian(value, choices) {
	// singular used for numbers ending in 01 (1, 101, 201...)
	// special case for numbers ending in 02 (2, 102, 202...)
	// special case for numbers ending in 03-04 (3-4, 103-104, 203-204...)
	var singular = (value % 100 === 1);
	if (choices === 2) return singular ? 0 : 1;

	var two = (value % 100 === 2);
	if (choices === 3) return singular ? 0 : two ? 1 : 2;

	var few = (value % 100 === 3 || value % 100 === 4);
	return singular ? 0 : two ? 1 : few ? 2 : 3;
});


module.exports = Smart;


/***/ }),

/***/ "u2Mx":
/***/ (function(module, exports) {

module.exports = numeral;

/***/ }),

/***/ "vBks":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vSTT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_numeral__ = __webpack_require__("u2Mx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lib_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigator__ = __webpack_require__("f5a1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_rangeslider__ = __webpack_require__("j16w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_model_settings__ = __webpack_require__("WISg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_model_lists__ = __webpack_require__("7DQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_model_categories__ = __webpack_require__("ZQ2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_model_products__ = __webpack_require__("1zZn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_utils_lang__ = __webpack_require__("RaK1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__core_utils_var__ = __webpack_require__("dTkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_data__ = __webpack_require__("m9tG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__ = __webpack_require__("2uje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__core_widgets_loading__ = __webpack_require__("l4Yc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__core_modals__ = __webpack_require__("YdFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_components__ = __webpack_require__("Rjrh");
var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





















var logger = Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_logger__["a" /* newLogger */])('Catalog');

window.nav = __WEBPACK_IMPORTED_MODULE_4__navigator__;

/**
 *
 * @param {object} options
 * @return {CatalogViewModel}
 */
function init(options) {
	logger.log('init', options);
	var model = new CatalogViewModel(__WEBPACK_IMPORTED_MODULE_14__common_data__["b" /* settings */]);
	model.init(options);
	window.catalogModel = model;
	return model;
}

var CatalogViewModel = function () {
	function CatalogViewModel(settings) {
		_classCallCheck(this, CatalogViewModel);

		this.pageData = new PageData();
		this.ready = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);
		this.loading = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);
		this.error = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);
		this.initialized = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);
		this.settings = null;
		this.sidebar = new Sidebar();
		this.viewOptions = new ViewOptions();
		this.selection = new SelectionList();
		this.products = null;

		this.settings = settings;
		this.products = new CProductList(settings, this.sidebar);
		this.adminPanel = new AdminPanel(this.products);
	}
	/** @type {CProductList} */


	/** @type {Settings} */


	_createClass(CatalogViewModel, [{
		key: 'init',
		value: function init(options) {
			var _this = this;

			var o = _extends({
				meta: {},
				products: [],
				productsScores: {},
				favorites: []
			}, options);

			__WEBPACK_IMPORTED_MODULE_4__navigator__["init"](this.settings.shopUrl, this.settings.catalogApiUrl);
			__WEBPACK_IMPORTED_MODULE_4__navigator__["loader"].onStart(function () {
				_this.loading(true);
			});
			__WEBPACK_IMPORTED_MODULE_4__navigator__["loader"].onStop(function (success) {
				_this.loading(false);
				_this.error(!success);
			});
			__WEBPACK_IMPORTED_MODULE_4__navigator__["loader"].onResponse(function (data) {
				_this._updateServerDataWhenReady(data);
			});

			if (__WEBPACK_IMPORTED_MODULE_14__common_data__["c" /* shopData */]) {
				this.sidebar.initData(__WEBPACK_IMPORTED_MODULE_14__common_data__["c" /* shopData */]);
			}
			if (o.meta) {
				this._initMeta(o.meta);
			}
			this.pageData.init();

			this._initProducts(o);

			this.initialized(true);
			this.ready(true);

			this._initScrollTop();

			// fill debug info
			var searchCriteria = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSearch();
			});
			__WEBPACK_IMPORTED_MODULE_14__common_data__["a" /* debugInfo */].setSearchCriteria(searchCriteria());
			searchCriteria.subscribe(function (val) {
				__WEBPACK_IMPORTED_MODULE_14__common_data__["a" /* debugInfo */].setSearchCriteria(val);
			});
		}
	}, {
		key: '_updateServerDataWhenReady',
		value: function _updateServerDataWhenReady(data) {
			var _this2 = this;

			if (this.ready()) {
				this._updateServerData(data);
			} else {
				logger.log('delay server data');
				this._whenReady(function () {
					return _this2._updateServerData(data);
				});
			}
		}
	}, {
		key: '_updateServerData',
		value: function _updateServerData(data) {
			logger.log('init from data', data);
			if (data['meta']) {
				this._initMeta(data['meta']);
			}
			if (data['viewdata']) {
				this.pageData.update(data['viewdata']);
			}
			if (data['products']) {
				this._initProducts(data);
			}
		}
	}, {
		key: '_whenReady',
		value: function _whenReady(callback) {
			var _this3 = this;

			var subscription = this.ready.subscribe(function (val) {
				if (val) {
					callback.call(_this3);
					subscription.dispose();
				}
			});
		}
	}, {
		key: '_initScrollTop',
		value: function _initScrollTop() {
			var _this4 = this;

			this.viewOptions.onPageChanged(function () {
				return _this4._scrollTop();
			});
			this.viewOptions.onLimitChanged(function () {
				return _this4._scrollTop();
			});
		}
	}, {
		key: '_scrollTop',
		value: function _scrollTop() {
			var _this5 = this;

			logger.log('scroll to top');
			var top = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shopCatalog').offset().top;
			if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop() > top) {
				this.ready(false);
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop().animate({ scrollTop: top }, 500, function () {
					_this5.ready(true);
				});
			}
		}
	}, {
		key: '_initMeta',
		value: function _initMeta(meta) {
			this.sidebar.init(meta);
			this.viewOptions.init(meta);
			if (meta['selection']) {
				this.selection.init(meta['selection']);
			}
		}
	}, {
		key: '_initProducts',
		value: function _initProducts(data) {
			this.products.init({
				items: data['products'],
				favorites: data['favorites'],
				scores: data['productsScores']
			});
		}
	}, {
		key: 'selectedCategory',
		get: function get() {
			return this.sidebar.selectedCategory;
		}
	}, {
		key: 'selectedSubcategory',
		get: function get() {
			return this.sidebar.selectedSubcategory;
		}
	}]);

	return CatalogViewModel;
}();

var Sidebar = function () {
	_createClass(Sidebar, [{
		key: 'selectedCategory',


		/** @return {CategoryItem|null} */
		get: function get() {
			return this.categories.getItemByName(__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getCategory());
		}

		/** @return {SubcategoryItem|null} */

	}, {
		key: 'selectedSubcategory',
		get: function get() {
			var cat = this.selectedCategory;
			return cat ? cat.subcategories.getItemByName(__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSubcategory()) : null;
		}
	}]);

	function Sidebar() {
		var _this6 = this;

		_classCallCheck(this, Sidebar);

		this.categories = new __WEBPACK_IMPORTED_MODULE_10__common_model_categories__["b" /* CategoryList */]();
		this.attributes = new Attributes();
		this.brands = new BrandList();
		this.shops = new ShopList();
		this.priceRangeFilter = new PriceRangeFilter();
		this.discountRangeFilter = new DiscountRangeFilter();
		this.lastUpdateFilter = new LastUpdateFilter();
		this.availabilityFilter = new AvailabilityFilter();
		this.discountFilter = new DiscountFilter();
		this.categoryList = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			var cat = _this6.selectedCategory;
			if (cat) {
				if (_this6.selectedSubcategory) {
					return null;
				}
				return cat.subcategories;
			}
			return _this6.categories;
		});

		this.categories.onItemClick(function (item) {
			if (item instanceof __WEBPACK_IMPORTED_MODULE_10__common_model_categories__["d" /* SubcategoryItem */]) {
				__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setSubcategory(item.category.name, item.name);
			} else if (item instanceof __WEBPACK_IMPORTED_MODULE_10__common_model_categories__["a" /* CategoryItem */]) {
				__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setCategory(item.name);
			} else if (item instanceof __WEBPACK_IMPORTED_MODULE_10__common_model_categories__["c" /* PopularShopItem */]) {
				__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setCategory(item.category.name);
				__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setShop(item.id);
			}
		});

		this._isSearch = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return !!(__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSearch() || __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSearchResults());
		});
		/*this._isSearch.subscribe((isSearch) => {
  	this.categories.sortByCount = isSearch;
  })*/
	}

	_createClass(Sidebar, [{
		key: 'init',
		value: function init(meta) {
			this.categories.sortType = this._isSearch() ? 'count' : null;

			if (meta['data']) {
				this.initData(meta['data']);
			}
			if (meta['counts']) {
				this._updateCounts(meta['counts']);
			}
			if (meta['priceRange']) {
				this.priceRangeFilter.update(meta['priceRange']);
			}
			if (meta['discountRange']) {
				this.discountRangeFilter.update(meta['discountRange']);
			}
			if (meta['lastUpdateRange']) {
				this.lastUpdateFilter.update(meta['lastUpdateRange']);
			}
			if (meta['availabilitySet']) {
				this.availabilityFilter.update(meta['availabilitySet']);
			}
			if (meta['discountSet']) {
				this.discountFilter.update(meta['discountSet']);
			}
			// logger.log('Brand counts:', _.keys(meta.brands).length);
			// logger.log('Shop counts:', _.keys(meta.shops).length);
		}
	}, {
		key: 'initData',
		value: function initData(data) {
			if (data.categories) {
				this.categories.init(data.categories, data.categoryGroups);
			}
			if (data.brands) {
				this.brands.init(data.brands);
			}
			if (data.shops) {
				this.shops.init(data.shops);
			}
			if (data.attributes) {
				// init attributes only if any category is selected
				this.attributes.init(this._showAttributes ? data.attributes : []);
			}
		}
	}, {
		key: '_updateCounts',
		value: function _updateCounts(counts) {
			if (counts.categories) {
				this.categories.updateCounts(counts.categories);
			}
			if (counts.brands) {
				this.brands.updateCounts(counts.brands);
			}
			if (counts.shops) {
				this.shops.updateCounts(counts.shops);
			}
		}
	}, {
		key: '_showAttributes',
		get: function get() {
			return this.selectedCategory || this._isSearch();
		}
	}]);

	return Sidebar;
}();

var ViewOptions = function () {
	function ViewOptions() {
		var _this7 = this;

		_classCallCheck(this, ViewOptions);

		this.sortBy = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed({
			read: function read() {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSortBy();
			},
			write: function write(val) {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setSortBy(val);
			}
		});
		this.limit = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed({
			read: function read() {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getLimit();
			},
			write: function write(val) {
				var currLimit = _this7.limit();
				var newLimit = val;
				if (currLimit != newLimit) {
					logger.log('set limit', newLimit);
					var currPage = _this7.page();
					var newPage = Math.floor((currPage - 1) * currLimit / newLimit) + 1;
					__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setLimit(newLimit, newPage);
					_this7._onLimitChanged.fire(_this7.limit());
				}
			}
		});
		this.page = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed({
			read: function read() {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getPage();
			},
			write: function write(val) {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setPage(val);
			}
		});
		this.layout = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed({
			read: function read() {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getLayout();
			},
			write: function write(val) {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setLayout(val);
			}
		});
		this._totalCount = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(0).extend({ numeric: 0 });
		this.pagination = new Pagination();
		this._onLimitChanged = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();

		__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setDefaults(ViewOptions.defaults);

		this.pagination.onPageChanged(function (page) {
			_this7.page(page);
		});

		this.page.subscribe(function (val) {
			_this7.pagination.currentPage(val);
		});
		this.limit.subscribe(function (val) {
			_this7.pagination.perPageCount(val);
		});
	}

	_createClass(ViewOptions, [{
		key: 'init',
		value: function init(meta) {
			this._totalCount(meta.totalCount);
			this.pagination.itemsCount(meta.totalCount);
			this.pagination.currentPage(this.page());
			this.pagination.perPageCount(this.limit());
		}
	}, {
		key: 'setLayoutTile',
		value: function setLayoutTile() {
			this.layout('tile');
		}
	}, {
		key: 'setLayoutRow',
		value: function setLayoutRow() {
			this.layout('row');
		}
	}, {
		key: 'onPageChanged',
		value: function onPageChanged(callback) {
			this.pagination.onPageChanged(callback);
		}
	}, {
		key: 'onLimitChanged',
		value: function onLimitChanged(callback) {
			this._onLimitChanged.add(callback);
		}
	}, {
		key: 'totalCount',
		get: function get() {
			return this._totalCount();
		}
	}]);

	return ViewOptions;
}();

ViewOptions.defaults = {
	sort: '',
	limit: 60,
	page: 1,
	layout: 'tile'
};

var AdminPanel = function () {

	/**
  * @param {CProductList} productList
  */
	function AdminPanel(productList) {
		_classCallCheck(this, AdminPanel);

		this._isVisible = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);

		this._productList = productList;

		this.toggleVisibleState = this.toggleVisibleState.bind(this);
	}

	_createClass(AdminPanel, [{
		key: 'toggleVisibleState',
		value: function toggleVisibleState() {
			this._isVisible(!this._isVisible());
		}
	}, {
		key: 'selectAll',
		value: function selectAll() {
			this._productList.items.forEach(function (p) {
				p.isSelected = true;
			});
		}
	}, {
		key: 'unselectAll',
		value: function unselectAll() {
			this._productList.items.forEach(function (p) {
				p.isSelected = false;
			});
		}
	}, {
		key: 'deleteItems',
		value: function deleteItems() {
			var checkedItems = this._productList.checkedItems;
			if (checkedItems.length > 0) {
				__WEBPACK_IMPORTED_MODULE_16__core_widgets_loading__["a" /* default */].show();
				__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(__WEBPACK_IMPORTED_MODULE_7__core_utils_url__["g" /* siteUrl */]('shop/admin/deleteItems'), { ids: checkedItems.map(function (p) {
						return p.id;
					}) }, function (response) {
					__WEBPACK_IMPORTED_MODULE_16__core_widgets_loading__["a" /* default */].hide();
					if (response.success) {
						__WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__["a" /* Notifier */].success('Товары удалены, изменения вступят в силу после индексирования');
					} else {
						__WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__["a" /* Notifier */].error(response.error || null);
					}
				}, 'json');
			}
		}
	}, {
		key: 'restoreItems',
		value: function restoreItems() {
			var checkedItems = this._productList.checkedItems;
			if (checkedItems.length > 0) {
				__WEBPACK_IMPORTED_MODULE_16__core_widgets_loading__["a" /* default */].show();
				__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(__WEBPACK_IMPORTED_MODULE_7__core_utils_url__["g" /* siteUrl */]('shop/admin/restoreItems'), { ids: checkedItems.map(function (p) {
						return p.id;
					}) }, function (response) {
					__WEBPACK_IMPORTED_MODULE_16__core_widgets_loading__["a" /* default */].hide();
					if (response.success) {
						__WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__["a" /* Notifier */].success('Товары восстановлены, изменения вступят в силу после индексирования');
					} else {
						__WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__["a" /* Notifier */].error(response.error || null);
					}
				}, 'json');
			}
		}
	}, {
		key: 'changeCategory',
		value: function changeCategory() {
			var checkedItems = this._productList.checkedItems;
			if (checkedItems.length > 0) {
				__WEBPACK_IMPORTED_MODULE_17__core_modals__["MODAL_SELECT_SHOP_CATEGORY"].show(function (dialogResult) {
					if (dialogResult && dialogResult.categoryId) {
						__WEBPACK_IMPORTED_MODULE_16__core_widgets_loading__["a" /* default */].show();
						__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(__WEBPACK_IMPORTED_MODULE_7__core_utils_url__["g" /* siteUrl */]('shop/admin/changeCategory'), {
							ids: checkedItems.map(function (p) {
								return p.id;
							}),
							category_id: dialogResult.categoryId
						}, function (response) {
							__WEBPACK_IMPORTED_MODULE_16__core_widgets_loading__["a" /* default */].hide();
							if (response.success) {
								__WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__["a" /* Notifier */].success('Товары добавлены в категорию, изменения вступят в силу после индексирования');
							} else {
								__WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__["a" /* Notifier */].error(response.error || null);
							}
						}, 'json');
					}
				});
			} else {
				__WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__["a" /* Notifier */].warning('Не выбрано ни одного товара');
			}
		}
	}, {
		key: 'isVisible',
		get: function get() {
			return this._isVisible();
		}
	}]);

	return AdminPanel;
}();

var PageData = function () {
	function PageData() {
		_classCallCheck(this, PageData);

		this.breadcrumbs = new Breadcrumbs();
		this.searchFilter = new SearchFilter();
	}

	_createClass(PageData, [{
		key: 'init',
		value: function init() {
			this.breadcrumbs.init();
			this.searchFilter.init();
		}
	}, {
		key: 'update',
		value: function update(data) {
			if (data.title) {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()('head title').html(data.title);
			}

			if (data.breadcrumbs) {
				this.breadcrumbs.update(data.breadcrumbs);
				this.searchFilter.updateSearchResultsInput();
			}
		}
	}]);

	return PageData;
}();

var Breadcrumbs = function () {
	function Breadcrumbs() {
		_classCallCheck(this, Breadcrumbs);

		this.$wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#breadcrumbsWrapper');
	}

	_createClass(Breadcrumbs, [{
		key: 'init',
		value: function init() {
			this.$wrapper.on('click', '[itemprop=url]', function () {
				var href = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');
				var parts = href.split('/');
				if (parts[parts.length - 1] === 'shop') {
					// Navigate to main page
					window.location = href;
				} else {
					__WEBPACK_IMPORTED_MODULE_4__navigator__["router"].navigate(href, true);
				}
				return false;
			});
		}
	}, {
		key: 'update',
		value: function update(content) {
			if (content) {
				this.$wrapper.html(content);
			}
		}
	}]);

	return Breadcrumbs;
}();

var SearchFilter = function () {
	function SearchFilter() {
		_classCallCheck(this, SearchFilter);

		this.$breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#breadcrumbsWrapper');
		this.$searchPanel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchPanel');
	}

	_createClass(SearchFilter, [{
		key: 'init',
		value: function init() {
			var _this8 = this;

			this.updateSearchResultsInput();

			// handle search forms
			/*this.$searchPanel.on('submit', '[rel=search-form]', (function (e) {
   	e.preventDefault();
   	const value = $.trim($(this).find('[rel=search-input]').val());
   	nav.query.setSearch(value);
   }));*/
			this.$breadcrumbs.on('submit', '[rel=search-form]', function (e) {
				e.preventDefault();
				var value = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('[rel=search-input]').val());
				__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setSearchResults(value);
			});

			// update search form
			__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSearch();
			}).subscribe(function () {
				return _this8.updateSearchInput();
			});
			__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSearchResults();
			}).subscribe(function () {
				return _this8.updateSearchResultsInput();
			});
		}
	}, {
		key: 'updateSearchInput',
		value: function updateSearchInput() {
			this.$searchPanel.find('[rel=search-form]').find('[rel=search-input]').val(__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSearch());
		}
	}, {
		key: 'updateSearchResultsInput',
		value: function updateSearchResultsInput() {
			this.$breadcrumbs.find('[rel=search-form]').find('[rel=search-input]').val(__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSearchResults());
		}
	}]);

	return SearchFilter;
}();

var Pagination = function () {
	function Pagination() {
		var _this9 = this;

		_classCallCheck(this, Pagination);

		this.perPageCount = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(10);
		this.itemsCount = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(0);
		this.currentPage = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(1);
		this.size = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(3);
		this.pagesCount = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return Math.ceil(_this9.itemsCount() / _this9.perPageCount());
		});
		this._onPageChanged = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();
		this.items = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			var pagesCount = _this9.pagesCount();
			if (pagesCount <= 0) {
				return [];
			}

			var currentPage = _this9.currentPage();
			var size = _this9.size();
			var total = size * 2;
			if (pagesCount <= total + 1) {
				return __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["range"](1, pagesCount + 1).map(function (i) {
					return new PaginationItem(i, i == currentPage);
				});
			}

			var first = Math.max(1, currentPage - size);
			var last = first + total;
			if (last > pagesCount) {
				last = pagesCount;
				first = last - total;
			}

			return __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["range"](first, last + 1).map(function (i) {
				return new PaginationItem(i, i == currentPage);
			});
		});
		this.firstItem = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			var item = __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["first"](_this9.items());
			return item && item.number > 1 ? new PaginationItem(1) : null;
		});
		this.lastItem = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			var item = __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["last"](_this9.items());
			var pagesCount = _this9.pagesCount();
			return item && item.number < pagesCount ? new PaginationItem(pagesCount) : null;
		});

		this.handleClickItem = function (item) {
			_this9._onPageChanged.fire(item.number);
		};
	}
	// input parameters


	// computed parameters


	// events


	// output


	_createClass(Pagination, [{
		key: 'onPageChanged',
		value: function onPageChanged(callback) {
			this._onPageChanged.add(callback);
		}
	}]);

	return Pagination;
}();

var PaginationItem = function PaginationItem(number, active) {
	_classCallCheck(this, PaginationItem);

	this.number = number;
	this.active = active;
	this.url = __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getPageUrl(number);
};

/*
Filters
 */

var BaseFilterList = function (_List) {
	_inherits(BaseFilterList, _List);

	function BaseFilterList(data) {
		_classCallCheck(this, BaseFilterList);

		var _this10 = _possibleConstructorReturn(this, (BaseFilterList.__proto__ || Object.getPrototypeOf(BaseFilterList)).call(this, data));

		_this10._total = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(0);
		_this10._isFetching = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable();
		_this10._filterSubscription = null;
		_this10._isFiltered = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable();
		_this10._filterVisible = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);
		_this10._initialData = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable();
		_this10._currentCriteria = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable('');
		_this10._limit = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(10);
		_this10.criteria = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable('');

		_this10._total(data ? data['total'] : 0);
		_this10._filterRequest = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(_this10.criteria).extend({ rateLimit: { timeout: 500, method: "notifyWhenChangesStop" } });
		_this10._filterSubscription = _this10._filterRequest.subscribe(function (query) {
			_this10._fetchItems(query);
		});
		_this10._visibleLimitedItems = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["first"](_this10.visibleItems, _this10._limit());
		});
		return _this10;
	}

	/**
  * @return {number}
  */


	_createClass(BaseFilterList, [{
		key: 'filterPredicate',
		value: function filterPredicate(item) {
			return item.count > 0;
		}
	}, {
		key: 'init',
		value: function init(data) {
			this._filterVisible(null);
			_get(BaseFilterList.prototype.__proto__ || Object.getPrototypeOf(BaseFilterList.prototype), 'init', this).call(this, data);
			this._initialData(data);
			this.criteria('');
			this._currentCriteria('');
			this._isFetching(false);
			this._isFiltered(false);
		}
	}, {
		key: 'initData',
		value: function initData(data) {
			_get(BaseFilterList.prototype.__proto__ || Object.getPrototypeOf(BaseFilterList.prototype), 'initData', this).call(this, data);
			if (!__WEBPACK_IMPORTED_MODULE_3_lib_underscore__["isUndefined"](data['total'])) {
				this._total(data['total']);

				if (this._filterVisible() === null) {
					this._filterVisible(this.moreCount > 0);
				}
			}
		}
	}, {
		key: 'initItems',
		value: function initItems(itemsData) {
			// super.initItems(itemsData ? itemsData.slice(0, this.itemsLimit()) : []);
			_get(BaseFilterList.prototype.__proto__ || Object.getPrototypeOf(BaseFilterList.prototype), 'initItems', this).call(this, itemsData);
			if (!this._total()) {
				this._total(this.items.length);
			}
		}
	}, {
		key: 'showMore',
		value: function showMore() {
			this._limit(this._limit() + 10);
		}
	}, {
		key: 'resetFilter',
		value: function resetFilter() {
			this._restoreItems();
		}
	}, {
		key: '_fetchItems',
		value: function _fetchItems(criteria) {
			var _this11 = this;

			criteria = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim(criteria);

			if (criteria == this._currentCriteria()) {
				return;
			}

			logger.log("query " + this.name + ": " + criteria);

			if (!criteria) {
				this._restoreItems();
				return;
			}

			var data = {
				action: 'filter',
				f_name: this.name,
				f_criteria: criteria
			};

			var query = __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getQuery();

			var url = __WEBPACK_IMPORTED_MODULE_7__core_utils_url__["f" /* joinPath */](__WEBPACK_IMPORTED_MODULE_14__common_data__["b" /* settings */].catalogApiUrl, _extends({}, query, data));

			logger.log(url);

			this._currentCriteria(criteria);
			this._isFetching(true);
			__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(url, null, function (response) {
				logger.log("new data", response);
				_this11.initData(response);
				_this11._isFetching(false);
				_this11._isFiltered(true);
			}, 'json');
		}
	}, {
		key: '_restoreItems',
		value: function _restoreItems() {
			logger.log("Restore initial data");
			this.init(this._initialData());
		}
	}, {
		key: 'total',
		get: function get() {
			return this._total() - this.selectedItems.length;
		}

		/**
   * @return {boolean}
   */

	}, {
		key: 'isFetching',
		get: function get() {
			return this._isFetching();
		}

		/**
   * @return {boolean}
   */

	}, {
		key: 'isFiltered',
		get: function get() {
			return this._isFiltered();
		}
	}, {
		key: 'isVisible',
		get: function get() {
			return this.hasVisibleItems || this.total > 0 || this.isFilterVisible;
		}

		/**
   * @return {boolean}
   */

	}, {
		key: 'isFilterVisible',
		get: function get() {
			return this._filterVisible();
		}
	}, {
		key: 'filterSource',
		get: function get() {
			return _get(BaseFilterList.prototype.__proto__ || Object.getPrototypeOf(BaseFilterList.prototype), 'unselectedItems', this);
		}

		/**
   * @return {ListItem[]}
   */

	}, {
		key: 'visibleLimitedItems',
		get: function get() {
			return this._visibleLimitedItems();
		}

		/**
   * @return {number}
   */

	}, {
		key: 'moreCount',
		get: function get() {
			return this.total - this.visibleLimitedItems.length;
		}

		/**
   * @return {number}
   */

	}, {
		key: 'visibleCount',
		get: function get() {
			return this.visibleLimitedItems.length;
		}

		/**
   * @return {number}
   */

	}, {
		key: 'hiddenCount',
		get: function get() {
			return this.visibleItems.length - this.visibleLimitedItems.length;
		}
	}, {
		key: 'sortItems',
		get: function get() {
			return this.isFiltered ? false : _get(BaseFilterList.prototype.__proto__ || Object.getPrototypeOf(BaseFilterList.prototype), 'sortItems', this);
		}
	}]);

	return BaseFilterList;
}(__WEBPACK_IMPORTED_MODULE_9__common_model_lists__["b" /* List */]);

/*
Brands
 */

var BrandList = function (_BaseFilterList) {
	_inherits(BrandList, _BaseFilterList);

	function BrandList() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		_classCallCheck(this, BrandList);

		return _possibleConstructorReturn(this, (BrandList.__proto__ || Object.getPrototypeOf(BrandList)).call(this, _extends({ name: 'brand', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_brand') }, data)));
	}

	_createClass(BrandList, [{
		key: 'newItem',
		value: function newItem(itemData) {
			return new BrandItem(itemData);
		}
	}, {
		key: 'handleClick',
		value: function handleClick(item) {
			__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].toggleBrand(item.id);
		}
	}]);

	return BrandList;
}(BaseFilterList);

var BrandItem = function (_ListItem) {
	_inherits(BrandItem, _ListItem);

	function BrandItem(data) {
		_classCallCheck(this, BrandItem);

		var _this13 = _possibleConstructorReturn(this, (BrandItem.__proto__ || Object.getPrototypeOf(BrandItem)).call(this, data));

		_this13._selected = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getBrands().indexOf("" + _this13.id) >= 0;
		});
		return _this13;
	}

	_createClass(BrandItem, [{
		key: 'selected',
		get: function get() {
			return this._selected();
		}
	}]);

	return BrandItem;
}(__WEBPACK_IMPORTED_MODULE_9__common_model_lists__["c" /* ListItem */]);

/*
Shops
 */

var ShopList = function (_BaseFilterList2) {
	_inherits(ShopList, _BaseFilterList2);

	function ShopList() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		_classCallCheck(this, ShopList);

		return _possibleConstructorReturn(this, (ShopList.__proto__ || Object.getPrototypeOf(ShopList)).call(this, _extends({ name: 'shop', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_shop') }, data)));
	}

	_createClass(ShopList, [{
		key: 'newItem',
		value: function newItem(itemData) {
			return new ShopItem(itemData);
		}
	}, {
		key: 'handleClick',
		value: function handleClick(item) {
			__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].toggleShop(item.id);
		}
	}]);

	return ShopList;
}(BaseFilterList);

var ShopItem = function (_ListItem2) {
	_inherits(ShopItem, _ListItem2);

	function ShopItem(data) {
		_classCallCheck(this, ShopItem);

		var _this15 = _possibleConstructorReturn(this, (ShopItem.__proto__ || Object.getPrototypeOf(ShopItem)).call(this, data));

		_this15._selected = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getShops().indexOf("" + _this15.id) >= 0;
		});
		return _this15;
	}

	_createClass(ShopItem, [{
		key: 'selected',
		get: function get() {
			return this._selected();
		}
	}]);

	return ShopItem;
}(__WEBPACK_IMPORTED_MODULE_9__common_model_lists__["c" /* ListItem */]);

/*
Attributes
 */

var Attributes = function () {
	function Attributes() {
		_classCallCheck(this, Attributes);

		this._items = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observableArray([]).indexBy('id');
	}

	_createClass(Attributes, [{
		key: 'init',
		value: function init(data) {
			/** @var {AttrbuteList[]} */
			var items = __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["map"](data, function (itemData) {
				var list = new AttrbuteList(itemData);
				list.init(itemData);
				return list;
			});
			items = __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["sortBy"](items, function (list) {
				return list.order;
			});
			this._items(items);
		}

		/**
   * @return {AttrbuteList[]}
   */

	}, {
		key: 'items',
		get: function get() {
			return this._items();
		}
	}]);

	return Attributes;
}();

var AttrbuteList = function (_List2) {
	_inherits(AttrbuteList, _List2);

	function AttrbuteList() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		_classCallCheck(this, AttrbuteList);

		var _this16 = _possibleConstructorReturn(this, (AttrbuteList.__proto__ || Object.getPrototypeOf(AttrbuteList)).call(this, data));

		_this16._type = null;
		_this16._order = null;

		_this16._type = data ? data.type : null;
		_this16._order = data ? data.order : null;
		return _this16;
	}

	/**
  * @return {number}
  */


	_createClass(AttrbuteList, [{
		key: 'initData',
		value: function initData(data) {
			_get(AttrbuteList.prototype.__proto__ || Object.getPrototypeOf(AttrbuteList.prototype), 'initData', this).call(this, data);
			if (!__WEBPACK_IMPORTED_MODULE_3_lib_underscore__["isUndefined"](data['type'])) {
				this._type = data['type'];
			}
			if (!__WEBPACK_IMPORTED_MODULE_3_lib_underscore__["isUndefined"](data['order'])) {
				this._order = data['order'];
			}
		}
	}, {
		key: 'newItem',
		value: function newItem(itemData) {
			return new AttributeItem(itemData, this.name);
		}
	}, {
		key: 'handleClick',
		value: function handleClick(item) {
			__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].toggleAttribute(this.name, item.id);
		}
	}, {
		key: 'sortFunction',


		/**
   * @param {AttributeItem} item1
   * @param {AttributeItem} item2
   * @return {number}
   */
		value: function sortFunction(item1, item2) {
			if (item2.order == item1.order) {
				return _get(AttrbuteList.prototype.__proto__ || Object.getPrototypeOf(AttrbuteList.prototype), 'sortFunction', this).call(this, item1, item2);
			} else {
				return item1.order - item2.order;
			}
		}
	}, {
		key: 'order',
		get: function get() {
			return this._order;
		}
	}, {
		key: 'filterSource',
		get: function get() {
			return _get(AttrbuteList.prototype.__proto__ || Object.getPrototypeOf(AttrbuteList.prototype), 'unselectedItems', this);
		}
	}]);

	return AttrbuteList;
}(__WEBPACK_IMPORTED_MODULE_9__common_model_lists__["b" /* List */]);

var AttributeItem = function (_ListItem3) {
	_inherits(AttributeItem, _ListItem3);

	function AttributeItem(data, listName) {
		_classCallCheck(this, AttributeItem);

		var _this17 = _possibleConstructorReturn(this, (AttributeItem.__proto__ || Object.getPrototypeOf(AttributeItem)).call(this, data));

		_this17._order = data.order;
		_this17._listName = listName;
		_this17._selected = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			var index = __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getAttributeValues(listName).indexOf("" + _this17.id);
			return index >= 0;
		});
		return _this17;
	}

	_createClass(AttributeItem, [{
		key: 'order',
		get: function get() {
			return this._order;
		}
	}, {
		key: 'selected',
		get: function get() {
			return this._selected();
		}
	}, {
		key: 'hint',
		get: function get() {
			var formattedCount = __WEBPACK_IMPORTED_MODULE_2_lib_numeral___default()(this.count).format('0,0');
			var countText = __WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["b" /* pluralize */](this.count, Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_products_plural'), 'n', formattedCount);
			if (this._listName == 'color') {
				return this.title + ' (' + countText + ')';
			} else {
				return countText;
			}
		}
	}]);

	return AttributeItem;
}(__WEBPACK_IMPORTED_MODULE_9__common_model_lists__["c" /* ListItem */]);

/*
Selections
 */


var SelectionList = function () {
	function SelectionList() {
		var _this18 = this;

		_classCallCheck(this, SelectionList);

		this._itemsByType = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable({});
		this._items = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable([]);

		this._itemsByType = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["groupBy"](_this18._items(), function (item) {
				return item.type;
			});
		});

		this.handleClick = this.handleClick.bind(this);
		this.reset = this.reset.bind(this);
	}

	_createClass(SelectionList, [{
		key: 'getItemsOfType',
		value: function getItemsOfType(type) {
			return this._itemsByType()[type] || [];
		}
	}, {
		key: 'hasItemsOfType',
		value: function hasItemsOfType(type) {
			return this.getItemsOfType(type).length > 0;
		}
	}, {
		key: 'init',
		value: function init(data) {
			var _this19 = this;

			var items = __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["map"](data, function (d) {
				return _this19._newItem(d);
			});
			this._items(items);
		}

		/**
   * @param {SelectionItem} item
   */

	}, {
		key: 'handleClick',
		value: function handleClick(item) {
			item.deselect();
			this._removeItem(item);
		}
	}, {
		key: 'reset',
		value: function reset() {
			var _this20 = this;

			[].concat(_toConsumableArray(this.items)).forEach(function (item) {
				_this20.handleClick(item);
			});
		}
	}, {
		key: '_newItem',
		value: function _newItem(itemData) {
			switch (itemData.type) {
				case 'search':
					return new SearchSelectionItem(itemData);
				case 'search_results':
					return new SearchResultsSelectionItem(itemData);
				case 'price':
					return new PriceSelectionItem(itemData);
			}
			return new SelectionItem(itemData);
		}
	}, {
		key: '_removeItem',
		value: function _removeItem(item) {
			var items = this._items();
			var i = __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["indexOf"](items, item);
			if (i >= 0) {
				items.splice(i, 1);
			}
			this._items(items);
		}
	}, {
		key: 'items',
		get: function get() {
			return this._items();
		}
	}, {
		key: 'isEmpty',
		get: function get() {
			return this._items().length == 0;
		}
	}]);

	return SelectionList;
}();

var SelectionItem = function () {
	function SelectionItem(data) {
		_classCallCheck(this, SelectionItem);

		this._type = data ? data.type : null;
		this._id = data ? data.id : null;
		this._title = data ? data.title : null;
	}

	_createClass(SelectionItem, [{
		key: 'deselect',
		value: function deselect() {
			__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].toggleValue(this.type, this.id);
		}
	}, {
		key: 'type',
		get: function get() {
			return this._type;
		}
	}, {
		key: 'id',
		get: function get() {
			return this._id;
		}
	}, {
		key: 'title',
		get: function get() {
			return this._title;
		}
	}]);

	return SelectionItem;
}();

var SearchSelectionItem = function (_SelectionItem) {
	_inherits(SearchSelectionItem, _SelectionItem);

	function SearchSelectionItem() {
		_classCallCheck(this, SearchSelectionItem);

		return _possibleConstructorReturn(this, (SearchSelectionItem.__proto__ || Object.getPrototypeOf(SearchSelectionItem)).apply(this, arguments));
	}

	_createClass(SearchSelectionItem, [{
		key: 'deselect',
		value: function deselect() {
			__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setSearch(null);
		}
	}]);

	return SearchSelectionItem;
}(SelectionItem);

var SearchResultsSelectionItem = function (_SelectionItem2) {
	_inherits(SearchResultsSelectionItem, _SelectionItem2);

	function SearchResultsSelectionItem() {
		_classCallCheck(this, SearchResultsSelectionItem);

		return _possibleConstructorReturn(this, (SearchResultsSelectionItem.__proto__ || Object.getPrototypeOf(SearchResultsSelectionItem)).apply(this, arguments));
	}

	_createClass(SearchResultsSelectionItem, [{
		key: 'deselect',
		value: function deselect() {
			__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setSearchResults(null);
		}
	}]);

	return SearchResultsSelectionItem;
}(SelectionItem);

var PriceSelectionItem = function (_SelectionItem3) {
	_inherits(PriceSelectionItem, _SelectionItem3);

	function PriceSelectionItem(data) {
		_classCallCheck(this, PriceSelectionItem);

		var _this23 = _possibleConstructorReturn(this, (PriceSelectionItem.__proto__ || Object.getPrototypeOf(PriceSelectionItem)).call(this, data));

		_this23._min = data ? __WEBPACK_IMPORTED_MODULE_14__common_data__["b" /* settings */].convertPrice(data.min) : null;
		_this23._max = data ? __WEBPACK_IMPORTED_MODULE_14__common_data__["b" /* settings */].convertPrice(data.max) : null;
		return _this23;
	}

	_createClass(PriceSelectionItem, [{
		key: 'deselect',
		value: function deselect() {
			__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setMinPrice(null);
			__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setMaxPrice(null);
		}
	}, {
		key: 'title',
		get: function get() {
			if (this._min && this._max) {
				return __WEBPACK_IMPORTED_MODULE_2_lib_numeral___default()(this._min).format('0,0') + ' - ' + __WEBPACK_IMPORTED_MODULE_2_lib_numeral___default()(this._max).format('0,0 $');
			} else if (this._min) {
				return Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_price_from', { price: __WEBPACK_IMPORTED_MODULE_2_lib_numeral___default()(this._min).format('0,0 $') });
			} else if (this._max) {
				return Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_price_to', { price: __WEBPACK_IMPORTED_MODULE_2_lib_numeral___default()(this._max).format('0,0 $') });
			} else {
				return '';
			}
		}
	}]);

	return PriceSelectionItem;
}(SelectionItem);

/*
Price and discount
 */

var RangeFilter = function () {

	/**
  * @param {string} paramName Query parameter name. Will be prefixed with 'min_' and 'max_'
  * @param {string} type Slider type. 'integer' or 'double'
  */
	function RangeFilter(paramName, type) {
		var _this24 = this;

		_classCallCheck(this, RangeFilter);

		this.min = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(0);
		this.max = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(0);
		this.from = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed({
			read: function read() {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getQueryParam(_this24._minParamName);
			},
			write: function write(val) {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setQueryParam(_this24._minParamName, val);
			}
		});
		this.to = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed({
			read: function read() {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getQueryParam(_this24._maxParamName);
			},
			write: function write(val) {
				return __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setQueryParam(_this24._maxParamName, val);
			}
		});
		this.rangeSliderData = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			var min = _this24.min();
			var max = _this24.max();
			var from = _this24.from();
			var to = _this24.to();
			var step = 1; //Math.round((max-min)*0.01);
			return { min: min, max: max, from: from, to: to, step: step };
		});

		this._minParamName = 'min_' + paramName;
		this._maxParamName = 'max_' + paramName;
		this._type = type;
	}

	_createClass(RangeFilter, [{
		key: 'update',
		value: function update(data) {
			var _nav$query$setDefault;

			var min = Math.floor(data.min);
			var max = Math.ceil(data.max);

			__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setDefaults((_nav$query$setDefault = {}, _defineProperty(_nav$query$setDefault, this._minParamName, min), _defineProperty(_nav$query$setDefault, this._maxParamName, max), _nav$query$setDefault));

			this.min(min);
			this.max(max);
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.from(this.min());
			this.to(this.max());
		}
	}, {
		key: 'rangeSliderOptions',
		get: function get() {
			var _this25 = this;

			return {
				type: this._type,
				min_interval: 1,
				force_edges: true,
				onFinish: function onFinish(data) {
					_this25.from(data.from);
					_this25.to(data.to);
				}
			};
		}
	}, {
		key: 'isVisible',
		get: function get() {
			return this.max() > this.min();
		}
	}, {
		key: 'isSelected',
		get: function get() {
			return this.from() > this.min() || this.to() < this.max();
		}
	}]);

	return RangeFilter;
}();

var PriceRangeFilter = function (_RangeFilter) {
	_inherits(PriceRangeFilter, _RangeFilter);

	function PriceRangeFilter() {
		_classCallCheck(this, PriceRangeFilter);

		return _possibleConstructorReturn(this, (PriceRangeFilter.__proto__ || Object.getPrototypeOf(PriceRangeFilter)).call(this, 'price', 'double'));
	}

	_createClass(PriceRangeFilter, [{
		key: 'rangeSliderOptions',
		get: function get() {
			return _extends({}, _get(PriceRangeFilter.prototype.__proto__ || Object.getPrototypeOf(PriceRangeFilter.prototype), 'rangeSliderOptions', this), {
				prettify_enabled: true,
				prettify: function prettify(value) {
					return __WEBPACK_IMPORTED_MODULE_2_lib_numeral___default()(__WEBPACK_IMPORTED_MODULE_14__common_data__["b" /* settings */].convertPrice(value)).format('0,0');
				}
			});
		}
	}]);

	return PriceRangeFilter;
}(RangeFilter);

var DiscountRangeFilter = function (_RangeFilter2) {
	_inherits(DiscountRangeFilter, _RangeFilter2);

	function DiscountRangeFilter() {
		_classCallCheck(this, DiscountRangeFilter);

		return _possibleConstructorReturn(this, (DiscountRangeFilter.__proto__ || Object.getPrototypeOf(DiscountRangeFilter)).call(this, 'discount', 'integer'));
	}

	return DiscountRangeFilter;
}(RangeFilter);

/*
Other filters
 */

var BaseOptionFilter = function () {
	function BaseOptionFilter(name) {
		var _this28 = this;

		var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

		_classCallCheck(this, BaseOptionFilter);

		this.value = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed({
			read: function read() {
				var val = __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getQueryParam(_this28._name);
				return val !== '' ? val : undefined;
			},
			write: function write(val) {
				__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setQueryParam(_this28._name, val !== undefined ? val : '');
			}
		});
		this._visibleKeys = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable();

		this._name = name;

		__WEBPACK_IMPORTED_MODULE_4__navigator__["query"].setDefaults(_defineProperty({}, name, defaultValue));

		this._visibleOptions = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			/** @type string[] */
			var visibleKeys = _this28.visibleKeys;
			if (visibleKeys) {
				return __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["filter"](_this28.options, function (o) {
					return visibleKeys.indexOf(o.key) >= 0;
				});
			} else {
				return _this28.options;
			}
		});
	}

	_createClass(BaseOptionFilter, [{
		key: 'update',
		value: function update(data) {
			this._visibleKeys(data.keys);
		}
	}, {
		key: 'name',
		get: function get() {
			return this._name;
		}
	}, {
		key: 'options',
		get: function get() {
			return [];
		}
	}, {
		key: 'visibleKeys',
		get: function get() {
			return this._visibleKeys();
		}
	}, {
		key: 'visibleOptions',
		get: function get() {
			return this._visibleOptions();
		}
	}, {
		key: 'caption',
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_not_selected');
		}
	}]);

	return BaseOptionFilter;
}();

var LastUpdateFilter = function (_BaseOptionFilter) {
	_inherits(LastUpdateFilter, _BaseOptionFilter);

	function LastUpdateFilter() {
		_classCallCheck(this, LastUpdateFilter);

		return _possibleConstructorReturn(this, (LastUpdateFilter.__proto__ || Object.getPrototypeOf(LastUpdateFilter)).call(this, 'last_update'));
	}

	_createClass(LastUpdateFilter, [{
		key: 'update',
		value: function update(data) {
			var now = new Date().getTime();
			var items = __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["filter"](this.options, function (o) {
				var itemHours = now - o.key * 60 * 60 * 1000;
				return itemHours <= data.max;
			});
			var keys = __WEBPACK_IMPORTED_MODULE_3_lib_underscore__["map"](items, function (item) {
				return item.key;
			});
			_get(LastUpdateFilter.prototype.__proto__ || Object.getPrototypeOf(LastUpdateFilter.prototype), 'update', this).call(this, { keys: keys });
		}
	}, {
		key: 'options',
		get: function get() {
			return [{ key: '336', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_last_update_option_2_weeks') }, { key: '168', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_last_update_option_1_week') }, { key: '72', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_last_update_option_3_days') }, { key: '24', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_last_update_option_1_day') }];
		}
	}]);

	return LastUpdateFilter;
}(BaseOptionFilter);

var AvailabilityFilter = function (_BaseOptionFilter2) {
	_inherits(AvailabilityFilter, _BaseOptionFilter2);

	function AvailabilityFilter() {
		_classCallCheck(this, AvailabilityFilter);

		return _possibleConstructorReturn(this, (AvailabilityFilter.__proto__ || Object.getPrototypeOf(AvailabilityFilter)).call(this, 'availability'));
	}

	_createClass(AvailabilityFilter, [{
		key: 'options',
		get: function get() {
			return [{ key: 'yes', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_availability_option_yes') }, { key: 'likely', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_availability_option_likely') }];
		}
	}]);

	return AvailabilityFilter;
}(BaseOptionFilter);

var DiscountFilter = function (_BaseOptionFilter3) {
	_inherits(DiscountFilter, _BaseOptionFilter3);

	function DiscountFilter() {
		_classCallCheck(this, DiscountFilter);

		return _possibleConstructorReturn(this, (DiscountFilter.__proto__ || Object.getPrototypeOf(DiscountFilter)).call(this, 'discount'));
	}

	_createClass(DiscountFilter, [{
		key: 'options',
		get: function get() {
			return [{ key: 'yes', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_discount_option_yes') }, { key: 'no', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_filter_discount_option_no') }];
		}

		/*update(data) {
  	const keys = [];
  	if (data.min == 0) {
  		keys.push("no");
  	}
  	if (data.max > 0) {
  		keys.push("yes");
  	}
  	super.update({keys});
  }*/

	}]);

	return DiscountFilter;
}(BaseOptionFilter);

/*
Products
 */

var CProductList = function (_ProductList) {
	_inherits(CProductList, _ProductList);

	/**
  * @param {Settings} settings
  * @param {Sidebar} sidebar
  */
	function CProductList(settings, sidebar) {
		_classCallCheck(this, CProductList);

		var _this32 = _possibleConstructorReturn(this, (CProductList.__proto__ || Object.getPrototypeOf(CProductList)).call(this, settings));

		_this32._sidebar = sidebar;

		_this32._selectedProducts = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			return _this32.items.filter(function (p) {
				return p.isSelected;
			});
		});
		return _this32;
	}

	_createClass(CProductList, [{
		key: 'newItem',
		value: function newItem(itemData) {
			if (itemData['brandId']) {
				itemData['brand'] = this._sidebar.brands.getItem(itemData['brandId']);
			}
			if (itemData['subcategoryId']) {
				itemData['subcategory'] = this._sidebar.categories.getAnyItem(itemData['subcategoryId']);
			}
			return new CProductItem(itemData, this.settings);
		}

		/** @return {CProductItem[]} */

	}, {
		key: '__init',
		value: function __init(data) {
			if (__WEBPACK_IMPORTED_MODULE_14__common_data__["b" /* settings */].isAdmin && !__WEBPACK_IMPORTED_MODULE_3_lib_underscore__["isEmpty"](data['scores'])) {
				data['items'].forEach(function (item) {
					item['score'] = data['scores'][item['id']];
				});
			}

			_get(CProductList.prototype.__proto__ || Object.getPrototypeOf(CProductList.prototype), 'init', this).call(this, data);
		}
	}, {
		key: 'items',
		get: function get() {
			return _get(CProductList.prototype.__proto__ || Object.getPrototypeOf(CProductList.prototype), 'items', this);
		}

		/** @return {CProductItem[]} */

	}, {
		key: 'checkedItems',
		get: function get() {
			return _get(CProductList.prototype.__proto__ || Object.getPrototypeOf(CProductList.prototype), 'items', this).filter(function (p) {
				return p.isSelected;
			});
		}
	}]);

	return CProductList;
}(__WEBPACK_IMPORTED_MODULE_11__common_model_products__["b" /* ProductList */]);

var CProductItem = function (_ProductItem) {
	_inherits(CProductItem, _ProductItem);

	/**
  * @param {object} data
  * @param {Settings} settings
  */
	function CProductItem(data, settings) {
		_classCallCheck(this, CProductItem);

		var _this33 = _possibleConstructorReturn(this, (CProductItem.__proto__ || Object.getPrototypeOf(CProductItem)).call(this, data, settings));

		_this33._isSelected = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);

		_this33.brand = data.brand;
		_this33.subcategory = data.subcategory;
		if (!settings.useOfferUrl) {
			_this33._setUrl(data);
		}
		_this33.score = data.score;
		return _this33;
	}

	_createClass(CProductItem, [{
		key: 'toggleSelectState',
		value: function toggleSelectState() {
			this._isSelected(!this._isSelected());
		}
	}, {
		key: 'toggleFavorite',
		value: function toggleFavorite() {
			var _this34 = this;

			var state = this._favorite();
			this._favorite(!state);
			var url = state ? 'favorites/removeProduct/' : 'favorites/addProduct/';
			__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(__WEBPACK_IMPORTED_MODULE_7__core_utils_url__["g" /* siteUrl */](url + this.id)).done(function () {
				if (state) {
					__WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__["a" /* Notifier */].info('Товар удален из избранного');
				} else {
					__WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__["a" /* Notifier */].info('Товар добавлен в избранное');
				}
			}).fail(function () {
				// revert visual state
				_this34._favorite(state);
				__WEBPACK_IMPORTED_MODULE_15__core_widgets_notifier__["a" /* Notifier */].error('Ошибка при добавлении в избранное');
			});
		}
	}, {
		key: '_setUrl',
		value: function _setUrl(data) {
			var category = __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getCategory();
			var subcategory = __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSubcategory();
			var search = __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSearch();
			var search_results = __WEBPACK_IMPORTED_MODULE_4__navigator__["query"].getSearchResults();

			// override product url according to user navigation in catalog
			if (category || subcategory) {
				this.url = __WEBPACK_IMPORTED_MODULE_7__core_utils_url__["f" /* joinPath */](__WEBPACK_IMPORTED_MODULE_14__common_data__["b" /* settings */].shopUrl, category, subcategory, data.name);
			}
			if (search || search_results) {
				this.url = __WEBPACK_IMPORTED_MODULE_7__core_utils_url__["f" /* joinPath */](this.url, search ? { search: search } : null, search_results ? { search_results: search_results } : null);
			}
		}
	}, {
		key: 'isCheckboxVisible',
		get: function get() {
			return __WEBPACK_IMPORTED_MODULE_14__common_data__["b" /* settings */].isAdmin;
		}
	}, {
		key: 'isFavoritesVisible',
		get: function get() {
			return __WEBPACK_IMPORTED_MODULE_14__common_data__["b" /* settings */].useFavorites;
		}
	}, {
		key: 'isSelected',
		get: function get() {
			return this._isSelected();
		},
		set: function set(value) {
			this._isSelected(!!value);
		}
	}]);

	return CProductItem;
}(__WEBPACK_IMPORTED_MODULE_11__common_model_products__["a" /* ProductItem */]);

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('shop-catalog', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params.model;
		}
	},
	template: __webpack_require__("ER90")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('catalog-sidebar', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params.sidebar;
		}
	},
	template: __webpack_require__("REJB")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('filter-block', {
	viewModel: function viewModel(params) {
		this.title = params.title;
		this.data = params.data;
	},
	template: __webpack_require__("LakT")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('list-filter', {
	viewModel: function viewModel(params) {
		this.list = params.list;
	},
	template: __webpack_require__("RD2g")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('attribute-filter', {
	viewModel: function viewModel(params) {
		this.list = params.list;
	},
	template: __webpack_require__("szBx")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('category-filter', {
	viewModel: function viewModel(params) {
		this.list = params.list;
	},
	template: __webpack_require__("plkG")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('dropdown-filter', {
	viewModel: function viewModel(params) {
		this.filter = params.filter;
	},
	template: __webpack_require__("BY5J")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('range-filter', {
	viewModel: function viewModel(params) {
		this.filter = params.filter;
	},
	template: __webpack_require__("voxd")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('selection-items', {
	viewModel: function viewModel(params) {
		/** @type {SelectionList} */
		var model = params.model;
		this.selection = params.model;
		this.type = params.type;
		this.items = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.computed(function () {
			return params.type ? model.getItemsOfType(__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.unwrap(params.type)) : model.items;
		});
		this.showReset = Object(__WEBPACK_IMPORTED_MODULE_13__core_utils_var__["e" /* element */])(params, 'showReset', false);
	},
	template: __webpack_require__("FBgD")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('catalog-title', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params.model;
		}
	},
	template: __webpack_require__("HQ4p")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('active-filters', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params.model;
		}
	},
	template: __webpack_require__("zB9m")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('view-options', {
	viewModel: function viewModel(params) {
		var _this35 = this;

		/** @type {ViewOptions} */
		this.model = params.model;
		this.sortTypes = [{ key: '', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_sorting_option_default') }, { key: 'date', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_sorting_option_date') }, { key: 'discount', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_sorting_option_discount') }, { key: 'price_asc', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_sorting_option_price_asc') }, { key: 'price_desc', title: Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_sorting_option_price_desc') }];
		this.limitValues = [30, 60, 90];

		this.showCountInfo = Object(__WEBPACK_IMPORTED_MODULE_13__core_utils_var__["e" /* element */])(params, 'showCountInfo', true);
		this.showPageInfo = Object(__WEBPACK_IMPORTED_MODULE_13__core_utils_var__["e" /* element */])(params, 'showPageInfo', true);
		this.showPagination = Object(__WEBPACK_IMPORTED_MODULE_13__core_utils_var__["e" /* element */])(params, 'showPagination', false);
		this.showSorting = Object(__WEBPACK_IMPORTED_MODULE_13__core_utils_var__["e" /* element */])(params, 'showSorting', true);
		this.showLimit = Object(__WEBPACK_IMPORTED_MODULE_13__core_utils_var__["e" /* element */])(params, 'showLimit', true);

		this.productsPluralText = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.pureComputed(function () {
			var count = _this35.model.totalCount;
			var formattedCount = __WEBPACK_IMPORTED_MODULE_2_lib_numeral___default()(count).format('0,0');
			return __WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["b" /* pluralize */](count, Object(__WEBPACK_IMPORTED_MODULE_12__core_utils_lang__["a" /* lang */])('shop_products_plural'), 'n', formattedCount);
		});
	},
	template: __webpack_require__("WO1x")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('admin-panel', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params.model;
		}
	},
	template: __webpack_require__("FttF")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('product-list', {
	viewModel: function viewModel(params) {
		this.list = params.list;
	},
	template: __webpack_require__("wD1/")
});

__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.components.register('product-list-item', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params.product;
		}
	},
	template: __webpack_require__("e7VL")
});



/***/ }),

/***/ "voxd":
/***/ (function(module, exports) {

module.exports = "<!-- ko with: filter -->\n<input data-bind=\"ionRangeSlider: {options: rangeSliderOptions, data: rangeSliderData}\"/>\n<div data-bind=\"visible: isSelected\">\n\t<a data-bind=\"click: reset, lang: 'btn_reset'\"></a>\n</div>\n<!-- /ko -->"

/***/ }),

/***/ "wD1/":
/***/ (function(module, exports) {

module.exports = "<!-- ko foreach: list.items -->\n<product-list-item params=\"product: $data\" data-bind=\"css: {selected: isSelected, favorite: isFavorite}\"></product-list-item>\n<!-- /ko -->"

/***/ }),

/***/ "wEGv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zB9m":
/***/ (function(module, exports) {

module.exports = "<ul class=\"active-filters-list tags-list\">\n\t<!-- ko foreach: items -->\n\t<li class=\"tag\" data-bind=\"click: $parent.handleClick, attr: {title: zde.lang('shop_filter_btn_cancel')}\">\n\t\t<span data-bind=\"text: title\"></span>\n\t\t<i class=\"icon--delete\"></i>\n\t</li>\n\t<!-- /ko -->\n\t<li class=\"tag tag-reset\" data-bind=\"click: reset, attr: {title: zde.lang('shop_filter_btn_cancel_all')}\">\n\t\t<span data-bind=\"lang: 'btn_reset'\"></span>\n\t</li>\n</ul>"

/***/ })

},[7]);


// WEBPACK FOOTER //
// shop_catalog.min.js